import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  JSON: { input: any; output: any };
};

export type AccessToken = {
  __typename?: 'AccessToken';
  accessTokenId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  expiresAt?: Maybe<Scalars['Date']['output']>;
  lastUsedAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  preview?: Maybe<Scalars['String']['output']>;
};

export type AccessTokenPreview = {
  __typename?: 'AccessTokenPreview';
  accessToken: AccessToken;
  token: Scalars['String']['output'];
};

export type Account = {
  __typename?: 'Account';
  accessTokens: Array<AccessToken>;
  accountId: Scalars['ID']['output'];
  agentSkill?: Maybe<AgentSkill>;
  agentSkills: Array<AgentSkill>;
  aiBusinessConcepts?: Maybe<Scalars['String']['output']>;
  aiQueryHistory: Array<AiQueryThread>;
  aiSystemInstructions: Array<AiSystemInstruction>;
  aiUsageLimits: AiUsageLimits;
  alertConfiguration?: Maybe<AlertConfiguration>;
  alertConfigurations: Array<AlertConfiguration>;
  analyticsEvents: Array<AnalyticsEvent>;
  answerGuidance: Array<AnswerGuidance>;
  ask: ConversationResponse;
  confluencePairingState: ConfluencePairingState;
  connections: Array<Connection>;
  conversation: Conversation;
  describeQuery: DescribeQueryResponse;
  discoverEnumOptions: DiscoverEnumOptionsResult;
  discoverModels: DiscoverModelsResult;
  discoverSchemas: DiscoverSchemasResult;
  exploration?: Maybe<Exploration>;
  /**
   * The requesting user's recent exploration activity: one entry per
   * workstream per day, newest first. Contains only the user's own edits.
   * Day grouping uses the given IANA time zone, defaulting to the account
   * time zone.
   */
  explorationHistory: Array<ExplorationHistoryEntry>;
  /**
   * A single history entry by id. The days and timeZone arguments must match
   * the ones used for the explorationHistory list the entry came from.
   */
  explorationHistoryEntry?: Maybe<ExplorationHistoryEntry>;
  explorationMetadata: Array<ExplorationMetadata>;
  explorationSearch: Array<ExplorationData>;
  explorationState?: Maybe<ExplorationState>;
  explorations: Array<Exploration>;
  exportConfiguration: Scalars['String']['output'];
  features?: Maybe<Scalars['JSON']['output']>;
  inboxItemCount: Scalars['Int']['output'];
  inboxItems: Array<InboxItem>;
  integrations: Array<Integration>;
  isOnboarded: Scalars['Boolean']['output'];
  isSsoRequired: Scalars['Boolean']['output'];
  me: AccountUser;
  metrics: Array<Metric>;
  model?: Maybe<Model>;
  models: Array<Model>;
  name: Scalars['String']['output'];
  navigation: Array<NavigationItem>;
  onboardingState: OnboardingState;
  /** @deprecated Use explorationMetadata instead. */
  parameterisedExplorations: Array<Exploration>;
  pinnedExplorationIds: Array<Scalars['String']['output']>;
  query: QueryResponseConnection;
  queryExplorationCell: QueryResponseConnection;
  serviceUsers: Array<ServiceUser>;
  slackChannels: Array<SlackChannel>;
  slug: Scalars['String']['output'];
  ssoProviderId?: Maybe<Scalars['String']['output']>;
  testConnection: TestConnectionResult;
  timezone?: Maybe<Scalars['String']['output']>;
  userGroups: Array<UserGroup>;
  users: Array<AccountUser>;
  /**
   * Validates an exploration against the account's stored models and metrics, compiling
   * each pipeline to surface PRQL errors. modelsInput and metricsInput are deprecated
   * and ignored; they are accepted for backwards compatibility with older clients.
   */
  validateExploration: Scalars['JSON']['output'];
};

export type AccountAgentSkillArgs = {
  agentSkillId: Scalars['ID']['input'];
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountAgentSkillsArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountAlertConfigurationArgs = {
  alertConfigurationId: Scalars['ID']['input'];
};

export type AccountAskArgs = {
  conversation: ConversationInput;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  exploration?: InputMaybe<ExplorationInput>;
  selectors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type AccountConfluencePairingStateArgs = {
  code: Scalars['String']['input'];
};

export type AccountConversationArgs = {
  conversationId: Scalars['ID']['input'];
};

export type AccountDescribeQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  baseModelId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<QueryOptionsInput>;
  pipeline: Array<OperationInput>;
  sort?: InputMaybe<Array<QuerySortBy>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type AccountDiscoverEnumOptionsArgs = {
  input: DiscoverEnumOptionsInput;
};

export type AccountDiscoverModelsArgs = {
  input?: InputMaybe<DiscoverModelsInput>;
};

export type AccountDiscoverSchemasArgs = {
  input?: InputMaybe<DiscoverSchemasInput>;
};

export type AccountExplorationArgs = {
  explorationId: Scalars['ID']['input'];
};

export type AccountExplorationHistoryArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type AccountExplorationHistoryEntryArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  entryId: Scalars['ID']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type AccountExplorationSearchArgs = {
  search: Scalars['String']['input'];
};

export type AccountExplorationStateArgs = {
  explorationId: Scalars['ID']['input'];
};

export type AccountExportConfigurationArgs = {
  agentSkillIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  explorationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeAiInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  metricIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  modelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AccountModelArgs = {
  modelId: Scalars['ID']['input'];
};

export type AccountModelsArgs = {
  connectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type AccountQueryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  baseModelId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<QueryOptionsInput>;
  pipeline: Array<OperationInput>;
  sort?: InputMaybe<Array<QuerySortBy>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type AccountQueryExplorationCellArgs = {
  input: ExplorationCellQueryInput;
};

export type AccountSlackChannelsArgs = {
  integrationId: Scalars['ID']['input'];
};

export type AccountTestConnectionArgs = {
  properties: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type AccountValidateExplorationArgs = {
  exploration: Scalars['JSON']['input'];
  metricsInput?: InputMaybe<Scalars['JSON']['input']>;
  modelsInput?: InputMaybe<Scalars['JSON']['input']>;
  variablesInput?: InputMaybe<Scalars['JSON']['input']>;
};

export type AccountUser = {
  __typename?: 'AccountUser';
  addedAt: Scalars['Date']['output'];
  authorizedClients: Array<AuthorizedClient>;
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  permissions: Array<Permission>;
  pinnedExplorationIds: Array<Scalars['String']['output']>;
  role: Role;
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['ID']['output'];
};

export type AccountUserChangeResponse = {
  __typename?: 'AccountUserChangeResponse';
  account: Account;
  accountUser: AccountUser;
};

export type AccountUserDeleteResponse = {
  __typename?: 'AccountUserDeleteResponse';
  account: Account;
  accountUser: AccountUser;
  success: Scalars['Boolean']['output'];
};

export type AgentInboxChangesInput = {
  addNew?: InputMaybe<Array<AgentInboxNewItemInput>>;
  confirmExisting?: InputMaybe<Array<Scalars['ID']['input']>>;
  conversation: AgentInboxConversationInput;
  deleteExisting?: InputMaybe<Array<AgentInboxDeleteItemInput>>;
  updateExisting?: InputMaybe<Array<AgentInboxUpdateItemInput>>;
};

export type AgentInboxConversationInput = {
  askedAt?: InputMaybe<Scalars['Date']['input']>;
  conversationId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AgentInboxDeleteItemInput = {
  inboxItemId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type AgentInboxNewItemInput = {
  details: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AgentInboxOpenItem = {
  __typename?: 'AgentInboxOpenItem';
  details: Scalars['String']['output'];
  dismissalReason?: Maybe<Scalars['String']['output']>;
  inboxItemId: Scalars['ID']['output'];
  status: InboxItemStatus;
  title: Scalars['String']['output'];
};

export type AgentInboxUpdateItemInput = {
  details: Scalars['String']['input'];
  inboxItemId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type AgentSkill = {
  __typename?: 'AgentSkill';
  access?: Maybe<Scalars['JSON']['output']>;
  agentSkillId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  instructions: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AgentSkillInput = {
  access?: InputMaybe<Scalars['JSON']['input']>;
  agentSkillId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  instructions: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type AiQuery = {
  __typename?: 'AiQuery';
  correlationId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  message: Scalars['String']['output'];
  resultUrl?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Array<Scalars['String']['output']>>;
};

export type AiQueryThread = {
  __typename?: 'AiQueryThread';
  queries: Array<AiQuery>;
  threadId: Scalars['ID']['output'];
};

export type AiSystemInstruction = {
  __typename?: 'AiSystemInstruction';
  aiSystemInstructionId: Scalars['ID']['output'];
  connectionId?: Maybe<Scalars['ID']['output']>;
  instructions: Scalars['String']['output'];
  integrationId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
};

export type AiUsageLimits = {
  __typename?: 'AiUsageLimits';
  account: AiUsageLimitsConfig;
  defaults: AiUsageLimitsConfig;
  user: AiUsageLimitsConfig;
};

export type AiUsageLimitsConfig = {
  __typename?: 'AiUsageLimitsConfig';
  costUsdPerDay?: Maybe<Scalars['Float']['output']>;
  costUsdPerMonth?: Maybe<Scalars['Float']['output']>;
  costUsdPerQuestion?: Maybe<Scalars['Float']['output']>;
  costUsdPerQuestionResearch?: Maybe<Scalars['Float']['output']>;
  questionsPerDay?: Maybe<Scalars['Int']['output']>;
  questionsPerMonth?: Maybe<Scalars['Int']['output']>;
};

export type AiUsageLimitsConfigInput = {
  costUsdPerDay?: InputMaybe<Scalars['Float']['input']>;
  costUsdPerMonth?: InputMaybe<Scalars['Float']['input']>;
  costUsdPerQuestion?: InputMaybe<Scalars['Float']['input']>;
  costUsdPerQuestionResearch?: InputMaybe<Scalars['Float']['input']>;
  questionsPerDay?: InputMaybe<Scalars['Int']['input']>;
  questionsPerMonth?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertConfiguration = {
  __typename?: 'AlertConfiguration';
  accountId: Scalars['ID']['output'];
  alertConfigurationId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  excludedFields: Array<Scalars['String']['output']>;
  keyFields: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notificationConfig: Scalars['JSON']['output'];
  pipeline: Scalars['JSON']['output'];
};

export type AlertConfigurationInput = {
  alertConfigurationId?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  excludedFields?: InputMaybe<Array<Scalars['String']['input']>>;
  keyFields: Array<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notificationConfig: Scalars['JSON']['input'];
  pipeline: Scalars['JSON']['input'];
};

export type AnalyticsEvent = {
  __typename?: 'AnalyticsEvent';
  analyticsEventId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  properties: Scalars['JSON']['output'];
};

export type AnswerGuidance = {
  __typename?: 'AnswerGuidance';
  createdAt: Scalars['Date']['output'];
  exploration?: Maybe<Scalars['JSON']['output']>;
  guidance?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  sourceScope: Array<AnswerGuidanceSource>;
  updatedAt: Scalars['Date']['output'];
};

export type AnswerGuidanceInput = {
  exploration?: InputMaybe<ExplorationInput>;
  guidance?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  question: Scalars['String']['input'];
  sourceScope: Array<AnswerGuidanceSourceInput>;
};

export type AnswerGuidanceSource = {
  __typename?: 'AnswerGuidanceSource';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type AnswerGuidanceSourceInput = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type AuthorizedClient = {
  __typename?: 'AuthorizedClient';
  authorizedAt: Scalars['Date']['output'];
  clientName: Scalars['String']['output'];
  grantId: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['Date']['output']>;
  logoUri?: Maybe<Scalars['String']['output']>;
  redirectHost: Scalars['String']['output'];
  scopes: Array<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type CellKindCount = {
  __typename?: 'CellKindCount';
  count: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
};

export type ChatCellMessage = {
  __typename?: 'ChatCellMessage';
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  role: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ChatViewCell = {
  __typename?: 'ChatViewCell';
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  messages: Array<ChatCellMessage>;
  viewOptions?: Maybe<Scalars['JSON']['output']>;
};

export type CohortViewCell = {
  __typename?: 'CohortViewCell';
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  pipeline: QueryPipeline;
  title?: Maybe<Scalars['String']['output']>;
  viewOptions?: Maybe<Scalars['JSON']['output']>;
};

export type ConfigurationImportResult = {
  __typename?: 'ConfigurationImportResult';
  deletedObjects?: Maybe<DeletedDanglingObjects>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  explorationCount?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type ConfigurationValidationResult = {
  __typename?: 'ConfigurationValidationResult';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type ConfluencePairingRequest = {
  __typename?: 'ConfluencePairingRequest';
  code: Scalars['String']['output'];
  expiresAt: Scalars['Date']['output'];
};

export type ConfluencePairingState = {
  __typename?: 'ConfluencePairingState';
  integrationId?: Maybe<Scalars['ID']['output']>;
  status: ConfluencePairingStatus;
};

export enum ConfluencePairingStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  NotFound = 'NOT_FOUND',
  Pending = 'PENDING',
}

export type Connection = {
  __typename?: 'Connection';
  connectionId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  properties: ConnectionProperties;
  type: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ConnectionProperties = {
  __typename?: 'ConnectionProperties';
  /**
   * Connection (statement) timeout in milliseconds. Null when the connection type doesn't support it
   * or no override is set, in which case the default timeout applies.
   */
  connectionTimeout?: Maybe<Scalars['Int']['output']>;
  /**
   * Maximum amount of data a query may process, in bytes. Null when the connection type doesn't
   * support it or no limit is set.
   */
  maximumDataProcessedBytes?: Maybe<Scalars['Float']['output']>;
};

export type ConsentInput = {
  subjects: Array<Scalars['String']['input']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  conversationId: Scalars['ID']['output'];
  jobs: Array<ConversationJob>;
  messages: Array<ConversationMessage>;
};

export type ConversationExplorationMessage = {
  __typename?: 'ConversationExplorationMessage';
  exploration: ExplorationData;
  id: Scalars['String']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  role: ConversationMessageRole;
  type: ConversationMessageType;
};

export type ConversationInput = {
  conversationId: Scalars['String']['input'];
  messages: Array<ConversationMessageInput>;
};

export type ConversationJob = {
  __typename?: 'ConversationJob';
  channel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  jobId: Scalars['ID']['output'];
  parentJobId?: Maybe<Scalars['ID']['output']>;
  progress?: Maybe<Array<Maybe<ConversationJobProgress>>>;
};

export type ConversationJobProgress = {
  __typename?: 'ConversationJobProgress';
  createdAt: Scalars['String']['output'];
  jobId: Scalars['ID']['output'];
  jobProgressId: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
};

export type ConversationMessage = ConversationExplorationMessage | ConversationTextMessage;

export type ConversationMessageInput = {
  enabledSources?: InputMaybe<Scalars['JSON']['input']>;
  exploration?: InputMaybe<ExplorationInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  research?: InputMaybe<Scalars['Boolean']['input']>;
  role: ConversationMessageRole;
  type: ConversationMessageType;
};

export enum ConversationMessageRole {
  Assistant = 'assistant',
  User = 'user',
}

export enum ConversationMessageType {
  ClarifyingAnswer = 'clarifying_answer',
  ClarifyingQuestion = 'clarifying_question',
  Exploration = 'exploration',
  FollowupQuestion = 'followup_question',
  InitialUserPrompt = 'initial_user_prompt',
  Progress = 'progress',
}

export type ConversationMutationResponse = {
  __typename?: 'ConversationMutationResponse';
  conversation: Conversation;
};

export type ConversationResponse = {
  __typename?: 'ConversationResponse';
  correlationId: Scalars['String']['output'];
  messages: Array<ConversationMessage>;
};

export type ConversationSubscriptionResponse = {
  __typename?: 'ConversationSubscriptionResponse';
  correlationId: Scalars['String']['output'];
  lastMessage: ConversationMessage;
};

export type ConversationTextMessage = {
  __typename?: 'ConversationTextMessage';
  enabledSources?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  jobId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  research?: Maybe<Scalars['Boolean']['output']>;
  role: ConversationMessageRole;
  type: ConversationMessageType;
};

export type ConversationViewCell = {
  __typename?: 'ConversationViewCell';
  conversationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
};

export type CreateAccessTokenError = {
  __typename?: 'CreateAccessTokenError';
  error: Scalars['String']['output'];
};

export type CreateAccessTokenInput = {
  accountId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateAccessTokenResult = AccessTokenPreview | CreateAccessTokenError | NotAllowedError;

export type CreateAnalyticsEventError = {
  __typename?: 'CreateAnalyticsEventError';
  error: Scalars['String']['output'];
};

export type CreateAnalyticsEventInput = {
  name: Scalars['String']['input'];
  properties: Scalars['JSON']['input'];
};

export type CreateAnalyticsEventResult =
  | AnalyticsEvent
  | CreateAnalyticsEventError
  | NotAllowedError;

export type CreateIntegrationResult = {
  __typename?: 'CreateIntegrationResult';
  success: Scalars['Boolean']['output'];
};

export type CreateMcpIntegrationError = {
  __typename?: 'CreateMcpIntegrationError';
  error: Scalars['String']['output'];
};

export type CreateMcpIntegrationResult = CreateMcpIntegrationError | CreateMcpIntegrationSuccess;

export type CreateMcpIntegrationSuccess = {
  __typename?: 'CreateMcpIntegrationSuccess';
  integration: Integration;
};

export type CreateServiceUserError = {
  __typename?: 'CreateServiceUserError';
  error: Scalars['String']['output'];
};

export type CreateServiceUserResult = CreateServiceUserError | NotAllowedError | ServiceUser;

export type DeleteAccessTokenError = {
  __typename?: 'DeleteAccessTokenError';
  error: Scalars['String']['output'];
};

export type DeleteAccessTokenResult =
  | DeleteAccessTokenError
  | DeleteAccessTokenSuccess
  | NotAllowedError;

export type DeleteAccessTokenSuccess = {
  __typename?: 'DeleteAccessTokenSuccess';
  result: Scalars['Boolean']['output'];
};

export type DeleteAlertConfigurationResult = DeleteAlertConfigurationSuccess;

export type DeleteAlertConfigurationSuccess = {
  __typename?: 'DeleteAlertConfigurationSuccess';
  result: Scalars['Boolean']['output'];
};

export type DeleteExplorationResult = DeleteExplorationSuccess | NotAllowedError;

export type DeleteExplorationSuccess = {
  __typename?: 'DeleteExplorationSuccess';
  result: Scalars['Boolean']['output'];
};

export type DeleteMetricError = {
  __typename?: 'DeleteMetricError';
  error: Scalars['String']['output'];
};

export type DeleteMetricResult = DeleteMetricError | DeleteMetricSuccess | NotAllowedError;

export type DeleteMetricSuccess = {
  __typename?: 'DeleteMetricSuccess';
  result: Scalars['Boolean']['output'];
};

export type DeleteModelError = {
  __typename?: 'DeleteModelError';
  error: Scalars['String']['output'];
};

export type DeleteModelResult = DeleteModelError | DeleteModelSuccess | NotAllowedError;

export type DeleteModelSuccess = {
  __typename?: 'DeleteModelSuccess';
  result: Scalars['Boolean']['output'];
};

export type DeleteServiceUserError = {
  __typename?: 'DeleteServiceUserError';
  error: Scalars['String']['output'];
};

export type DeleteServiceUserResult =
  | DeleteServiceUserError
  | DeleteServiceUserSuccess
  | NotAllowedError;

export type DeleteServiceUserSuccess = {
  __typename?: 'DeleteServiceUserSuccess';
  result: Scalars['Boolean']['output'];
};

export type DeletedDanglingObjects = {
  __typename?: 'DeletedDanglingObjects';
  agentSkills?: Maybe<Array<AgentSkill>>;
  aiInstructionSources?: Maybe<Array<AiSystemInstruction>>;
  metrics?: Maybe<Array<Metric>>;
  models?: Maybe<Array<Model>>;
};

export type DescribeQueryResponse = {
  __typename?: 'DescribeQueryResponse';
  sql: Scalars['String']['output'];
};

export type DiscoverEnumOptionsError = {
  __typename?: 'DiscoverEnumOptionsError';
  error: Scalars['String']['output'];
};

export type DiscoverEnumOptionsInput = {
  column: Scalars['String']['input'];
  connectionId?: InputMaybe<Scalars['ID']['input']>;
  labelColumn?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  table: Scalars['String']['input'];
};

export type DiscoverEnumOptionsResult = DiscoverEnumOptionsError | DiscoverEnumOptionsSuccess;

export type DiscoverEnumOptionsSuccess = {
  __typename?: 'DiscoverEnumOptionsSuccess';
  options: Scalars['String']['output'];
};

export type DiscoverModelsError = {
  __typename?: 'DiscoverModelsError';
  error: Scalars['String']['output'];
};

export type DiscoverModelsInput = {
  catalog?: InputMaybe<Scalars['String']['input']>;
  connectionId?: InputMaybe<Scalars['ID']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  skipModelPrefix?: InputMaybe<Scalars['Boolean']['input']>;
  skipTables?: InputMaybe<Array<Scalars['String']['input']>>;
  tables?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DiscoverModelsResult = DiscoverModelsError | DiscoverModelsSuccess;

export type DiscoverModelsSuccess = {
  __typename?: 'DiscoverModelsSuccess';
  configurationFile: Scalars['String']['output'];
};

export type DiscoverSchemasError = {
  __typename?: 'DiscoverSchemasError';
  error: Scalars['String']['output'];
};

export type DiscoverSchemasInput = {
  catalog?: InputMaybe<Scalars['String']['input']>;
  connectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type DiscoverSchemasResult = DiscoverSchemasError | DiscoverSchemasSuccess;

export type DiscoverSchemasSuccess = {
  __typename?: 'DiscoverSchemasSuccess';
  schemas: Array<Schema>;
};

export type Exploration = {
  __typename?: 'Exploration';
  createdAt: Scalars['Date']['output'];
  createdBy: UserProfile;
  description?: Maybe<Scalars['String']['output']>;
  explorationId: Scalars['ID']['output'];
  labels: Scalars['JSON']['output'];
  metadata: ExplorationViewMetadata;
  name: Scalars['String']['output'];
  parameters: Array<ExplorationParameter>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  updatedBy: UserProfile;
  view: ExplorationView;
};

export type ExplorationCellQueryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  cellId: Scalars['ID']['input'];
  exploration: Scalars['JSON']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type ExplorationData = {
  __typename?: 'ExplorationData';
  description?: Maybe<Scalars['String']['output']>;
  explorationId: Scalars['ID']['output'];
  labels: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  parameters: Array<ExplorationParameter>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  view: ExplorationView;
};

export enum ExplorationHistoryChangeKind {
  Change = 'CHANGE',
  LayoutOnly = 'LAYOUT_ONLY',
  StartingPoint = 'STARTING_POINT',
}

export type ExplorationHistoryEntry = {
  __typename?: 'ExplorationHistoryEntry';
  continuedFromDate?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  endedAt: Scalars['String']['output'];
  entryId: Scalars['ID']['output'];
  explorationSourceId?: Maybe<Scalars['String']['output']>;
  headStateId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sittingCount: Scalars['Int']['output'];
  startedAt: Scalars['String']['output'];
  /**
   * Set when the workstream started from a raw model rather than a saved
   * exploration — the id of that model.
   */
  startedFromModelId?: Maybe<Scalars['String']['output']>;
  stateCount: Scalars['Int']['output'];
  /**
   * The entry's steps: one per state transition, in order. Each step's stateId
   * references the exploration state the step produced.
   */
  steps: Array<ExplorationHistoryStep>;
  /** One-line summary of what was done in this entry. */
  summary: Scalars['String']['output'];
};

export type ExplorationHistoryStep = {
  __typename?: 'ExplorationHistoryStep';
  changeKind: ExplorationHistoryChangeKind;
  changeLabel: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  stateId: Scalars['ID']['output'];
};

export type ExplorationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  explorationId: Scalars['ID']['input'];
  labels?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  schemaVersion?: InputMaybe<Scalars['String']['input']>;
  view: Scalars['JSON']['input'];
};

export type ExplorationMetadata = {
  __typename?: 'ExplorationMetadata';
  createdAt: Scalars['Date']['output'];
  createdBy: UserProfile;
  description?: Maybe<Scalars['String']['output']>;
  explorationId: Scalars['ID']['output'];
  labels: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  parameters: Array<ExplorationParameter>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  stats: ExplorationStats;
  updatedAt: Scalars['Date']['output'];
  updatedBy: UserProfile;
};

export type ExplorationNavigationItem = {
  __typename?: 'ExplorationNavigationItem';
  explorationId: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ExplorationParameter = {
  __typename?: 'ExplorationParameter';
  key: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
};

export type ExplorationState = {
  __typename?: 'ExplorationState';
  createdAt: Scalars['Date']['output'];
  createdBy: UserProfile;
  explorationId: Scalars['ID']['output'];
  explorationSourceId?: Maybe<Scalars['ID']['output']>;
  previousStateId?: Maybe<Scalars['ID']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  state: Scalars['JSON']['output'];
};

export type ExplorationStateInput = {
  explorationId: Scalars['ID']['input'];
  explorationSourceId?: InputMaybe<Scalars['ID']['input']>;
  previousStateId?: InputMaybe<Scalars['ID']['input']>;
  schemaVersion?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['JSON']['input'];
};

export type ExplorationStats = {
  __typename?: 'ExplorationStats';
  cellKind: Array<CellKindCount>;
};

export type ExplorationView = {
  __typename?: 'ExplorationView';
  canvas?: Maybe<Scalars['JSON']['output']>;
  cells: Array<ViewCell>;
  options?: Maybe<Scalars['JSON']['output']>;
  tabs?: Maybe<Scalars['JSON']['output']>;
};

export type ExplorationViewCellSort = {
  __typename?: 'ExplorationViewCellSort';
  direction: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type ExplorationViewMetadata = {
  __typename?: 'ExplorationViewMetadata';
  stats: ExplorationStats;
};

export type FunnelViewCell = {
  __typename?: 'FunnelViewCell';
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  pipeline: QueryPipeline;
  title?: Maybe<Scalars['String']['output']>;
  viewOptions?: Maybe<Scalars['JSON']['output']>;
};

export type InboxItem = {
  __typename?: 'InboxItem';
  accountId: Scalars['ID']['output'];
  conversations: Array<InboxItemConversation>;
  createdAt: Scalars['Date']['output'];
  details: Scalars['String']['output'];
  dismissalReason?: Maybe<Scalars['String']['output']>;
  inboxItemId: Scalars['ID']['output'];
  source: InboxItemSource;
  status: InboxItemStatus;
  statusChangedAt: Scalars['Date']['output'];
  statusChangedBy?: Maybe<InboxItemUser>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  users: Array<InboxItemUser>;
};

export type InboxItemConversation = {
  __typename?: 'InboxItemConversation';
  conversationId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  explorationStateId?: Maybe<Scalars['ID']['output']>;
  messageId?: Maybe<Scalars['ID']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  user?: Maybe<InboxItemUser>;
};

export enum InboxItemReviewStatus {
  Confirmed = 'CONFIRMED',
  Dismissed = 'DISMISSED',
  New = 'NEW',
}

export enum InboxItemSource {
  Agent = 'AGENT',
}

export enum InboxItemStatus {
  Confirmed = 'CONFIRMED',
  Dismissed = 'DISMISSED',
  New = 'NEW',
  Resolved = 'RESOLVED',
}

export type InboxItemUser = {
  __typename?: 'InboxItemUser';
  email?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type Integration = {
  __typename?: 'Integration';
  authStatus?: Maybe<IntegrationAuthStatus>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  integrationId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  oauthClientId?: Maybe<Scalars['ID']['output']>;
  service: IntegrationService;
  url?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export enum IntegrationAuthStatus {
  Connected = 'CONNECTED',
  Expired = 'EXPIRED',
  NotConnected = 'NOT_CONNECTED',
}

export enum IntegrationService {
  Confluence = 'CONFLUENCE',
  Custom = 'CUSTOM',
  CustomUnstructured = 'CUSTOM_UNSTRUCTURED',
  FacebookAds = 'FACEBOOK_ADS',
  FacebookPage = 'FACEBOOK_PAGE',
  Github = 'GITHUB',
  GoogleAds = 'GOOGLE_ADS',
  GoogleAnalytics = 'GOOGLE_ANALYTICS',
  GoogleBigquery = 'GOOGLE_BIGQUERY',
  GoogleDrive = 'GOOGLE_DRIVE',
  Mcp = 'MCP',
  Mixpanel = 'MIXPANEL',
  Notion = 'NOTION',
  Shopify = 'SHOPIFY',
  Slack = 'SLACK',
  Stripe = 'STRIPE',
  Woocommerce = 'WOOCOMMERCE',
}

export type InvalidViewCell = {
  __typename?: 'InvalidViewCell';
  cell: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  message: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  viewOptions?: Maybe<Scalars['JSON']['output']>;
};

export type Metric = {
  __typename?: 'Metric';
  definition: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  metricId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MetricViewCell = {
  __typename?: 'MetricViewCell';
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  metricId: Scalars['ID']['output'];
  viewOptions?: Maybe<Scalars['JSON']['output']>;
};

export type Model = {
  __typename?: 'Model';
  description?: Maybe<Scalars['String']['output']>;
  labels: Scalars['JSON']['output'];
  modelId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentPipeline?: Maybe<Scalars['JSON']['output']>;
  primaryKey: Array<Scalars['String']['output']>;
  properties: Array<ModelProperty>;
  property?: Maybe<ModelProperty>;
  relations: Array<ModelRelation>;
  semantics?: Maybe<Scalars['JSON']['output']>;
};

export type ModelPropertyArgs = {
  key: Scalars['String']['input'];
};

export type ModelProperty = {
  __typename?: 'ModelProperty';
  description?: Maybe<Scalars['String']['output']>;
  enumOptions?: Maybe<Array<ModelPropertyEnumOption>>;
  format?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  precision?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ModelPropertyEnumOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelPropertyEnumOption = {
  __typename?: 'ModelPropertyEnumOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ModelRelation = {
  __typename?: 'ModelRelation';
  description?: Maybe<Scalars['String']['output']>;
  joinStrategy: ModelRelationJoinStrategy;
  key: Scalars['String']['output'];
  model: Model;
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ModelRelationJoinStrategy = {
  __typename?: 'ModelRelationJoinStrategy';
  joinKeyOnBase?: Maybe<Scalars['String']['output']>;
  joinKeyOnRelated?: Maybe<Scalars['String']['output']>;
  sql?: Maybe<Scalars['String']['output']>;
  steps?: Maybe<Array<ModelRelationJoinStrategySteps>>;
  through?: Maybe<ModelRelationJoinStrategyThrough>;
};

export type ModelRelationJoinStrategySteps = {
  __typename?: 'ModelRelationJoinStrategySteps';
  relationKey: Scalars['String']['output'];
};

export type ModelRelationJoinStrategyThrough = {
  __typename?: 'ModelRelationJoinStrategyThrough';
  joinKeyToBase?: Maybe<Scalars['String']['output']>;
  joinKeyToRelated?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addMessage: ConversationMutationResponse;
  addUserToAccount: AccountUserChangeResponse;
  addUserToGroup: UserGroup;
  applyAgentInboxChanges: Scalars['Boolean']['output'];
  cancelConversationJob: ConversationMutationResponse;
  createAccessToken: CreateAccessTokenResult;
  createAnalyticsEvent: CreateAnalyticsEventResult;
  createConfluencePairingRequest: ConfluencePairingRequest;
  createConnection: Connection;
  createGoogleDriveIntegration: CreateIntegrationResult;
  createMcpIntegration: CreateMcpIntegrationResult;
  createNotionIntegration: CreateIntegrationResult;
  createServiceUser: CreateServiceUserResult;
  createServiceUserAccessToken: CreateAccessTokenResult;
  deleteAccessToken: DeleteAccessTokenResult;
  deleteAgentSkill: Scalars['Boolean']['output'];
  deleteAlertConfiguration: DeleteAlertConfigurationResult;
  deleteAnswerGuidance: Scalars['Boolean']['output'];
  deleteExploration: DeleteExplorationResult;
  deleteMessage: ConversationMutationResponse;
  deleteMetric: DeleteMetricResult;
  deleteModel: DeleteModelResult;
  deleteServiceUser: DeleteServiceUserResult;
  deleteServiceUserAccessToken: DeleteAccessTokenResult;
  deleteUserFromAccount: AccountUserDeleteResponse;
  deleteUserGroup: UserGroup;
  discardMessage: ConversationMutationResponse;
  disconnectMcpIntegration: Scalars['Boolean']['output'];
  executePythonCell: PythonExecutionResult;
  giveConsent: Scalars['Boolean']['output'];
  importConfiguration: ConfigurationImportResult;
  oauthCallback: OauthCallbackResult;
  oauthGithubCallback: OauthGithubCallbackResult;
  oauthSlackCallback: OauthSlackCallbackResult;
  ping: Scalars['String']['output'];
  removeUserFromGroup: UserGroup;
  rerunConversationJob: ConversationMutationResponse;
  resolveInboxItem: Scalars['Boolean']['output'];
  revokeAuthorizedClient: RevokeAuthorizedClientResult;
  signUp: User;
  startConversation: ConversationMutationResponse;
  startOauth: StartOauthResult;
  toggleUserPinnedExploration: AccountUser;
  updateAiBusinessConcepts?: Maybe<Account>;
  updateAiUsageLimitsConfig: AiUsageLimits;
  updateConnection: Connection;
  updateFeatures: Account;
  updateInboxItemStatus: Scalars['Boolean']['output'];
  updateMessage: ConversationMutationResponse;
  updateNavigation: Scalars['Boolean']['output'];
  updateOnboardingState: Scalars['JSON']['output'];
  updateUserInAccount: AccountUserChangeResponse;
  upsertAgentSkill: AgentSkill;
  /**
   * Upsert AI system instructions for a specific connection or integration.
   * Exactly one of connectionId or integrationId must be provided (not both, not neither).
   * Pass instructions as null to delete.
   */
  upsertAiSystemInstruction?: Maybe<AiSystemInstruction>;
  upsertAlertConfiguration: AlertConfiguration;
  upsertAnswerGuidance: AnswerGuidance;
  upsertExploration: Exploration;
  upsertExplorationState: ExplorationState;
  upsertUserGroup: UserGroup;
  validateConfigurationImport: ConfigurationValidationResult;
};

export type MutationAddMessageArgs = {
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  correlationId?: InputMaybe<Scalars['String']['input']>;
  exploration?: InputMaybe<ExplorationInput>;
  message: ConversationMessageInput;
  selectors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationAddUserToAccountArgs = {
  accountId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  role: UserRole;
};

export type MutationAddUserToGroupArgs = {
  accountId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationApplyAgentInboxChangesArgs = {
  accountId: Scalars['ID']['input'];
  input: AgentInboxChangesInput;
};

export type MutationCancelConversationJobArgs = {
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
};

export type MutationCreateAccessTokenArgs = {
  input: CreateAccessTokenInput;
};

export type MutationCreateAnalyticsEventArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  input: CreateAnalyticsEventInput;
};

export type MutationCreateConfluencePairingRequestArgs = {
  accountId: Scalars['String']['input'];
};

export type MutationCreateConnectionArgs = {
  accountId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  properties: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
};

export type MutationCreateGoogleDriveIntegrationArgs = {
  accountId: Scalars['String']['input'];
  folderUrl: Scalars['String']['input'];
};

export type MutationCreateMcpIntegrationArgs = {
  accountId: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  serverUrl: Scalars['String']['input'];
};

export type MutationCreateNotionIntegrationArgs = {
  accountId: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
};

export type MutationCreateServiceUserArgs = {
  accountId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  role: UserRole;
};

export type MutationCreateServiceUserAccessTokenArgs = {
  accountId: Scalars['ID']['input'];
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationDeleteAccessTokenArgs = {
  accessTokenId: Scalars['ID']['input'];
};

export type MutationDeleteAgentSkillArgs = {
  accountId: Scalars['ID']['input'];
  agentSkillId: Scalars['ID']['input'];
};

export type MutationDeleteAlertConfigurationArgs = {
  accountId: Scalars['ID']['input'];
  alertConfigurationId: Scalars['ID']['input'];
};

export type MutationDeleteAnswerGuidanceArgs = {
  accountId: Scalars['ID']['input'];
  answerGuidanceId: Scalars['ID']['input'];
};

export type MutationDeleteExplorationArgs = {
  accountId: Scalars['ID']['input'];
  explorationId: Scalars['ID']['input'];
};

export type MutationDeleteMessageArgs = {
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};

export type MutationDeleteMetricArgs = {
  accountId: Scalars['ID']['input'];
  metricId: Scalars['String']['input'];
};

export type MutationDeleteModelArgs = {
  accountId: Scalars['ID']['input'];
  id: Scalars['String']['input'];
};

export type MutationDeleteServiceUserArgs = {
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationDeleteServiceUserAccessTokenArgs = {
  accessTokenId: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
};

export type MutationDeleteUserFromAccountArgs = {
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationDeleteUserGroupArgs = {
  accountId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationDiscardMessageArgs = {
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};

export type MutationDisconnectMcpIntegrationArgs = {
  accountId: Scalars['String']['input'];
  integrationId: Scalars['ID']['input'];
};

export type MutationExecutePythonCellArgs = {
  accountId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  dataContext: Scalars['JSON']['input'];
};

export type MutationGiveConsentArgs = {
  accountId: Scalars['ID']['input'];
  input: ConsentInput;
};

export type MutationImportConfigurationArgs = {
  accountId: Scalars['ID']['input'];
  deleteDangling?: InputMaybe<Scalars['Boolean']['input']>;
  input: Scalars['String']['input'];
  validateAlertConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  validateAnswerGuidance?: InputMaybe<Scalars['Boolean']['input']>;
  validateExplorations?: InputMaybe<Scalars['Boolean']['input']>;
  validateSql?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationOauthCallbackArgs = {
  accountId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  oauthClientId: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};

export type MutationOauthGithubCallbackArgs = {
  accountId: Scalars['String']['input'];
  code: Scalars['String']['input'];
};

export type MutationOauthSlackCallbackArgs = {
  accountId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};

export type MutationRemoveUserFromGroupArgs = {
  accountId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRerunConversationJobArgs = {
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  correlationId?: InputMaybe<Scalars['String']['input']>;
  exploration?: InputMaybe<ExplorationInput>;
  jobId: Scalars['ID']['input'];
  selectors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationResolveInboxItemArgs = {
  accountId: Scalars['ID']['input'];
  inboxItemId: Scalars['ID']['input'];
};

export type MutationRevokeAuthorizedClientArgs = {
  accountId: Scalars['ID']['input'];
  grantId: Scalars['ID']['input'];
};

export type MutationSignUpArgs = {
  consent?: InputMaybe<ConsentInput>;
  email: Scalars['String']['input'];
  extras?: InputMaybe<Scalars['JSON']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartConversationArgs = {
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  correlationId?: InputMaybe<Scalars['String']['input']>;
  exploration?: InputMaybe<ExplorationInput>;
  message: ConversationMessageInput;
  selectors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationStartOauthArgs = {
  accountId: Scalars['String']['input'];
  oauthClientId: Scalars['ID']['input'];
};

export type MutationToggleUserPinnedExplorationArgs = {
  accountId: Scalars['ID']['input'];
  explorationId: Scalars['ID']['input'];
};

export type MutationUpdateAiBusinessConceptsArgs = {
  accountId: Scalars['ID']['input'];
  aiBusinessConcepts: Scalars['String']['input'];
};

export type MutationUpdateAiUsageLimitsConfigArgs = {
  account: AiUsageLimitsConfigInput;
  accountId: Scalars['ID']['input'];
  user: AiUsageLimitsConfigInput;
};

export type MutationUpdateConnectionArgs = {
  accountId: Scalars['ID']['input'];
  connectionId: Scalars['ID']['input'];
  input: UpdateConnectionInput;
};

export type MutationUpdateFeaturesArgs = {
  accountId: Scalars['ID']['input'];
  input: UpdateFeaturesInput;
};

export type MutationUpdateInboxItemStatusArgs = {
  accountId: Scalars['ID']['input'];
  dismissalReason?: InputMaybe<Scalars['String']['input']>;
  inboxItemId: Scalars['ID']['input'];
  status: InboxItemReviewStatus;
};

export type MutationUpdateMessageArgs = {
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  correlationId?: InputMaybe<Scalars['String']['input']>;
  exploration?: InputMaybe<ExplorationInput>;
  message: ConversationMessageInput;
  selectors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type MutationUpdateNavigationArgs = {
  accountId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};

export type MutationUpdateOnboardingStateArgs = {
  accountId: Scalars['ID']['input'];
  key: OnboardingStateKey;
  value: Scalars['JSON']['input'];
};

export type MutationUpdateUserInAccountArgs = {
  accountId: Scalars['ID']['input'];
  role: UserRole;
  userId: Scalars['ID']['input'];
};

export type MutationUpsertAgentSkillArgs = {
  accountId: Scalars['ID']['input'];
  input: AgentSkillInput;
};

export type MutationUpsertAiSystemInstructionArgs = {
  accountId: Scalars['ID']['input'];
  connectionId?: InputMaybe<Scalars['ID']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  integrationId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpsertAlertConfigurationArgs = {
  accountId: Scalars['ID']['input'];
  input: AlertConfigurationInput;
};

export type MutationUpsertAnswerGuidanceArgs = {
  accountId: Scalars['ID']['input'];
  input: AnswerGuidanceInput;
};

export type MutationUpsertExplorationArgs = {
  accountId: Scalars['ID']['input'];
  input: ExplorationInput;
};

export type MutationUpsertExplorationStateArgs = {
  accountId: Scalars['ID']['input'];
  input: ExplorationStateInput;
};

export type MutationUpsertUserGroupArgs = {
  accountId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  permissions?: InputMaybe<Array<UserRolePermission>>;
  userGroupId: Scalars['ID']['input'];
};

export type MutationValidateConfigurationImportArgs = {
  accountId: Scalars['ID']['input'];
  input: Scalars['String']['input'];
  validateAlertConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  validateAnswerGuidance?: InputMaybe<Scalars['Boolean']['input']>;
  validateDangling?: InputMaybe<Scalars['Boolean']['input']>;
  validateExplorations?: InputMaybe<Scalars['Boolean']['input']>;
  validateSql?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationItem = ExplorationNavigationItem;

export type NotAllowedError = {
  __typename?: 'NotAllowedError';
  message: Scalars['String']['output'];
};

export type OauthCallbackError = {
  __typename?: 'OauthCallbackError';
  error: Scalars['String']['output'];
};

export type OauthCallbackResult = OauthCallbackError | OauthCallbackSuccess;

export type OauthCallbackSuccess = {
  __typename?: 'OauthCallbackSuccess';
  success: Scalars['Boolean']['output'];
};

export type OauthGithubCallbackError = {
  __typename?: 'OauthGithubCallbackError';
  error: Scalars['String']['output'];
};

export type OauthGithubCallbackInstallRequired = {
  __typename?: 'OauthGithubCallbackInstallRequired';
  installRequired: Scalars['Boolean']['output'];
};

export type OauthGithubCallbackResult =
  | OauthGithubCallbackError
  | OauthGithubCallbackInstallRequired
  | OauthGithubCallbackSuccess;

export type OauthGithubCallbackSuccess = {
  __typename?: 'OauthGithubCallbackSuccess';
  success: Scalars['Boolean']['output'];
};

export type OauthSlackCallbackError = {
  __typename?: 'OauthSlackCallbackError';
  error: Scalars['String']['output'];
};

export type OauthSlackCallbackResult = OauthSlackCallbackError | OauthSlackCallbackSuccess;

export type OauthSlackCallbackSuccess = {
  __typename?: 'OauthSlackCallbackSuccess';
  success: Scalars['Boolean']['output'];
};

export type OnboardingState = {
  __typename?: 'OnboardingState';
  hasBookedSetupCall: Scalars['Boolean']['output'];
  hasConnection: Scalars['Boolean']['output'];
  hasConsented: Scalars['Boolean']['output'];
  hasOnboarded: Scalars['Boolean']['output'];
  hasPassedSetupCallStep: Scalars['Boolean']['output'];
  welcomeSurvey?: Maybe<Scalars['JSON']['output']>;
};

export enum OnboardingStateKey {
  HasBookedSetupCall = 'hasBookedSetupCall',
  HasPassedSetupCallStep = 'hasPassedSetupCallStep',
  WelcomeSurvey = 'welcomeSurvey',
}

export type OperationInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  operation: Scalars['String']['input'];
  parameters: Scalars['JSON']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Permission = {
  __typename?: 'Permission';
  name: Scalars['String']['output'];
  permissionId: UserRolePermission;
};

export type PipelineOperator = {
  __typename?: 'PipelineOperator';
  disabled?: Maybe<Scalars['Boolean']['output']>;
  operation: Scalars['String']['output'];
  parameters: Scalars['JSON']['output'];
};

export type PythonExecutionResult = {
  __typename?: 'PythonExecutionResult';
  logs: Scalars['JSON']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
};

export type PythonViewCell = {
  __typename?: 'PythonViewCell';
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  pipeline: QueryPipeline;
  title?: Maybe<Scalars['String']['output']>;
  viewOptions?: Maybe<Scalars['JSON']['output']>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accounts: Array<Account>;
  agentInboxOpenItems: Array<AgentInboxOpenItem>;
  me?: Maybe<User>;
  permissions: Array<Permission>;
  ping: Scalars['String']['output'];
  roles: Array<Role>;
  ssoProviderIdForEmail?: Maybe<Scalars['String']['output']>;
  /**
   * Statically validates an exploration against caller-provided models and metrics.
   * Used by AI training/eval flows whose synthetic models do not exist in any account.
   */
  validateTrainingExploration: Scalars['JSON']['output'];
};

export type QueryAccountArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAgentInboxOpenItemsArgs = {
  accountId: Scalars['ID']['input'];
};

export type QuerySsoProviderIdForEmailArgs = {
  email: Scalars['String']['input'];
};

export type QueryValidateTrainingExplorationArgs = {
  exploration: Scalars['JSON']['input'];
  metricsInput?: InputMaybe<Scalars['JSON']['input']>;
  modelsInput: Scalars['JSON']['input'];
  variablesInput?: InputMaybe<Scalars['JSON']['input']>;
};

export type QueryLabelsInput = {
  block?: InputMaybe<Scalars['String']['input']>;
  exploration?: InputMaybe<Scalars['String']['input']>;
};

export type QueryOptionsInput = {
  labels?: InputMaybe<QueryLabelsInput>;
  optimize?: InputMaybe<Scalars['Boolean']['input']>;
  refreshCache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPipeline = {
  __typename?: 'QueryPipeline';
  baseModelId?: Maybe<Scalars['String']['output']>;
  operations: Array<PipelineOperator>;
  parentId?: Maybe<Scalars['String']['output']>;
  pipelineId?: Maybe<Scalars['String']['output']>;
};

export type QueryResponseConnection = {
  __typename?: 'QueryResponseConnection';
  edges: Array<QueryResponseEdge>;
  grouping: Array<QueryResponseGrouping>;
  metadata: QueryResponseMetadata;
  pageInfo: PageInfo;
  recordType: Array<QueryResponseRecordType>;
};

export type QueryResponseEdge = {
  __typename?: 'QueryResponseEdge';
  node: Scalars['JSON']['output'];
};

export type QueryResponseGrouping = {
  __typename?: 'QueryResponseGrouping';
  key: Scalars['String']['output'];
};

export type QueryResponseMetadata = {
  __typename?: 'QueryResponseMetadata';
  cachedAt?: Maybe<Scalars['Date']['output']>;
};

export type QueryResponseRecordModel = {
  __typename?: 'QueryResponseRecordModel';
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  propertyKey: Scalars['String']['output'];
};

export type QueryResponseRecordRelation = {
  __typename?: 'QueryResponseRecordRelation';
  key: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QueryResponseRecordType = {
  __typename?: 'QueryResponseRecordType';
  format?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  model?: Maybe<QueryResponseRecordModel>;
  name: Scalars['String']['output'];
  pk?: Maybe<Scalars['Boolean']['output']>;
  precision?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<QueryResponseRecordRelation>;
  type: Scalars['String']['output'];
};

export type QuerySortBy = {
  direction: QuerySortDirection;
  key: Scalars['String']['input'];
};

export enum QuerySortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type RecordsViewCell = {
  __typename?: 'RecordsViewCell';
  excludeProperties?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  pipeline: QueryPipeline;
  sort?: Maybe<Array<ExplorationViewCellSort>>;
  title?: Maybe<Scalars['String']['output']>;
  viewOptions?: Maybe<Scalars['JSON']['output']>;
  visualisations?: Maybe<Array<Visualisation>>;
};

export type RevokeAuthorizedClientError = {
  __typename?: 'RevokeAuthorizedClientError';
  error: Scalars['String']['output'];
};

export type RevokeAuthorizedClientResult =
  | NotAllowedError
  | RevokeAuthorizedClientError
  | RevokeAuthorizedClientSuccess;

export type RevokeAuthorizedClientSuccess = {
  __typename?: 'RevokeAuthorizedClientSuccess';
  result: Scalars['Boolean']['output'];
};

export type Role = {
  __typename?: 'Role';
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  roleId: UserRole;
};

export type Schema = {
  __typename?: 'Schema';
  name: Scalars['String']['output'];
};

export type ServiceUser = {
  __typename?: 'ServiceUser';
  accessTokens: Array<AccessToken>;
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: UserRole;
  userId: Scalars['ID']['output'];
};

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['ID']['output'];
  isBotInChannel: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type SqlViewCell = {
  __typename?: 'SqlViewCell';
  excludeProperties?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  pipeline: QueryPipeline;
  title?: Maybe<Scalars['String']['output']>;
  viewOptions?: Maybe<Scalars['JSON']['output']>;
  visualisations?: Maybe<Array<Visualisation>>;
};

export type StartOauthError = {
  __typename?: 'StartOauthError';
  error: Scalars['String']['output'];
};

export type StartOauthResult = StartOauthError | StartOauthSuccess;

export type StartOauthSuccess = {
  __typename?: 'StartOauthSuccess';
  authorizeUrl: Scalars['String']['output'];
};

export type StreamPipelineInput = {
  accountId: Scalars['ID']['input'];
  baseModelId: Scalars['ID']['input'];
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<QueryOptionsInput>;
  pipeline: Array<OperationInput>;
  sort?: InputMaybe<Array<QuerySortBy>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type StreamPipelinePayload = {
  __typename?: 'StreamPipelinePayload';
  grouping?: Maybe<Array<QueryResponseGrouping>>;
  recordType?: Maybe<Array<QueryResponseRecordType>>;
  rowCount: Scalars['Int']['output'];
  rows: Array<Scalars['JSON']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  ask: ConversationSubscriptionResponse;
  ping: Scalars['String']['output'];
  streamPipeline: StreamPipelinePayload;
};

export type SubscriptionAskArgs = {
  accountId: Scalars['ID']['input'];
  conversation: ConversationInput;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  exploration?: InputMaybe<ExplorationInput>;
  selectors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type SubscriptionStreamPipelineArgs = {
  input: StreamPipelineInput;
};

export type TestConnectionFailed = {
  __typename?: 'TestConnectionFailed';
  error: Scalars['String']['output'];
};

export type TestConnectionResult = TestConnectionFailed | TestConnectionSuccess;

export type TestConnectionSuccess = {
  __typename?: 'TestConnectionSuccess';
  success: Scalars['Boolean']['output'];
};

export type TextViewCell = {
  __typename?: 'TextViewCell';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  viewOptions?: Maybe<Scalars['JSON']['output']>;
};

export type UpdateConnectionInput = {
  /** New connection name. Omit (or null) to leave the name unchanged. */
  name?: InputMaybe<Scalars['String']['input']>;
  properties: UpdateConnectionPropertiesInput;
};

export type UpdateConnectionPropertiesInput = {
  /**
   * Connection (statement) timeout in milliseconds. Null clears the override and falls back to the
   * default; omitting the field leaves the current value untouched.
   */
  connectionTimeout?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Maximum amount of data a query may process, in bytes. Null clears the limit; omitting the field
   * leaves the current value untouched.
   */
  maximumDataProcessedBytes?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFeaturesInput = {
  /**
   * Whether the AI fetches query rows while answering. Null clears the override and falls back to the
   * default; omitting the field leaves the current value untouched.
   */
  queryDataFetch?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Timeout in seconds the AI applies when fetching query results while answering. Null clears the
   * override and falls back to the default; omitting the field leaves the current value untouched.
   */
  queryDataFetchTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['ID']['output'];
};

export type UserGroup = {
  __typename?: 'UserGroup';
  createdAt: Scalars['Date']['output'];
  members: Array<AccountUser>;
  name: Scalars['String']['output'];
  parameters?: Maybe<Scalars['JSON']['output']>;
  permissions: Array<UserRolePermission>;
  updatedAt: Scalars['Date']['output'];
  userGroupId: Scalars['ID']['output'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  email: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export enum UserRole {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  Explorer = 'EXPLORER',
}

export enum UserRolePermission {
  ManageAccount = 'MANAGE_ACCOUNT',
  ManageAccountFeatures = 'MANAGE_ACCOUNT_FEATURES',
  ManageAiSystemInstructions = 'MANAGE_AI_SYSTEM_INSTRUCTIONS',
  ManageAlerts = 'MANAGE_ALERTS',
  ManageAnswerGuidance = 'MANAGE_ANSWER_GUIDANCE',
  ManageConnections = 'MANAGE_CONNECTIONS',
  ManageExplorations = 'MANAGE_EXPLORATIONS',
  ManageModels = 'MANAGE_MODELS',
  ManageUsers = 'MANAGE_USERS',
  ManageUserGroups = 'MANAGE_USER_GROUPS',
  UseSqlOperations = 'USE_SQL_OPERATIONS',
}

export type VariableViewCell = {
  __typename?: 'VariableViewCell';
  definition: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  viewOptions?: Maybe<Scalars['JSON']['output']>;
};

export type ViewCell =
  | ChatViewCell
  | CohortViewCell
  | ConversationViewCell
  | FunnelViewCell
  | InvalidViewCell
  | MetricViewCell
  | PythonViewCell
  | RecordsViewCell
  | SqlViewCell
  | TextViewCell
  | VariableViewCell;

export type Visualisation = {
  __typename?: 'Visualisation';
  aggregation?: Maybe<Scalars['JSON']['output']>;
  aggregationTarget?: Maybe<Scalars['String']['output']>;
  aggregationType?: Maybe<Scalars['String']['output']>;
  aggregations?: Maybe<Scalars['JSON']['output']>;
  groupByField?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Scalars['JSON']['output']>;
  mainAxisKey?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Array<Maybe<ExplorationViewCellSort>>>;
  timeGranularity?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  valueKeys?: Maybe<Array<Scalars['String']['output']>>;
  viewOptions?: Maybe<Scalars['JSON']['output']>;
  visualisation?: Maybe<Scalars['JSON']['output']>;
};

export type AiQueryHistoryQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type AiQueryHistoryQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    aiQueryHistory: Array<{
      __typename?: 'AiQueryThread';
      threadId: string;
      queries: Array<{
        __typename?: 'AiQuery';
        correlationId: string;
        message: string;
        resultUrl?: string | null;
        sources?: Array<string> | null;
        createdAt: string;
      }>;
    }>;
  } | null;
};

export type ExplorationHistoryQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExplorationHistoryQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    explorationHistory: Array<{
      __typename?: 'ExplorationHistoryEntry';
      entryId: string;
      startedAt: string;
      endedAt: string;
      stateCount: number;
      sittingCount: number;
      name: string;
      headStateId: string;
      continuedFromDate?: string | null;
      startedFromModelId?: string | null;
    }>;
  } | null;
};

export type ExplorationHistoryEntrySummaryQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  entryId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExplorationHistoryEntrySummaryQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    explorationHistoryEntry?: {
      __typename?: 'ExplorationHistoryEntry';
      entryId: string;
      summary: string;
    } | null;
  } | null;
};

export type ExplorationHistoryEntryStepsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  entryId: Scalars['ID']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExplorationHistoryEntryStepsQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    explorationHistoryEntry?: {
      __typename?: 'ExplorationHistoryEntry';
      entryId: string;
      steps: Array<{
        __typename?: 'ExplorationHistoryStep';
        stateId: string;
        createdAt: string;
        changeLabel: string;
        changeKind: ExplorationHistoryChangeKind;
      }>;
    } | null;
  } | null;
};

export type AlertConfigurationQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  alertConfigurationId: Scalars['ID']['input'];
}>;

export type AlertConfigurationQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    alertConfiguration?: {
      __typename?: 'AlertConfiguration';
      alertConfigurationId: string;
      accountId: string;
      name: string;
      message: string;
      pipeline: any;
      keyFields: Array<string>;
      excludedFields: Array<string>;
      notificationConfig: any;
      createdAt: string;
    } | null;
    models: Array<{ __typename?: 'Model'; modelId: string; name: string }>;
  } | null;
};

export type ExplorationRecordTypeQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  baseModelId: Scalars['ID']['input'];
  pipeline: Array<OperationInput> | OperationInput;
  variables?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type ExplorationRecordTypeQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    query: {
      __typename?: 'QueryResponseConnection';
      recordType: Array<{
        __typename?: 'QueryResponseRecordType';
        key: string;
        type: string;
        name: string;
        relation?: {
          __typename?: 'QueryResponseRecordRelation';
          modelId: string;
          key: string;
          name: string;
        } | null;
      }>;
      grouping: Array<{ __typename?: 'QueryResponseGrouping'; key: string }>;
    };
  } | null;
};

export type ConversationFragmentFragment = {
  __typename?: 'Conversation';
  conversationId: string;
  messages: Array<
    | {
        __typename?: 'ConversationExplorationMessage';
        id: string;
        role: ConversationMessageRole;
        type: ConversationMessageType;
        jobId?: string | null;
        exploration: {
          __typename?: 'ExplorationData';
          schemaVersion?: string | null;
          explorationId: string;
          name: string;
          description?: string | null;
          labels: any;
          parameters: Array<{ __typename?: 'ExplorationParameter'; key: string; modelId: string }>;
          view: {
            __typename?: 'ExplorationView';
            canvas?: any | null;
            tabs?: any | null;
            options?: any | null;
            cells: Array<
              | {
                  __typename?: 'ChatViewCell';
                  id: string;
                  kind: string;
                  viewOptions?: any | null;
                  messages: Array<{
                    __typename?: 'ChatCellMessage';
                    id: string;
                    role: string;
                    type: string;
                    message: string;
                  }>;
                }
              | {
                  __typename?: 'CohortViewCell';
                  id: string;
                  kind: string;
                  title?: string | null;
                  viewOptions?: any | null;
                  pipeline: {
                    __typename?: 'QueryPipeline';
                    baseModelId?: string | null;
                    pipelineId?: string | null;
                    parentId?: string | null;
                    operations: Array<{
                      __typename?: 'PipelineOperator';
                      operation: string;
                      parameters: any;
                    }>;
                  };
                }
              | {
                  __typename?: 'ConversationViewCell';
                  id: string;
                  kind: string;
                  conversationId: string;
                }
              | {
                  __typename?: 'FunnelViewCell';
                  id: string;
                  kind: string;
                  title?: string | null;
                  viewOptions?: any | null;
                  pipeline: {
                    __typename?: 'QueryPipeline';
                    baseModelId?: string | null;
                    pipelineId?: string | null;
                    operations: Array<{
                      __typename?: 'PipelineOperator';
                      operation: string;
                      parameters: any;
                    }>;
                  };
                }
              | {
                  __typename?: 'InvalidViewCell';
                  id: string;
                  kind: string;
                  title?: string | null;
                  message: string;
                  viewOptions?: any | null;
                  cell: any;
                }
              | {
                  __typename?: 'MetricViewCell';
                  id: string;
                  kind: string;
                  metricId: string;
                  viewOptions?: any | null;
                }
              | {
                  __typename?: 'PythonViewCell';
                  id: string;
                  kind: string;
                  title?: string | null;
                  viewOptions?: any | null;
                  pipeline: {
                    __typename?: 'QueryPipeline';
                    baseModelId?: string | null;
                    pipelineId?: string | null;
                    operations: Array<{
                      __typename?: 'PipelineOperator';
                      operation: string;
                      parameters: any;
                    }>;
                  };
                }
              | {
                  __typename?: 'RecordsViewCell';
                  id: string;
                  kind: string;
                  title?: string | null;
                  excludeProperties?: Array<string> | null;
                  viewOptions?: any | null;
                  pipeline: {
                    __typename?: 'QueryPipeline';
                    baseModelId?: string | null;
                    pipelineId?: string | null;
                    parentId?: string | null;
                    operations: Array<{
                      __typename?: 'PipelineOperator';
                      operation: string;
                      parameters: any;
                      disabled?: boolean | null;
                    }>;
                  };
                  sort?: Array<{
                    __typename?: 'ExplorationViewCellSort';
                    key: string;
                    direction: string;
                  }> | null;
                  visualisations?: Array<{
                    __typename?: 'Visualisation';
                    aggregationType?: string | null;
                    aggregationTarget?: string | null;
                    groupByField?: string | null;
                    timeGranularity?: string | null;
                    viewOptions?: any | null;
                    aggregations?: any | null;
                    groups?: any | null;
                    aggregation?: any | null;
                    valueKeys?: Array<string> | null;
                    mainAxisKey?: string | null;
                    type?: string | null;
                    message?: string | null;
                    visualisation?: any | null;
                    sort?: Array<{
                      __typename?: 'ExplorationViewCellSort';
                      key: string;
                      direction: string;
                    } | null> | null;
                  }> | null;
                }
              | {
                  __typename?: 'SqlViewCell';
                  id: string;
                  kind: string;
                  title?: string | null;
                  excludeProperties?: Array<string> | null;
                  viewOptions?: any | null;
                  pipeline: {
                    __typename?: 'QueryPipeline';
                    baseModelId?: string | null;
                    pipelineId?: string | null;
                    operations: Array<{
                      __typename?: 'PipelineOperator';
                      operation: string;
                      parameters: any;
                    }>;
                  };
                  visualisations?: Array<{
                    __typename?: 'Visualisation';
                    aggregationType?: string | null;
                    aggregationTarget?: string | null;
                    groupByField?: string | null;
                    timeGranularity?: string | null;
                    viewOptions?: any | null;
                    aggregations?: any | null;
                    groups?: any | null;
                    aggregation?: any | null;
                    valueKeys?: Array<string> | null;
                    mainAxisKey?: string | null;
                    type?: string | null;
                    message?: string | null;
                    visualisation?: any | null;
                    sort?: Array<{
                      __typename?: 'ExplorationViewCellSort';
                      key: string;
                      direction: string;
                    } | null> | null;
                  }> | null;
                }
              | {
                  __typename?: 'TextViewCell';
                  id: string;
                  kind: string;
                  title?: string | null;
                  content?: string | null;
                  viewOptions?: any | null;
                }
              | {
                  __typename?: 'VariableViewCell';
                  id: string;
                  kind: string;
                  definition: any;
                  viewOptions?: any | null;
                }
            >;
          };
        };
      }
    | {
        __typename?: 'ConversationTextMessage';
        id: string;
        role: ConversationMessageRole;
        type: ConversationMessageType;
        enabledSources?: any | null;
        research?: boolean | null;
        message: string;
        jobId?: string | null;
      }
  >;
  jobs: Array<{
    __typename?: 'ConversationJob';
    jobId: string;
    parentJobId?: string | null;
    channel?: string | null;
    createdAt: string;
    progress?: Array<{
      __typename?: 'ConversationJobProgress';
      jobProgressId: string;
      jobId: string;
      status?: string | null;
      statusMessage?: string | null;
      createdAt: string;
    } | null> | null;
  }>;
};

export type ConversationQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
}>;

export type ConversationQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    conversation: {
      __typename?: 'Conversation';
      conversationId: string;
      messages: Array<
        | {
            __typename?: 'ConversationExplorationMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            jobId?: string | null;
            exploration: {
              __typename?: 'ExplorationData';
              schemaVersion?: string | null;
              explorationId: string;
              name: string;
              description?: string | null;
              labels: any;
              parameters: Array<{
                __typename?: 'ExplorationParameter';
                key: string;
                modelId: string;
              }>;
              view: {
                __typename?: 'ExplorationView';
                canvas?: any | null;
                tabs?: any | null;
                options?: any | null;
                cells: Array<
                  | {
                      __typename?: 'ChatViewCell';
                      id: string;
                      kind: string;
                      viewOptions?: any | null;
                      messages: Array<{
                        __typename?: 'ChatCellMessage';
                        id: string;
                        role: string;
                        type: string;
                        message: string;
                      }>;
                    }
                  | {
                      __typename?: 'CohortViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'ConversationViewCell';
                      id: string;
                      kind: string;
                      conversationId: string;
                    }
                  | {
                      __typename?: 'FunnelViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'InvalidViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      message: string;
                      viewOptions?: any | null;
                      cell: any;
                    }
                  | {
                      __typename?: 'MetricViewCell';
                      id: string;
                      kind: string;
                      metricId: string;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'PythonViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'RecordsViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                          disabled?: boolean | null;
                        }>;
                      };
                      sort?: Array<{
                        __typename?: 'ExplorationViewCellSort';
                        key: string;
                        direction: string;
                      }> | null;
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'SqlViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'TextViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      content?: string | null;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'VariableViewCell';
                      id: string;
                      kind: string;
                      definition: any;
                      viewOptions?: any | null;
                    }
                >;
              };
            };
          }
        | {
            __typename?: 'ConversationTextMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            enabledSources?: any | null;
            research?: boolean | null;
            message: string;
            jobId?: string | null;
          }
      >;
      jobs: Array<{
        __typename?: 'ConversationJob';
        jobId: string;
        parentJobId?: string | null;
        channel?: string | null;
        createdAt: string;
        progress?: Array<{
          __typename?: 'ConversationJobProgress';
          jobProgressId: string;
          jobId: string;
          status?: string | null;
          statusMessage?: string | null;
          createdAt: string;
        } | null> | null;
      }>;
    };
  } | null;
};

export type StartConversationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  message: ConversationMessageInput;
  exploration?: InputMaybe<ExplorationInput>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  selectors?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type StartConversationMutation = {
  __typename?: 'Mutation';
  startConversation: {
    __typename?: 'ConversationMutationResponse';
    conversation: {
      __typename?: 'Conversation';
      conversationId: string;
      messages: Array<
        | {
            __typename?: 'ConversationExplorationMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            jobId?: string | null;
            exploration: {
              __typename?: 'ExplorationData';
              schemaVersion?: string | null;
              explorationId: string;
              name: string;
              description?: string | null;
              labels: any;
              parameters: Array<{
                __typename?: 'ExplorationParameter';
                key: string;
                modelId: string;
              }>;
              view: {
                __typename?: 'ExplorationView';
                canvas?: any | null;
                tabs?: any | null;
                options?: any | null;
                cells: Array<
                  | {
                      __typename?: 'ChatViewCell';
                      id: string;
                      kind: string;
                      viewOptions?: any | null;
                      messages: Array<{
                        __typename?: 'ChatCellMessage';
                        id: string;
                        role: string;
                        type: string;
                        message: string;
                      }>;
                    }
                  | {
                      __typename?: 'CohortViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'ConversationViewCell';
                      id: string;
                      kind: string;
                      conversationId: string;
                    }
                  | {
                      __typename?: 'FunnelViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'InvalidViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      message: string;
                      viewOptions?: any | null;
                      cell: any;
                    }
                  | {
                      __typename?: 'MetricViewCell';
                      id: string;
                      kind: string;
                      metricId: string;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'PythonViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'RecordsViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                          disabled?: boolean | null;
                        }>;
                      };
                      sort?: Array<{
                        __typename?: 'ExplorationViewCellSort';
                        key: string;
                        direction: string;
                      }> | null;
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'SqlViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'TextViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      content?: string | null;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'VariableViewCell';
                      id: string;
                      kind: string;
                      definition: any;
                      viewOptions?: any | null;
                    }
                >;
              };
            };
          }
        | {
            __typename?: 'ConversationTextMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            enabledSources?: any | null;
            research?: boolean | null;
            message: string;
            jobId?: string | null;
          }
      >;
      jobs: Array<{
        __typename?: 'ConversationJob';
        jobId: string;
        parentJobId?: string | null;
        channel?: string | null;
        createdAt: string;
        progress?: Array<{
          __typename?: 'ConversationJobProgress';
          jobProgressId: string;
          jobId: string;
          status?: string | null;
          statusMessage?: string | null;
          createdAt: string;
        } | null> | null;
      }>;
    };
  };
};

export type AddMessageMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  message: ConversationMessageInput;
  exploration?: InputMaybe<ExplorationInput>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  selectors?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type AddMessageMutation = {
  __typename?: 'Mutation';
  addMessage: {
    __typename?: 'ConversationMutationResponse';
    conversation: {
      __typename?: 'Conversation';
      conversationId: string;
      messages: Array<
        | {
            __typename?: 'ConversationExplorationMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            jobId?: string | null;
            exploration: {
              __typename?: 'ExplorationData';
              schemaVersion?: string | null;
              explorationId: string;
              name: string;
              description?: string | null;
              labels: any;
              parameters: Array<{
                __typename?: 'ExplorationParameter';
                key: string;
                modelId: string;
              }>;
              view: {
                __typename?: 'ExplorationView';
                canvas?: any | null;
                tabs?: any | null;
                options?: any | null;
                cells: Array<
                  | {
                      __typename?: 'ChatViewCell';
                      id: string;
                      kind: string;
                      viewOptions?: any | null;
                      messages: Array<{
                        __typename?: 'ChatCellMessage';
                        id: string;
                        role: string;
                        type: string;
                        message: string;
                      }>;
                    }
                  | {
                      __typename?: 'CohortViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'ConversationViewCell';
                      id: string;
                      kind: string;
                      conversationId: string;
                    }
                  | {
                      __typename?: 'FunnelViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'InvalidViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      message: string;
                      viewOptions?: any | null;
                      cell: any;
                    }
                  | {
                      __typename?: 'MetricViewCell';
                      id: string;
                      kind: string;
                      metricId: string;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'PythonViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'RecordsViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                          disabled?: boolean | null;
                        }>;
                      };
                      sort?: Array<{
                        __typename?: 'ExplorationViewCellSort';
                        key: string;
                        direction: string;
                      }> | null;
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'SqlViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'TextViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      content?: string | null;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'VariableViewCell';
                      id: string;
                      kind: string;
                      definition: any;
                      viewOptions?: any | null;
                    }
                >;
              };
            };
          }
        | {
            __typename?: 'ConversationTextMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            enabledSources?: any | null;
            research?: boolean | null;
            message: string;
            jobId?: string | null;
          }
      >;
      jobs: Array<{
        __typename?: 'ConversationJob';
        jobId: string;
        parentJobId?: string | null;
        channel?: string | null;
        createdAt: string;
        progress?: Array<{
          __typename?: 'ConversationJobProgress';
          jobProgressId: string;
          jobId: string;
          status?: string | null;
          statusMessage?: string | null;
          createdAt: string;
        } | null> | null;
      }>;
    };
  };
};

export type UpdateMessageMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  message: ConversationMessageInput;
  exploration?: InputMaybe<ExplorationInput>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  selectors?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type UpdateMessageMutation = {
  __typename?: 'Mutation';
  updateMessage: {
    __typename?: 'ConversationMutationResponse';
    conversation: {
      __typename?: 'Conversation';
      conversationId: string;
      messages: Array<
        | {
            __typename?: 'ConversationExplorationMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            jobId?: string | null;
            exploration: {
              __typename?: 'ExplorationData';
              schemaVersion?: string | null;
              explorationId: string;
              name: string;
              description?: string | null;
              labels: any;
              parameters: Array<{
                __typename?: 'ExplorationParameter';
                key: string;
                modelId: string;
              }>;
              view: {
                __typename?: 'ExplorationView';
                canvas?: any | null;
                tabs?: any | null;
                options?: any | null;
                cells: Array<
                  | {
                      __typename?: 'ChatViewCell';
                      id: string;
                      kind: string;
                      viewOptions?: any | null;
                      messages: Array<{
                        __typename?: 'ChatCellMessage';
                        id: string;
                        role: string;
                        type: string;
                        message: string;
                      }>;
                    }
                  | {
                      __typename?: 'CohortViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'ConversationViewCell';
                      id: string;
                      kind: string;
                      conversationId: string;
                    }
                  | {
                      __typename?: 'FunnelViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'InvalidViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      message: string;
                      viewOptions?: any | null;
                      cell: any;
                    }
                  | {
                      __typename?: 'MetricViewCell';
                      id: string;
                      kind: string;
                      metricId: string;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'PythonViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'RecordsViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                          disabled?: boolean | null;
                        }>;
                      };
                      sort?: Array<{
                        __typename?: 'ExplorationViewCellSort';
                        key: string;
                        direction: string;
                      }> | null;
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'SqlViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'TextViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      content?: string | null;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'VariableViewCell';
                      id: string;
                      kind: string;
                      definition: any;
                      viewOptions?: any | null;
                    }
                >;
              };
            };
          }
        | {
            __typename?: 'ConversationTextMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            enabledSources?: any | null;
            research?: boolean | null;
            message: string;
            jobId?: string | null;
          }
      >;
      jobs: Array<{
        __typename?: 'ConversationJob';
        jobId: string;
        parentJobId?: string | null;
        channel?: string | null;
        createdAt: string;
        progress?: Array<{
          __typename?: 'ConversationJobProgress';
          jobProgressId: string;
          jobId: string;
          status?: string | null;
          statusMessage?: string | null;
          createdAt: string;
        } | null> | null;
      }>;
    };
  };
};

export type DiscardMessageMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
}>;

export type DiscardMessageMutation = {
  __typename?: 'Mutation';
  discardMessage: {
    __typename?: 'ConversationMutationResponse';
    conversation: {
      __typename?: 'Conversation';
      conversationId: string;
      messages: Array<
        | {
            __typename?: 'ConversationExplorationMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            jobId?: string | null;
            exploration: {
              __typename?: 'ExplorationData';
              schemaVersion?: string | null;
              explorationId: string;
              name: string;
              description?: string | null;
              labels: any;
              parameters: Array<{
                __typename?: 'ExplorationParameter';
                key: string;
                modelId: string;
              }>;
              view: {
                __typename?: 'ExplorationView';
                canvas?: any | null;
                tabs?: any | null;
                options?: any | null;
                cells: Array<
                  | {
                      __typename?: 'ChatViewCell';
                      id: string;
                      kind: string;
                      viewOptions?: any | null;
                      messages: Array<{
                        __typename?: 'ChatCellMessage';
                        id: string;
                        role: string;
                        type: string;
                        message: string;
                      }>;
                    }
                  | {
                      __typename?: 'CohortViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'ConversationViewCell';
                      id: string;
                      kind: string;
                      conversationId: string;
                    }
                  | {
                      __typename?: 'FunnelViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'InvalidViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      message: string;
                      viewOptions?: any | null;
                      cell: any;
                    }
                  | {
                      __typename?: 'MetricViewCell';
                      id: string;
                      kind: string;
                      metricId: string;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'PythonViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'RecordsViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                          disabled?: boolean | null;
                        }>;
                      };
                      sort?: Array<{
                        __typename?: 'ExplorationViewCellSort';
                        key: string;
                        direction: string;
                      }> | null;
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'SqlViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'TextViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      content?: string | null;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'VariableViewCell';
                      id: string;
                      kind: string;
                      definition: any;
                      viewOptions?: any | null;
                    }
                >;
              };
            };
          }
        | {
            __typename?: 'ConversationTextMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            enabledSources?: any | null;
            research?: boolean | null;
            message: string;
            jobId?: string | null;
          }
      >;
      jobs: Array<{
        __typename?: 'ConversationJob';
        jobId: string;
        parentJobId?: string | null;
        channel?: string | null;
        createdAt: string;
        progress?: Array<{
          __typename?: 'ConversationJobProgress';
          jobProgressId: string;
          jobId: string;
          status?: string | null;
          statusMessage?: string | null;
          createdAt: string;
        } | null> | null;
      }>;
    };
  };
};

export type DeleteMessageMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
}>;

export type DeleteMessageMutation = {
  __typename?: 'Mutation';
  deleteMessage: {
    __typename?: 'ConversationMutationResponse';
    conversation: {
      __typename?: 'Conversation';
      conversationId: string;
      messages: Array<
        | {
            __typename?: 'ConversationExplorationMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            jobId?: string | null;
            exploration: {
              __typename?: 'ExplorationData';
              schemaVersion?: string | null;
              explorationId: string;
              name: string;
              description?: string | null;
              labels: any;
              parameters: Array<{
                __typename?: 'ExplorationParameter';
                key: string;
                modelId: string;
              }>;
              view: {
                __typename?: 'ExplorationView';
                canvas?: any | null;
                tabs?: any | null;
                options?: any | null;
                cells: Array<
                  | {
                      __typename?: 'ChatViewCell';
                      id: string;
                      kind: string;
                      viewOptions?: any | null;
                      messages: Array<{
                        __typename?: 'ChatCellMessage';
                        id: string;
                        role: string;
                        type: string;
                        message: string;
                      }>;
                    }
                  | {
                      __typename?: 'CohortViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'ConversationViewCell';
                      id: string;
                      kind: string;
                      conversationId: string;
                    }
                  | {
                      __typename?: 'FunnelViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'InvalidViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      message: string;
                      viewOptions?: any | null;
                      cell: any;
                    }
                  | {
                      __typename?: 'MetricViewCell';
                      id: string;
                      kind: string;
                      metricId: string;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'PythonViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'RecordsViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                          disabled?: boolean | null;
                        }>;
                      };
                      sort?: Array<{
                        __typename?: 'ExplorationViewCellSort';
                        key: string;
                        direction: string;
                      }> | null;
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'SqlViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'TextViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      content?: string | null;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'VariableViewCell';
                      id: string;
                      kind: string;
                      definition: any;
                      viewOptions?: any | null;
                    }
                >;
              };
            };
          }
        | {
            __typename?: 'ConversationTextMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            enabledSources?: any | null;
            research?: boolean | null;
            message: string;
            jobId?: string | null;
          }
      >;
      jobs: Array<{
        __typename?: 'ConversationJob';
        jobId: string;
        parentJobId?: string | null;
        channel?: string | null;
        createdAt: string;
        progress?: Array<{
          __typename?: 'ConversationJobProgress';
          jobProgressId: string;
          jobId: string;
          status?: string | null;
          statusMessage?: string | null;
          createdAt: string;
        } | null> | null;
      }>;
    };
  };
};

export type CancelConversationJobMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
}>;

export type CancelConversationJobMutation = {
  __typename?: 'Mutation';
  cancelConversationJob: {
    __typename?: 'ConversationMutationResponse';
    conversation: {
      __typename?: 'Conversation';
      conversationId: string;
      messages: Array<
        | {
            __typename?: 'ConversationExplorationMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            jobId?: string | null;
            exploration: {
              __typename?: 'ExplorationData';
              schemaVersion?: string | null;
              explorationId: string;
              name: string;
              description?: string | null;
              labels: any;
              parameters: Array<{
                __typename?: 'ExplorationParameter';
                key: string;
                modelId: string;
              }>;
              view: {
                __typename?: 'ExplorationView';
                canvas?: any | null;
                tabs?: any | null;
                options?: any | null;
                cells: Array<
                  | {
                      __typename?: 'ChatViewCell';
                      id: string;
                      kind: string;
                      viewOptions?: any | null;
                      messages: Array<{
                        __typename?: 'ChatCellMessage';
                        id: string;
                        role: string;
                        type: string;
                        message: string;
                      }>;
                    }
                  | {
                      __typename?: 'CohortViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'ConversationViewCell';
                      id: string;
                      kind: string;
                      conversationId: string;
                    }
                  | {
                      __typename?: 'FunnelViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'InvalidViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      message: string;
                      viewOptions?: any | null;
                      cell: any;
                    }
                  | {
                      __typename?: 'MetricViewCell';
                      id: string;
                      kind: string;
                      metricId: string;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'PythonViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'RecordsViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                          disabled?: boolean | null;
                        }>;
                      };
                      sort?: Array<{
                        __typename?: 'ExplorationViewCellSort';
                        key: string;
                        direction: string;
                      }> | null;
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'SqlViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'TextViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      content?: string | null;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'VariableViewCell';
                      id: string;
                      kind: string;
                      definition: any;
                      viewOptions?: any | null;
                    }
                >;
              };
            };
          }
        | {
            __typename?: 'ConversationTextMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            enabledSources?: any | null;
            research?: boolean | null;
            message: string;
            jobId?: string | null;
          }
      >;
      jobs: Array<{
        __typename?: 'ConversationJob';
        jobId: string;
        parentJobId?: string | null;
        channel?: string | null;
        createdAt: string;
        progress?: Array<{
          __typename?: 'ConversationJobProgress';
          jobProgressId: string;
          jobId: string;
          status?: string | null;
          statusMessage?: string | null;
          createdAt: string;
        } | null> | null;
      }>;
    };
  };
};

export type RerunConversationJobMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
  exploration?: InputMaybe<ExplorationInput>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  selectors?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type RerunConversationJobMutation = {
  __typename?: 'Mutation';
  rerunConversationJob: {
    __typename?: 'ConversationMutationResponse';
    conversation: {
      __typename?: 'Conversation';
      conversationId: string;
      messages: Array<
        | {
            __typename?: 'ConversationExplorationMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            jobId?: string | null;
            exploration: {
              __typename?: 'ExplorationData';
              schemaVersion?: string | null;
              explorationId: string;
              name: string;
              description?: string | null;
              labels: any;
              parameters: Array<{
                __typename?: 'ExplorationParameter';
                key: string;
                modelId: string;
              }>;
              view: {
                __typename?: 'ExplorationView';
                canvas?: any | null;
                tabs?: any | null;
                options?: any | null;
                cells: Array<
                  | {
                      __typename?: 'ChatViewCell';
                      id: string;
                      kind: string;
                      viewOptions?: any | null;
                      messages: Array<{
                        __typename?: 'ChatCellMessage';
                        id: string;
                        role: string;
                        type: string;
                        message: string;
                      }>;
                    }
                  | {
                      __typename?: 'CohortViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'ConversationViewCell';
                      id: string;
                      kind: string;
                      conversationId: string;
                    }
                  | {
                      __typename?: 'FunnelViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'InvalidViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      message: string;
                      viewOptions?: any | null;
                      cell: any;
                    }
                  | {
                      __typename?: 'MetricViewCell';
                      id: string;
                      kind: string;
                      metricId: string;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'PythonViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                    }
                  | {
                      __typename?: 'RecordsViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        parentId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                          disabled?: boolean | null;
                        }>;
                      };
                      sort?: Array<{
                        __typename?: 'ExplorationViewCellSort';
                        key: string;
                        direction: string;
                      }> | null;
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'SqlViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      excludeProperties?: Array<string> | null;
                      viewOptions?: any | null;
                      pipeline: {
                        __typename?: 'QueryPipeline';
                        baseModelId?: string | null;
                        pipelineId?: string | null;
                        operations: Array<{
                          __typename?: 'PipelineOperator';
                          operation: string;
                          parameters: any;
                        }>;
                      };
                      visualisations?: Array<{
                        __typename?: 'Visualisation';
                        aggregationType?: string | null;
                        aggregationTarget?: string | null;
                        groupByField?: string | null;
                        timeGranularity?: string | null;
                        viewOptions?: any | null;
                        aggregations?: any | null;
                        groups?: any | null;
                        aggregation?: any | null;
                        valueKeys?: Array<string> | null;
                        mainAxisKey?: string | null;
                        type?: string | null;
                        message?: string | null;
                        visualisation?: any | null;
                        sort?: Array<{
                          __typename?: 'ExplorationViewCellSort';
                          key: string;
                          direction: string;
                        } | null> | null;
                      }> | null;
                    }
                  | {
                      __typename?: 'TextViewCell';
                      id: string;
                      kind: string;
                      title?: string | null;
                      content?: string | null;
                      viewOptions?: any | null;
                    }
                  | {
                      __typename?: 'VariableViewCell';
                      id: string;
                      kind: string;
                      definition: any;
                      viewOptions?: any | null;
                    }
                >;
              };
            };
          }
        | {
            __typename?: 'ConversationTextMessage';
            id: string;
            role: ConversationMessageRole;
            type: ConversationMessageType;
            enabledSources?: any | null;
            research?: boolean | null;
            message: string;
            jobId?: string | null;
          }
      >;
      jobs: Array<{
        __typename?: 'ConversationJob';
        jobId: string;
        parentJobId?: string | null;
        channel?: string | null;
        createdAt: string;
        progress?: Array<{
          __typename?: 'ConversationJobProgress';
          jobProgressId: string;
          jobId: string;
          status?: string | null;
          statusMessage?: string | null;
          createdAt: string;
        } | null> | null;
      }>;
    };
  };
};

export type ExecutePythonCellMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  dataContext: Scalars['JSON']['input'];
}>;

export type ExecutePythonCellMutation = {
  __typename?: 'Mutation';
  executePythonCell: { __typename?: 'PythonExecutionResult'; result?: any | null; logs: any };
};

export type ExplorationDataFragmentFragment = {
  __typename?: 'ExplorationData';
  schemaVersion?: string | null;
  explorationId: string;
  name: string;
  description?: string | null;
  labels: any;
  parameters: Array<{ __typename?: 'ExplorationParameter'; key: string; modelId: string }>;
  view: {
    __typename?: 'ExplorationView';
    canvas?: any | null;
    tabs?: any | null;
    options?: any | null;
    cells: Array<
      | {
          __typename?: 'ChatViewCell';
          id: string;
          kind: string;
          viewOptions?: any | null;
          messages: Array<{
            __typename?: 'ChatCellMessage';
            id: string;
            role: string;
            type: string;
            message: string;
          }>;
        }
      | {
          __typename?: 'CohortViewCell';
          id: string;
          kind: string;
          title?: string | null;
          viewOptions?: any | null;
          pipeline: {
            __typename?: 'QueryPipeline';
            baseModelId?: string | null;
            pipelineId?: string | null;
            parentId?: string | null;
            operations: Array<{
              __typename?: 'PipelineOperator';
              operation: string;
              parameters: any;
            }>;
          };
        }
      | { __typename?: 'ConversationViewCell'; id: string; kind: string; conversationId: string }
      | {
          __typename?: 'FunnelViewCell';
          id: string;
          kind: string;
          title?: string | null;
          viewOptions?: any | null;
          pipeline: {
            __typename?: 'QueryPipeline';
            baseModelId?: string | null;
            pipelineId?: string | null;
            operations: Array<{
              __typename?: 'PipelineOperator';
              operation: string;
              parameters: any;
            }>;
          };
        }
      | {
          __typename?: 'InvalidViewCell';
          id: string;
          kind: string;
          title?: string | null;
          message: string;
          viewOptions?: any | null;
          cell: any;
        }
      | {
          __typename?: 'MetricViewCell';
          id: string;
          kind: string;
          metricId: string;
          viewOptions?: any | null;
        }
      | {
          __typename?: 'PythonViewCell';
          id: string;
          kind: string;
          title?: string | null;
          viewOptions?: any | null;
          pipeline: {
            __typename?: 'QueryPipeline';
            baseModelId?: string | null;
            pipelineId?: string | null;
            operations: Array<{
              __typename?: 'PipelineOperator';
              operation: string;
              parameters: any;
            }>;
          };
        }
      | {
          __typename?: 'RecordsViewCell';
          id: string;
          kind: string;
          title?: string | null;
          excludeProperties?: Array<string> | null;
          viewOptions?: any | null;
          pipeline: {
            __typename?: 'QueryPipeline';
            baseModelId?: string | null;
            pipelineId?: string | null;
            parentId?: string | null;
            operations: Array<{
              __typename?: 'PipelineOperator';
              operation: string;
              parameters: any;
              disabled?: boolean | null;
            }>;
          };
          sort?: Array<{
            __typename?: 'ExplorationViewCellSort';
            key: string;
            direction: string;
          }> | null;
          visualisations?: Array<{
            __typename?: 'Visualisation';
            aggregationType?: string | null;
            aggregationTarget?: string | null;
            groupByField?: string | null;
            timeGranularity?: string | null;
            viewOptions?: any | null;
            aggregations?: any | null;
            groups?: any | null;
            aggregation?: any | null;
            valueKeys?: Array<string> | null;
            mainAxisKey?: string | null;
            type?: string | null;
            message?: string | null;
            visualisation?: any | null;
            sort?: Array<{
              __typename?: 'ExplorationViewCellSort';
              key: string;
              direction: string;
            } | null> | null;
          }> | null;
        }
      | {
          __typename?: 'SqlViewCell';
          id: string;
          kind: string;
          title?: string | null;
          excludeProperties?: Array<string> | null;
          viewOptions?: any | null;
          pipeline: {
            __typename?: 'QueryPipeline';
            baseModelId?: string | null;
            pipelineId?: string | null;
            operations: Array<{
              __typename?: 'PipelineOperator';
              operation: string;
              parameters: any;
            }>;
          };
          visualisations?: Array<{
            __typename?: 'Visualisation';
            aggregationType?: string | null;
            aggregationTarget?: string | null;
            groupByField?: string | null;
            timeGranularity?: string | null;
            viewOptions?: any | null;
            aggregations?: any | null;
            groups?: any | null;
            aggregation?: any | null;
            valueKeys?: Array<string> | null;
            mainAxisKey?: string | null;
            type?: string | null;
            message?: string | null;
            visualisation?: any | null;
            sort?: Array<{
              __typename?: 'ExplorationViewCellSort';
              key: string;
              direction: string;
            } | null> | null;
          }> | null;
        }
      | {
          __typename?: 'TextViewCell';
          id: string;
          kind: string;
          title?: string | null;
          content?: string | null;
          viewOptions?: any | null;
        }
      | {
          __typename?: 'VariableViewCell';
          id: string;
          kind: string;
          definition: any;
          viewOptions?: any | null;
        }
    >;
  };
};

export type ExplorationsSearchQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
}>;

export type ExplorationsSearchQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    explorationSearch: Array<{
      __typename?: 'ExplorationData';
      schemaVersion?: string | null;
      explorationId: string;
      name: string;
      description?: string | null;
      labels: any;
      parameters: Array<{ __typename?: 'ExplorationParameter'; key: string; modelId: string }>;
      view: {
        __typename?: 'ExplorationView';
        canvas?: any | null;
        tabs?: any | null;
        options?: any | null;
        cells: Array<
          | {
              __typename?: 'ChatViewCell';
              id: string;
              kind: string;
              viewOptions?: any | null;
              messages: Array<{
                __typename?: 'ChatCellMessage';
                id: string;
                role: string;
                type: string;
                message: string;
              }>;
            }
          | {
              __typename?: 'CohortViewCell';
              id: string;
              kind: string;
              title?: string | null;
              viewOptions?: any | null;
              pipeline: {
                __typename?: 'QueryPipeline';
                baseModelId?: string | null;
                pipelineId?: string | null;
                parentId?: string | null;
                operations: Array<{
                  __typename?: 'PipelineOperator';
                  operation: string;
                  parameters: any;
                }>;
              };
            }
          | {
              __typename?: 'ConversationViewCell';
              id: string;
              kind: string;
              conversationId: string;
            }
          | {
              __typename?: 'FunnelViewCell';
              id: string;
              kind: string;
              title?: string | null;
              viewOptions?: any | null;
              pipeline: {
                __typename?: 'QueryPipeline';
                baseModelId?: string | null;
                pipelineId?: string | null;
                operations: Array<{
                  __typename?: 'PipelineOperator';
                  operation: string;
                  parameters: any;
                }>;
              };
            }
          | {
              __typename?: 'InvalidViewCell';
              id: string;
              kind: string;
              title?: string | null;
              message: string;
              viewOptions?: any | null;
              cell: any;
            }
          | {
              __typename?: 'MetricViewCell';
              id: string;
              kind: string;
              metricId: string;
              viewOptions?: any | null;
            }
          | {
              __typename?: 'PythonViewCell';
              id: string;
              kind: string;
              title?: string | null;
              viewOptions?: any | null;
              pipeline: {
                __typename?: 'QueryPipeline';
                baseModelId?: string | null;
                pipelineId?: string | null;
                operations: Array<{
                  __typename?: 'PipelineOperator';
                  operation: string;
                  parameters: any;
                }>;
              };
            }
          | {
              __typename?: 'RecordsViewCell';
              id: string;
              kind: string;
              title?: string | null;
              excludeProperties?: Array<string> | null;
              viewOptions?: any | null;
              pipeline: {
                __typename?: 'QueryPipeline';
                baseModelId?: string | null;
                pipelineId?: string | null;
                parentId?: string | null;
                operations: Array<{
                  __typename?: 'PipelineOperator';
                  operation: string;
                  parameters: any;
                  disabled?: boolean | null;
                }>;
              };
              sort?: Array<{
                __typename?: 'ExplorationViewCellSort';
                key: string;
                direction: string;
              }> | null;
              visualisations?: Array<{
                __typename?: 'Visualisation';
                aggregationType?: string | null;
                aggregationTarget?: string | null;
                groupByField?: string | null;
                timeGranularity?: string | null;
                viewOptions?: any | null;
                aggregations?: any | null;
                groups?: any | null;
                aggregation?: any | null;
                valueKeys?: Array<string> | null;
                mainAxisKey?: string | null;
                type?: string | null;
                message?: string | null;
                visualisation?: any | null;
                sort?: Array<{
                  __typename?: 'ExplorationViewCellSort';
                  key: string;
                  direction: string;
                } | null> | null;
              }> | null;
            }
          | {
              __typename?: 'SqlViewCell';
              id: string;
              kind: string;
              title?: string | null;
              excludeProperties?: Array<string> | null;
              viewOptions?: any | null;
              pipeline: {
                __typename?: 'QueryPipeline';
                baseModelId?: string | null;
                pipelineId?: string | null;
                operations: Array<{
                  __typename?: 'PipelineOperator';
                  operation: string;
                  parameters: any;
                }>;
              };
              visualisations?: Array<{
                __typename?: 'Visualisation';
                aggregationType?: string | null;
                aggregationTarget?: string | null;
                groupByField?: string | null;
                timeGranularity?: string | null;
                viewOptions?: any | null;
                aggregations?: any | null;
                groups?: any | null;
                aggregation?: any | null;
                valueKeys?: Array<string> | null;
                mainAxisKey?: string | null;
                type?: string | null;
                message?: string | null;
                visualisation?: any | null;
                sort?: Array<{
                  __typename?: 'ExplorationViewCellSort';
                  key: string;
                  direction: string;
                } | null> | null;
              }> | null;
            }
          | {
              __typename?: 'TextViewCell';
              id: string;
              kind: string;
              title?: string | null;
              content?: string | null;
              viewOptions?: any | null;
            }
          | {
              __typename?: 'VariableViewCell';
              id: string;
              kind: string;
              definition: any;
              viewOptions?: any | null;
            }
        >;
      };
    }>;
  } | null;
};

export type ExplorationFragmentFragment = {
  __typename?: 'Exploration';
  schemaVersion?: string | null;
  explorationId: string;
  name: string;
  description?: string | null;
  labels: any;
  createdAt: string;
  updatedAt: string;
  createdBy: { __typename?: 'UserProfile'; email: string };
  updatedBy: { __typename?: 'UserProfile'; email: string };
  parameters: Array<{ __typename?: 'ExplorationParameter'; key: string; modelId: string }>;
  view: {
    __typename?: 'ExplorationView';
    canvas?: any | null;
    tabs?: any | null;
    options?: any | null;
    cells: Array<
      | {
          __typename?: 'ChatViewCell';
          id: string;
          kind: string;
          viewOptions?: any | null;
          messages: Array<{
            __typename?: 'ChatCellMessage';
            id: string;
            role: string;
            type: string;
            message: string;
          }>;
        }
      | {
          __typename?: 'CohortViewCell';
          id: string;
          kind: string;
          title?: string | null;
          viewOptions?: any | null;
          pipeline: {
            __typename?: 'QueryPipeline';
            baseModelId?: string | null;
            pipelineId?: string | null;
            parentId?: string | null;
            operations: Array<{
              __typename?: 'PipelineOperator';
              operation: string;
              parameters: any;
            }>;
          };
        }
      | { __typename?: 'ConversationViewCell'; id: string; kind: string; conversationId: string }
      | {
          __typename?: 'FunnelViewCell';
          id: string;
          kind: string;
          title?: string | null;
          viewOptions?: any | null;
          pipeline: {
            __typename?: 'QueryPipeline';
            baseModelId?: string | null;
            pipelineId?: string | null;
            operations: Array<{
              __typename?: 'PipelineOperator';
              operation: string;
              parameters: any;
            }>;
          };
        }
      | {
          __typename?: 'InvalidViewCell';
          id: string;
          kind: string;
          title?: string | null;
          message: string;
          viewOptions?: any | null;
          cell: any;
        }
      | {
          __typename?: 'MetricViewCell';
          id: string;
          kind: string;
          metricId: string;
          viewOptions?: any | null;
        }
      | {
          __typename?: 'PythonViewCell';
          id: string;
          kind: string;
          title?: string | null;
          viewOptions?: any | null;
          pipeline: {
            __typename?: 'QueryPipeline';
            baseModelId?: string | null;
            pipelineId?: string | null;
            operations: Array<{
              __typename?: 'PipelineOperator';
              operation: string;
              parameters: any;
            }>;
          };
        }
      | {
          __typename?: 'RecordsViewCell';
          id: string;
          kind: string;
          title?: string | null;
          excludeProperties?: Array<string> | null;
          viewOptions?: any | null;
          pipeline: {
            __typename?: 'QueryPipeline';
            baseModelId?: string | null;
            pipelineId?: string | null;
            parentId?: string | null;
            operations: Array<{
              __typename?: 'PipelineOperator';
              operation: string;
              parameters: any;
              disabled?: boolean | null;
            }>;
          };
          sort?: Array<{
            __typename?: 'ExplorationViewCellSort';
            key: string;
            direction: string;
          }> | null;
          visualisations?: Array<{
            __typename?: 'Visualisation';
            aggregationType?: string | null;
            aggregationTarget?: string | null;
            groupByField?: string | null;
            timeGranularity?: string | null;
            viewOptions?: any | null;
            aggregations?: any | null;
            groups?: any | null;
            aggregation?: any | null;
            valueKeys?: Array<string> | null;
            mainAxisKey?: string | null;
            type?: string | null;
            message?: string | null;
            visualisation?: any | null;
            sort?: Array<{
              __typename?: 'ExplorationViewCellSort';
              key: string;
              direction: string;
            } | null> | null;
          }> | null;
        }
      | {
          __typename?: 'SqlViewCell';
          id: string;
          kind: string;
          title?: string | null;
          excludeProperties?: Array<string> | null;
          viewOptions?: any | null;
          pipeline: {
            __typename?: 'QueryPipeline';
            baseModelId?: string | null;
            pipelineId?: string | null;
            operations: Array<{
              __typename?: 'PipelineOperator';
              operation: string;
              parameters: any;
            }>;
          };
          visualisations?: Array<{
            __typename?: 'Visualisation';
            aggregationType?: string | null;
            aggregationTarget?: string | null;
            groupByField?: string | null;
            timeGranularity?: string | null;
            viewOptions?: any | null;
            aggregations?: any | null;
            groups?: any | null;
            aggregation?: any | null;
            valueKeys?: Array<string> | null;
            mainAxisKey?: string | null;
            type?: string | null;
            message?: string | null;
            visualisation?: any | null;
            sort?: Array<{
              __typename?: 'ExplorationViewCellSort';
              key: string;
              direction: string;
            } | null> | null;
          }> | null;
        }
      | {
          __typename?: 'TextViewCell';
          id: string;
          kind: string;
          title?: string | null;
          content?: string | null;
          viewOptions?: any | null;
        }
      | {
          __typename?: 'VariableViewCell';
          id: string;
          kind: string;
          definition: any;
          viewOptions?: any | null;
        }
    >;
  };
};

export type ExplorationQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  explorationId: Scalars['ID']['input'];
}>;

export type ExplorationQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    exploration?: {
      __typename?: 'Exploration';
      schemaVersion?: string | null;
      explorationId: string;
      name: string;
      description?: string | null;
      labels: any;
      createdAt: string;
      updatedAt: string;
      createdBy: { __typename?: 'UserProfile'; email: string };
      updatedBy: { __typename?: 'UserProfile'; email: string };
      parameters: Array<{ __typename?: 'ExplorationParameter'; key: string; modelId: string }>;
      view: {
        __typename?: 'ExplorationView';
        canvas?: any | null;
        tabs?: any | null;
        options?: any | null;
        cells: Array<
          | {
              __typename?: 'ChatViewCell';
              id: string;
              kind: string;
              viewOptions?: any | null;
              messages: Array<{
                __typename?: 'ChatCellMessage';
                id: string;
                role: string;
                type: string;
                message: string;
              }>;
            }
          | {
              __typename?: 'CohortViewCell';
              id: string;
              kind: string;
              title?: string | null;
              viewOptions?: any | null;
              pipeline: {
                __typename?: 'QueryPipeline';
                baseModelId?: string | null;
                pipelineId?: string | null;
                parentId?: string | null;
                operations: Array<{
                  __typename?: 'PipelineOperator';
                  operation: string;
                  parameters: any;
                }>;
              };
            }
          | {
              __typename?: 'ConversationViewCell';
              id: string;
              kind: string;
              conversationId: string;
            }
          | {
              __typename?: 'FunnelViewCell';
              id: string;
              kind: string;
              title?: string | null;
              viewOptions?: any | null;
              pipeline: {
                __typename?: 'QueryPipeline';
                baseModelId?: string | null;
                pipelineId?: string | null;
                operations: Array<{
                  __typename?: 'PipelineOperator';
                  operation: string;
                  parameters: any;
                }>;
              };
            }
          | {
              __typename?: 'InvalidViewCell';
              id: string;
              kind: string;
              title?: string | null;
              message: string;
              viewOptions?: any | null;
              cell: any;
            }
          | {
              __typename?: 'MetricViewCell';
              id: string;
              kind: string;
              metricId: string;
              viewOptions?: any | null;
            }
          | {
              __typename?: 'PythonViewCell';
              id: string;
              kind: string;
              title?: string | null;
              viewOptions?: any | null;
              pipeline: {
                __typename?: 'QueryPipeline';
                baseModelId?: string | null;
                pipelineId?: string | null;
                operations: Array<{
                  __typename?: 'PipelineOperator';
                  operation: string;
                  parameters: any;
                }>;
              };
            }
          | {
              __typename?: 'RecordsViewCell';
              id: string;
              kind: string;
              title?: string | null;
              excludeProperties?: Array<string> | null;
              viewOptions?: any | null;
              pipeline: {
                __typename?: 'QueryPipeline';
                baseModelId?: string | null;
                pipelineId?: string | null;
                parentId?: string | null;
                operations: Array<{
                  __typename?: 'PipelineOperator';
                  operation: string;
                  parameters: any;
                  disabled?: boolean | null;
                }>;
              };
              sort?: Array<{
                __typename?: 'ExplorationViewCellSort';
                key: string;
                direction: string;
              }> | null;
              visualisations?: Array<{
                __typename?: 'Visualisation';
                aggregationType?: string | null;
                aggregationTarget?: string | null;
                groupByField?: string | null;
                timeGranularity?: string | null;
                viewOptions?: any | null;
                aggregations?: any | null;
                groups?: any | null;
                aggregation?: any | null;
                valueKeys?: Array<string> | null;
                mainAxisKey?: string | null;
                type?: string | null;
                message?: string | null;
                visualisation?: any | null;
                sort?: Array<{
                  __typename?: 'ExplorationViewCellSort';
                  key: string;
                  direction: string;
                } | null> | null;
              }> | null;
            }
          | {
              __typename?: 'SqlViewCell';
              id: string;
              kind: string;
              title?: string | null;
              excludeProperties?: Array<string> | null;
              viewOptions?: any | null;
              pipeline: {
                __typename?: 'QueryPipeline';
                baseModelId?: string | null;
                pipelineId?: string | null;
                operations: Array<{
                  __typename?: 'PipelineOperator';
                  operation: string;
                  parameters: any;
                }>;
              };
              visualisations?: Array<{
                __typename?: 'Visualisation';
                aggregationType?: string | null;
                aggregationTarget?: string | null;
                groupByField?: string | null;
                timeGranularity?: string | null;
                viewOptions?: any | null;
                aggregations?: any | null;
                groups?: any | null;
                aggregation?: any | null;
                valueKeys?: Array<string> | null;
                mainAxisKey?: string | null;
                type?: string | null;
                message?: string | null;
                visualisation?: any | null;
                sort?: Array<{
                  __typename?: 'ExplorationViewCellSort';
                  key: string;
                  direction: string;
                } | null> | null;
              }> | null;
            }
          | {
              __typename?: 'TextViewCell';
              id: string;
              kind: string;
              title?: string | null;
              content?: string | null;
              viewOptions?: any | null;
            }
          | {
              __typename?: 'VariableViewCell';
              id: string;
              kind: string;
              definition: any;
              viewOptions?: any | null;
            }
        >;
      };
    } | null;
  } | null;
};

export type StreamPipelineSubscriptionVariables = Exact<{
  input: StreamPipelineInput;
}>;

export type StreamPipelineSubscription = {
  __typename?: 'Subscription';
  streamPipeline: {
    __typename?: 'StreamPipelinePayload';
    rows: Array<any>;
    rowCount: number;
    totalRows?: number | null;
    recordType?: Array<{
      __typename?: 'QueryResponseRecordType';
      key: string;
      type: string;
      name: string;
      pk?: boolean | null;
      precision?: string | null;
      model?: {
        __typename?: 'QueryResponseRecordModel';
        modelId: string;
        name: string;
        propertyKey: string;
      } | null;
      relation?: {
        __typename?: 'QueryResponseRecordRelation';
        modelId: string;
        key: string;
        name: string;
      } | null;
    }> | null;
    grouping?: Array<{ __typename?: 'QueryResponseGrouping'; key: string }> | null;
  };
};

export type DeleteExplorationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  explorationId: Scalars['ID']['input'];
}>;

export type DeleteExplorationMutation = {
  __typename?: 'Mutation';
  deleteExploration:
    | { __typename?: 'DeleteExplorationSuccess'; result: boolean }
    | { __typename?: 'NotAllowedError'; message: string };
};

export type EnumOptionsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  modelId: Scalars['ID']['input'];
  propertyKey: Scalars['String']['input'];
}>;

export type EnumOptionsQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    model?: {
      __typename?: 'Model';
      modelId: string;
      property?: {
        __typename?: 'ModelProperty';
        key: string;
        enumOptions?: Array<{
          __typename?: 'ModelPropertyEnumOption';
          label: string;
          value: string;
        }> | null;
      } | null;
    } | null;
  } | null;
};

export type ExplorationChatSubscriptionVariables = Exact<{
  accountId: Scalars['ID']['input'];
  conversation: ConversationInput;
  exploration?: InputMaybe<ExplorationInput>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  selectors?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type ExplorationChatSubscription = {
  __typename?: 'Subscription';
  ask: {
    __typename?: 'ConversationSubscriptionResponse';
    lastMessage:
      | {
          __typename?: 'ConversationExplorationMessage';
          id: string;
          role: ConversationMessageRole;
          type: ConversationMessageType;
          exploration: {
            __typename?: 'ExplorationData';
            schemaVersion?: string | null;
            explorationId: string;
            name: string;
            description?: string | null;
            labels: any;
            parameters: Array<{
              __typename?: 'ExplorationParameter';
              key: string;
              modelId: string;
            }>;
            view: {
              __typename?: 'ExplorationView';
              canvas?: any | null;
              tabs?: any | null;
              options?: any | null;
              cells: Array<
                | {
                    __typename?: 'ChatViewCell';
                    id: string;
                    kind: string;
                    viewOptions?: any | null;
                    messages: Array<{
                      __typename?: 'ChatCellMessage';
                      id: string;
                      role: string;
                      type: string;
                      message: string;
                    }>;
                  }
                | {
                    __typename?: 'CohortViewCell';
                    id: string;
                    kind: string;
                    title?: string | null;
                    viewOptions?: any | null;
                    pipeline: {
                      __typename?: 'QueryPipeline';
                      baseModelId?: string | null;
                      pipelineId?: string | null;
                      parentId?: string | null;
                      operations: Array<{
                        __typename?: 'PipelineOperator';
                        operation: string;
                        parameters: any;
                      }>;
                    };
                  }
                | {
                    __typename?: 'ConversationViewCell';
                    id: string;
                    kind: string;
                    conversationId: string;
                  }
                | {
                    __typename?: 'FunnelViewCell';
                    id: string;
                    kind: string;
                    title?: string | null;
                    viewOptions?: any | null;
                    pipeline: {
                      __typename?: 'QueryPipeline';
                      baseModelId?: string | null;
                      pipelineId?: string | null;
                      operations: Array<{
                        __typename?: 'PipelineOperator';
                        operation: string;
                        parameters: any;
                      }>;
                    };
                  }
                | {
                    __typename?: 'InvalidViewCell';
                    id: string;
                    kind: string;
                    title?: string | null;
                    message: string;
                    viewOptions?: any | null;
                    cell: any;
                  }
                | {
                    __typename?: 'MetricViewCell';
                    id: string;
                    kind: string;
                    metricId: string;
                    viewOptions?: any | null;
                  }
                | {
                    __typename?: 'PythonViewCell';
                    id: string;
                    kind: string;
                    title?: string | null;
                    viewOptions?: any | null;
                    pipeline: {
                      __typename?: 'QueryPipeline';
                      baseModelId?: string | null;
                      pipelineId?: string | null;
                      operations: Array<{
                        __typename?: 'PipelineOperator';
                        operation: string;
                        parameters: any;
                      }>;
                    };
                  }
                | {
                    __typename?: 'RecordsViewCell';
                    id: string;
                    kind: string;
                    title?: string | null;
                    excludeProperties?: Array<string> | null;
                    viewOptions?: any | null;
                    pipeline: {
                      __typename?: 'QueryPipeline';
                      baseModelId?: string | null;
                      pipelineId?: string | null;
                      parentId?: string | null;
                      operations: Array<{
                        __typename?: 'PipelineOperator';
                        operation: string;
                        parameters: any;
                        disabled?: boolean | null;
                      }>;
                    };
                    sort?: Array<{
                      __typename?: 'ExplorationViewCellSort';
                      key: string;
                      direction: string;
                    }> | null;
                    visualisations?: Array<{
                      __typename?: 'Visualisation';
                      aggregationType?: string | null;
                      aggregationTarget?: string | null;
                      groupByField?: string | null;
                      timeGranularity?: string | null;
                      viewOptions?: any | null;
                      aggregations?: any | null;
                      groups?: any | null;
                      aggregation?: any | null;
                      valueKeys?: Array<string> | null;
                      mainAxisKey?: string | null;
                      type?: string | null;
                      message?: string | null;
                      visualisation?: any | null;
                      sort?: Array<{
                        __typename?: 'ExplorationViewCellSort';
                        key: string;
                        direction: string;
                      } | null> | null;
                    }> | null;
                  }
                | {
                    __typename?: 'SqlViewCell';
                    id: string;
                    kind: string;
                    title?: string | null;
                    excludeProperties?: Array<string> | null;
                    viewOptions?: any | null;
                    pipeline: {
                      __typename?: 'QueryPipeline';
                      baseModelId?: string | null;
                      pipelineId?: string | null;
                      operations: Array<{
                        __typename?: 'PipelineOperator';
                        operation: string;
                        parameters: any;
                      }>;
                    };
                    visualisations?: Array<{
                      __typename?: 'Visualisation';
                      aggregationType?: string | null;
                      aggregationTarget?: string | null;
                      groupByField?: string | null;
                      timeGranularity?: string | null;
                      viewOptions?: any | null;
                      aggregations?: any | null;
                      groups?: any | null;
                      aggregation?: any | null;
                      valueKeys?: Array<string> | null;
                      mainAxisKey?: string | null;
                      type?: string | null;
                      message?: string | null;
                      visualisation?: any | null;
                      sort?: Array<{
                        __typename?: 'ExplorationViewCellSort';
                        key: string;
                        direction: string;
                      } | null> | null;
                    }> | null;
                  }
                | {
                    __typename?: 'TextViewCell';
                    id: string;
                    kind: string;
                    title?: string | null;
                    content?: string | null;
                    viewOptions?: any | null;
                  }
                | {
                    __typename?: 'VariableViewCell';
                    id: string;
                    kind: string;
                    definition: any;
                    viewOptions?: any | null;
                  }
              >;
            };
          };
        }
      | {
          __typename?: 'ConversationTextMessage';
          id: string;
          role: ConversationMessageRole;
          type: ConversationMessageType;
          message: string;
        };
  };
};

export type ExplorationDataQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  baseModelId: Scalars['ID']['input'];
  pipeline: Array<OperationInput> | OperationInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<QuerySortBy> | QuerySortBy>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
  options?: InputMaybe<QueryOptionsInput>;
}>;

export type ExplorationDataQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    name: string;
    query: {
      __typename?: 'QueryResponseConnection';
      edges: Array<{ __typename?: 'QueryResponseEdge'; node: any }>;
      pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
      recordType: Array<{
        __typename?: 'QueryResponseRecordType';
        key: string;
        type: string;
        name: string;
        pk?: boolean | null;
        precision?: string | null;
        model?: {
          __typename?: 'QueryResponseRecordModel';
          modelId: string;
          name: string;
          propertyKey: string;
        } | null;
        relation?: {
          __typename?: 'QueryResponseRecordRelation';
          modelId: string;
          key: string;
          name: string;
        } | null;
      }>;
      grouping: Array<{ __typename?: 'QueryResponseGrouping'; key: string }>;
    };
  } | null;
};

export type ExplorationDescribeQueryQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  baseModelId: Scalars['ID']['input'];
  pipeline: Array<OperationInput> | OperationInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<QuerySortBy> | QuerySortBy>;
  variables?: InputMaybe<Scalars['JSON']['input']>;
  options?: InputMaybe<QueryOptionsInput>;
}>;

export type ExplorationDescribeQueryQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    name: string;
    describeQuery: { __typename?: 'DescribeQueryResponse'; sql: string };
  } | null;
};

export type ToggleUserPinnedExplorationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  explorationId: Scalars['ID']['input'];
}>;

export type ToggleUserPinnedExplorationMutation = {
  __typename?: 'Mutation';
  toggleUserPinnedExploration: {
    __typename?: 'AccountUser';
    userId: string;
    pinnedExplorationIds: Array<string>;
  };
};

export type UpsertExplorationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: ExplorationInput;
}>;

export type UpsertExplorationMutation = {
  __typename?: 'Mutation';
  upsertExploration: {
    __typename?: 'Exploration';
    schemaVersion?: string | null;
    explorationId: string;
    name: string;
    description?: string | null;
    labels: any;
    createdAt: string;
    updatedAt: string;
    createdBy: { __typename?: 'UserProfile'; email: string };
    updatedBy: { __typename?: 'UserProfile'; email: string };
    parameters: Array<{ __typename?: 'ExplorationParameter'; key: string; modelId: string }>;
    view: {
      __typename?: 'ExplorationView';
      canvas?: any | null;
      tabs?: any | null;
      options?: any | null;
      cells: Array<
        | {
            __typename?: 'ChatViewCell';
            id: string;
            kind: string;
            viewOptions?: any | null;
            messages: Array<{
              __typename?: 'ChatCellMessage';
              id: string;
              role: string;
              type: string;
              message: string;
            }>;
          }
        | {
            __typename?: 'CohortViewCell';
            id: string;
            kind: string;
            title?: string | null;
            viewOptions?: any | null;
            pipeline: {
              __typename?: 'QueryPipeline';
              baseModelId?: string | null;
              pipelineId?: string | null;
              parentId?: string | null;
              operations: Array<{
                __typename?: 'PipelineOperator';
                operation: string;
                parameters: any;
              }>;
            };
          }
        | { __typename?: 'ConversationViewCell'; id: string; kind: string; conversationId: string }
        | {
            __typename?: 'FunnelViewCell';
            id: string;
            kind: string;
            title?: string | null;
            viewOptions?: any | null;
            pipeline: {
              __typename?: 'QueryPipeline';
              baseModelId?: string | null;
              pipelineId?: string | null;
              operations: Array<{
                __typename?: 'PipelineOperator';
                operation: string;
                parameters: any;
              }>;
            };
          }
        | {
            __typename?: 'InvalidViewCell';
            id: string;
            kind: string;
            title?: string | null;
            message: string;
            viewOptions?: any | null;
            cell: any;
          }
        | {
            __typename?: 'MetricViewCell';
            id: string;
            kind: string;
            metricId: string;
            viewOptions?: any | null;
          }
        | {
            __typename?: 'PythonViewCell';
            id: string;
            kind: string;
            title?: string | null;
            viewOptions?: any | null;
            pipeline: {
              __typename?: 'QueryPipeline';
              baseModelId?: string | null;
              pipelineId?: string | null;
              operations: Array<{
                __typename?: 'PipelineOperator';
                operation: string;
                parameters: any;
              }>;
            };
          }
        | {
            __typename?: 'RecordsViewCell';
            id: string;
            kind: string;
            title?: string | null;
            excludeProperties?: Array<string> | null;
            viewOptions?: any | null;
            pipeline: {
              __typename?: 'QueryPipeline';
              baseModelId?: string | null;
              pipelineId?: string | null;
              parentId?: string | null;
              operations: Array<{
                __typename?: 'PipelineOperator';
                operation: string;
                parameters: any;
                disabled?: boolean | null;
              }>;
            };
            sort?: Array<{
              __typename?: 'ExplorationViewCellSort';
              key: string;
              direction: string;
            }> | null;
            visualisations?: Array<{
              __typename?: 'Visualisation';
              aggregationType?: string | null;
              aggregationTarget?: string | null;
              groupByField?: string | null;
              timeGranularity?: string | null;
              viewOptions?: any | null;
              aggregations?: any | null;
              groups?: any | null;
              aggregation?: any | null;
              valueKeys?: Array<string> | null;
              mainAxisKey?: string | null;
              type?: string | null;
              message?: string | null;
              visualisation?: any | null;
              sort?: Array<{
                __typename?: 'ExplorationViewCellSort';
                key: string;
                direction: string;
              } | null> | null;
            }> | null;
          }
        | {
            __typename?: 'SqlViewCell';
            id: string;
            kind: string;
            title?: string | null;
            excludeProperties?: Array<string> | null;
            viewOptions?: any | null;
            pipeline: {
              __typename?: 'QueryPipeline';
              baseModelId?: string | null;
              pipelineId?: string | null;
              operations: Array<{
                __typename?: 'PipelineOperator';
                operation: string;
                parameters: any;
              }>;
            };
            visualisations?: Array<{
              __typename?: 'Visualisation';
              aggregationType?: string | null;
              aggregationTarget?: string | null;
              groupByField?: string | null;
              timeGranularity?: string | null;
              viewOptions?: any | null;
              aggregations?: any | null;
              groups?: any | null;
              aggregation?: any | null;
              valueKeys?: Array<string> | null;
              mainAxisKey?: string | null;
              type?: string | null;
              message?: string | null;
              visualisation?: any | null;
              sort?: Array<{
                __typename?: 'ExplorationViewCellSort';
                key: string;
                direction: string;
              } | null> | null;
            }> | null;
          }
        | {
            __typename?: 'TextViewCell';
            id: string;
            kind: string;
            title?: string | null;
            content?: string | null;
            viewOptions?: any | null;
          }
        | {
            __typename?: 'VariableViewCell';
            id: string;
            kind: string;
            definition: any;
            viewOptions?: any | null;
          }
      >;
    };
  };
};

export type MetricFragmentFragment = {
  __typename?: 'Metric';
  metricId: string;
  name: string;
  description?: string | null;
  definition: any;
};

export type ModelFragmentFragment = {
  __typename?: 'Model';
  modelId: string;
  name: string;
  description?: string | null;
  primaryKey: Array<string>;
  labels: any;
  semantics?: any | null;
  properties: Array<{
    __typename?: 'ModelProperty';
    name: string;
    type: string;
    key: string;
    format?: string | null;
    precision?: string | null;
    description?: string | null;
  }>;
  relations: Array<{
    __typename?: 'ModelRelation';
    key: string;
    modelId: string;
    type: string;
    name: string;
    description?: string | null;
    joinStrategy: {
      __typename?: 'ModelRelationJoinStrategy';
      joinKeyOnBase?: string | null;
      joinKeyOnRelated?: string | null;
      sql?: string | null;
      through?: {
        __typename?: 'ModelRelationJoinStrategyThrough';
        modelId: string;
        joinKeyToBase?: string | null;
        joinKeyToRelated?: string | null;
      } | null;
      steps?: Array<{ __typename?: 'ModelRelationJoinStrategySteps'; relationKey: string }> | null;
    };
  }>;
};

export type RecordTypeFragmentFragment = {
  __typename?: 'QueryResponseRecordType';
  key: string;
  type: string;
  name: string;
  pk?: boolean | null;
  precision?: string | null;
  model?: {
    __typename?: 'QueryResponseRecordModel';
    modelId: string;
    name: string;
    propertyKey: string;
  } | null;
  relation?: {
    __typename?: 'QueryResponseRecordRelation';
    modelId: string;
    key: string;
    name: string;
  } | null;
};

export type GetExplorationStateQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  explorationId: Scalars['ID']['input'];
}>;

export type GetExplorationStateQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    explorationState?: {
      __typename?: 'ExplorationState';
      explorationId: string;
      previousStateId?: string | null;
      explorationSourceId?: string | null;
      state: any;
    } | null;
  } | null;
};

export type SetExplorationStateMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: ExplorationStateInput;
}>;

export type SetExplorationStateMutation = {
  __typename?: 'Mutation';
  upsertExplorationState: {
    __typename?: 'ExplorationState';
    explorationId: string;
    previousStateId?: string | null;
    explorationSourceId?: string | null;
    state: any;
  };
};

export type InboxItemsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type InboxItemsQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    inboxItems: Array<{
      __typename?: 'InboxItem';
      inboxItemId: string;
      source: InboxItemSource;
      status: InboxItemStatus;
      title: string;
      details: string;
      dismissalReason?: string | null;
      statusChangedAt: string;
      createdAt: string;
      statusChangedBy?: {
        __typename?: 'InboxItemUser';
        userId: string;
        email?: string | null;
      } | null;
      users: Array<{ __typename?: 'InboxItemUser'; userId: string; email?: string | null }>;
      conversations: Array<{
        __typename?: 'InboxItemConversation';
        conversationId: string;
        explorationStateId?: string | null;
        createdAt?: string | null;
        messageId?: string | null;
        question?: string | null;
        user?: { __typename?: 'InboxItemUser'; userId: string; email?: string | null } | null;
      }>;
    }>;
  } | null;
};

export type InboxItemCountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type InboxItemCountQuery = {
  __typename?: 'Query';
  account?: { __typename?: 'Account'; accountId: string; inboxItemCount: number } | null;
};

export type ResolveInboxItemMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  inboxItemId: Scalars['ID']['input'];
}>;

export type ResolveInboxItemMutation = { __typename?: 'Mutation'; resolveInboxItem: boolean };

export type UpdateInboxItemStatusMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  inboxItemId: Scalars['ID']['input'];
  status: InboxItemReviewStatus;
  dismissalReason?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateInboxItemStatusMutation = {
  __typename?: 'Mutation';
  updateInboxItemStatus: boolean;
};

export type CreateAnalyticsEventMutationVariables = Exact<{
  input: CreateAnalyticsEventInput;
  accountId: Scalars['ID']['input'];
}>;

export type CreateAnalyticsEventMutation = {
  __typename?: 'Mutation';
  createAnalyticsEvent:
    | { __typename?: 'AnalyticsEvent'; analyticsEventId: string }
    | { __typename?: 'CreateAnalyticsEventError'; error: string }
    | { __typename?: 'NotAllowedError'; message: string };
};

export type ExplorationMetadataFragmentFragment = {
  __typename?: 'ExplorationMetadata';
  schemaVersion?: string | null;
  explorationId: string;
  name: string;
  description?: string | null;
  labels: any;
  createdAt: string;
  updatedAt: string;
  stats: {
    __typename?: 'ExplorationStats';
    cellKind: Array<{ __typename?: 'CellKindCount'; kind: string; count: number }>;
  };
  createdBy: { __typename?: 'UserProfile'; email: string };
  updatedBy: { __typename?: 'UserProfile'; email: string };
  parameters: Array<{ __typename?: 'ExplorationParameter'; key: string; modelId: string }>;
};

export type MetadataQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type MetadataQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    explorationMetadata: Array<{
      __typename?: 'ExplorationMetadata';
      schemaVersion?: string | null;
      explorationId: string;
      name: string;
      description?: string | null;
      labels: any;
      createdAt: string;
      updatedAt: string;
      stats: {
        __typename?: 'ExplorationStats';
        cellKind: Array<{ __typename?: 'CellKindCount'; kind: string; count: number }>;
      };
      createdBy: { __typename?: 'UserProfile'; email: string };
      updatedBy: { __typename?: 'UserProfile'; email: string };
      parameters: Array<{ __typename?: 'ExplorationParameter'; key: string; modelId: string }>;
    }>;
    models: Array<{
      __typename?: 'Model';
      modelId: string;
      name: string;
      description?: string | null;
      primaryKey: Array<string>;
      labels: any;
      semantics?: any | null;
      properties: Array<{
        __typename?: 'ModelProperty';
        name: string;
        type: string;
        key: string;
        format?: string | null;
        precision?: string | null;
        description?: string | null;
      }>;
      relations: Array<{
        __typename?: 'ModelRelation';
        key: string;
        modelId: string;
        type: string;
        name: string;
        description?: string | null;
        joinStrategy: {
          __typename?: 'ModelRelationJoinStrategy';
          joinKeyOnBase?: string | null;
          joinKeyOnRelated?: string | null;
          sql?: string | null;
          through?: {
            __typename?: 'ModelRelationJoinStrategyThrough';
            modelId: string;
            joinKeyToBase?: string | null;
            joinKeyToRelated?: string | null;
          } | null;
          steps?: Array<{
            __typename?: 'ModelRelationJoinStrategySteps';
            relationKey: string;
          }> | null;
        };
      }>;
    }>;
    metrics: Array<{
      __typename?: 'Metric';
      metricId: string;
      name: string;
      description?: string | null;
      definition: any;
    }>;
  } | null;
};

export type OnboardingStateQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type OnboardingStateQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    onboardingState: {
      __typename?: 'OnboardingState';
      hasConnection: boolean;
      hasConsented: boolean;
      hasOnboarded: boolean;
      hasPassedSetupCallStep: boolean;
      hasBookedSetupCall: boolean;
      welcomeSurvey?: any | null;
    };
  } | null;
};

export type CreateConnectionMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
  name: Scalars['String']['input'];
  properties: Scalars['JSON']['input'];
}>;

export type CreateConnectionMutation = {
  __typename?: 'Mutation';
  createConnection: { __typename?: 'Connection'; connectionId: string };
};

export type DiscoverModelsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input?: InputMaybe<DiscoverModelsInput>;
}>;

export type DiscoverModelsQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    discoverModels:
      | { __typename?: 'DiscoverModelsError'; error: string }
      | { __typename?: 'DiscoverModelsSuccess'; configurationFile: string };
  } | null;
};

export type DiscoverSchemasQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  connectionId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DiscoverSchemasQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    discoverSchemas:
      | { __typename?: 'DiscoverSchemasError'; error: string }
      | {
          __typename?: 'DiscoverSchemasSuccess';
          schemas: Array<{ __typename?: 'Schema'; name: string }>;
        };
  } | null;
};

export type ImportConfigurationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: Scalars['String']['input'];
}>;

export type ImportConfigurationMutation = {
  __typename?: 'Mutation';
  importConfiguration: {
    __typename?: 'ConfigurationImportResult';
    success: boolean;
    errors?: Array<string> | null;
    warnings?: Array<string> | null;
  };
};

export type TestConnectionQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
  properties: Scalars['JSON']['input'];
}>;

export type TestConnectionQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    testConnection:
      | { __typename?: 'TestConnectionFailed'; error: string }
      | { __typename?: 'TestConnectionSuccess'; success: boolean };
  } | null;
};

export type GiveConsentMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: ConsentInput;
}>;

export type GiveConsentMutation = { __typename?: 'Mutation'; giveConsent: boolean };

export type UpdateOnboardingStateMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  key: OnboardingStateKey;
  value: Scalars['JSON']['input'];
}>;

export type UpdateOnboardingStateMutation = { __typename?: 'Mutation'; updateOnboardingState: any };

export type SsoProviderIdForEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type SsoProviderIdForEmailQuery = {
  __typename?: 'Query';
  ssoProviderIdForEmail?: string | null;
};

export type SignUpMutationVariables = Exact<{
  email: Scalars['String']['input'];
  consent: ConsentInput;
}>;

export type SignUpMutation = {
  __typename?: 'Mutation';
  signUp: { __typename?: 'User'; userId: string };
};

export type CreateAccessTokenMutationVariables = Exact<{
  input: CreateAccessTokenInput;
}>;

export type CreateAccessTokenMutation = {
  __typename?: 'Mutation';
  createAccessToken:
    | {
        __typename?: 'AccessTokenPreview';
        token: string;
        accessToken: {
          __typename?: 'AccessToken';
          name: string;
          preview?: string | null;
          lastUsedAt?: string | null;
          expiresAt?: string | null;
          createdAt: string;
          accessTokenId: string;
        };
      }
    | { __typename?: 'CreateAccessTokenError'; error: string }
    | { __typename?: 'NotAllowedError'; message: string };
};

export type DeleteAccessTokenMutationVariables = Exact<{
  accessTokenId: Scalars['ID']['input'];
}>;

export type DeleteAccessTokenMutation = {
  __typename?: 'Mutation';
  deleteAccessToken:
    | { __typename?: 'DeleteAccessTokenError'; error: string }
    | { __typename?: 'DeleteAccessTokenSuccess'; result: boolean }
    | { __typename?: 'NotAllowedError'; message: string };
};

export type AgentSkillsSettingsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type AgentSkillsSettingsQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    agentSkills: Array<{
      __typename?: 'AgentSkill';
      agentSkillId: string;
      name: string;
      description: string;
      instructions: string;
      access?: any | null;
      enabled: boolean;
      position: number;
    }>;
  } | null;
};

export type UpsertAgentSkillMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: AgentSkillInput;
}>;

export type UpsertAgentSkillMutation = {
  __typename?: 'Mutation';
  upsertAgentSkill: {
    __typename?: 'AgentSkill';
    agentSkillId: string;
    name: string;
    description: string;
    instructions: string;
    access?: any | null;
    enabled: boolean;
    position: number;
  };
};

export type DeleteAgentSkillMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  agentSkillId: Scalars['ID']['input'];
}>;

export type DeleteAgentSkillMutation = { __typename?: 'Mutation'; deleteAgentSkill: boolean };

export type AnswerGuidanceFieldsFragment = {
  __typename?: 'AnswerGuidance';
  id: string;
  question: string;
  guidance?: string | null;
  exploration?: any | null;
  createdAt: string;
  updatedAt: string;
  sourceScope: Array<{ __typename?: 'AnswerGuidanceSource'; type: string; id: string }>;
};

export type AnswerGuidanceSettingsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type AnswerGuidanceSettingsQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    answerGuidance: Array<{
      __typename?: 'AnswerGuidance';
      id: string;
      question: string;
      guidance?: string | null;
      exploration?: any | null;
      createdAt: string;
      updatedAt: string;
      sourceScope: Array<{ __typename?: 'AnswerGuidanceSource'; type: string; id: string }>;
    }>;
  } | null;
};

export type UpsertAnswerGuidanceMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: AnswerGuidanceInput;
}>;

export type UpsertAnswerGuidanceMutation = {
  __typename?: 'Mutation';
  upsertAnswerGuidance: {
    __typename?: 'AnswerGuidance';
    id: string;
    question: string;
    guidance?: string | null;
    exploration?: any | null;
    createdAt: string;
    updatedAt: string;
    sourceScope: Array<{ __typename?: 'AnswerGuidanceSource'; type: string; id: string }>;
  };
};

export type DeleteAnswerGuidanceMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  answerGuidanceId: Scalars['ID']['input'];
}>;

export type DeleteAnswerGuidanceMutation = {
  __typename?: 'Mutation';
  deleteAnswerGuidance: boolean;
};

export type UpdateAiBusinessConceptsMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  aiBusinessConcepts: Scalars['String']['input'];
}>;

export type UpdateAiBusinessConceptsMutation = {
  __typename?: 'Mutation';
  updateAiBusinessConcepts?: {
    __typename?: 'Account';
    accountId: string;
    aiBusinessConcepts?: string | null;
  } | null;
};

export type UpsertAiSystemInstructionMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  connectionId?: InputMaybe<Scalars['ID']['input']>;
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpsertAiSystemInstructionMutation = {
  __typename?: 'Mutation';
  upsertAiSystemInstruction?: {
    __typename?: 'AiSystemInstruction';
    aiSystemInstructionId: string;
    source: string;
    instructions: string;
    connectionId?: string | null;
    integrationId?: string | null;
  } | null;
};

export type UpdateFeaturesMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: UpdateFeaturesInput;
}>;

export type UpdateFeaturesMutation = {
  __typename?: 'Mutation';
  updateFeatures: { __typename?: 'Account'; accountId: string; features?: any | null };
};

export type AiUsageLimitsSettingsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type AiUsageLimitsSettingsQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    aiUsageLimits: {
      __typename?: 'AiUsageLimits';
      account: {
        __typename?: 'AiUsageLimitsConfig';
        costUsdPerDay?: number | null;
        costUsdPerMonth?: number | null;
        questionsPerDay?: number | null;
        questionsPerMonth?: number | null;
        costUsdPerQuestion?: number | null;
        costUsdPerQuestionResearch?: number | null;
      };
      user: {
        __typename?: 'AiUsageLimitsConfig';
        costUsdPerDay?: number | null;
        costUsdPerMonth?: number | null;
        questionsPerDay?: number | null;
        questionsPerMonth?: number | null;
        costUsdPerQuestion?: number | null;
        costUsdPerQuestionResearch?: number | null;
      };
      defaults: {
        __typename?: 'AiUsageLimitsConfig';
        costUsdPerDay?: number | null;
        costUsdPerMonth?: number | null;
        questionsPerDay?: number | null;
        questionsPerMonth?: number | null;
        costUsdPerQuestion?: number | null;
        costUsdPerQuestionResearch?: number | null;
      };
    };
  } | null;
};

export type UpdateAiUsageLimitsConfigMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  account: AiUsageLimitsConfigInput;
  user: AiUsageLimitsConfigInput;
}>;

export type UpdateAiUsageLimitsConfigMutation = {
  __typename?: 'Mutation';
  updateAiUsageLimitsConfig: {
    __typename?: 'AiUsageLimits';
    account: {
      __typename?: 'AiUsageLimitsConfig';
      costUsdPerDay?: number | null;
      costUsdPerMonth?: number | null;
      questionsPerDay?: number | null;
      questionsPerMonth?: number | null;
      costUsdPerQuestion?: number | null;
      costUsdPerQuestionResearch?: number | null;
    };
    user: {
      __typename?: 'AiUsageLimitsConfig';
      costUsdPerDay?: number | null;
      costUsdPerMonth?: number | null;
      questionsPerDay?: number | null;
      questionsPerMonth?: number | null;
      costUsdPerQuestion?: number | null;
      costUsdPerQuestionResearch?: number | null;
    };
  };
};

export type DeleteAlertConfigurationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  alertConfigurationId: Scalars['ID']['input'];
}>;

export type DeleteAlertConfigurationMutation = {
  __typename?: 'Mutation';
  deleteAlertConfiguration: { __typename?: 'DeleteAlertConfigurationSuccess'; result: boolean };
};

export type SlackChannelsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
}>;

export type SlackChannelsQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    slackChannels: Array<{
      __typename?: 'SlackChannel';
      id: string;
      name: string;
      isPrivate: boolean;
      isBotInChannel: boolean;
    }>;
  } | null;
};

export type UpsertAlertConfigurationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: AlertConfigurationInput;
}>;

export type UpsertAlertConfigurationMutation = {
  __typename?: 'Mutation';
  upsertAlertConfiguration: {
    __typename?: 'AlertConfiguration';
    alertConfigurationId: string;
    name: string;
    message: string;
    keyFields: Array<string>;
    pipeline: any;
    notificationConfig: any;
    createdAt: string;
  };
};

export type ConnectionPropertiesQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type ConnectionPropertiesQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    connections: Array<{
      __typename?: 'Connection';
      connectionId: string;
      properties: {
        __typename?: 'ConnectionProperties';
        connectionTimeout?: number | null;
        maximumDataProcessedBytes?: number | null;
      };
    }>;
  } | null;
};

export type UpdateConnectionMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  connectionId: Scalars['ID']['input'];
  input: UpdateConnectionInput;
}>;

export type UpdateConnectionMutation = {
  __typename?: 'Mutation';
  updateConnection: {
    __typename?: 'Connection';
    connectionId: string;
    name: string;
    properties: {
      __typename?: 'ConnectionProperties';
      connectionTimeout?: number | null;
      maximumDataProcessedBytes?: number | null;
    };
  };
};

export type AccountSettingsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type AccountSettingsQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    name: string;
    aiBusinessConcepts?: string | null;
    me: {
      __typename?: 'AccountUser';
      userId: string;
      authorizedClients: Array<{
        __typename?: 'AuthorizedClient';
        grantId: string;
        verified: boolean;
        clientName: string;
        logoUri?: string | null;
        redirectHost: string;
        scopes: Array<string>;
        authorizedAt: string;
        lastUsedAt?: string | null;
      }>;
    };
    users: Array<{
      __typename?: 'AccountUser';
      userId: string;
      email: string;
      addedAt: string;
      role: { __typename?: 'Role'; roleId: UserRole; name: string };
    }>;
    accessTokens: Array<{
      __typename?: 'AccessToken';
      name: string;
      preview?: string | null;
      expiresAt?: string | null;
      lastUsedAt?: string | null;
      createdAt: string;
      accessTokenId: string;
    }>;
    serviceUsers: Array<{
      __typename?: 'ServiceUser';
      userId: string;
      name: string;
      email: string;
      role: UserRole;
      createdAt: string;
      accessTokens: Array<{
        __typename?: 'AccessToken';
        accessTokenId: string;
        name: string;
        preview?: string | null;
        expiresAt?: string | null;
        lastUsedAt?: string | null;
        createdAt: string;
      }>;
    }>;
    connections: Array<{
      __typename?: 'Connection';
      connectionId: string;
      name: string;
      type: string;
      createdAt: string;
    }>;
    integrations: Array<{
      __typename?: 'Integration';
      integrationId: string;
      service: IntegrationService;
      name?: string | null;
      workspaceId?: string | null;
      url?: string | null;
      description?: string | null;
      createdAt: string;
      oauthClientId?: string | null;
      authStatus?: IntegrationAuthStatus | null;
    }>;
    alertConfigurations: Array<{
      __typename?: 'AlertConfiguration';
      alertConfigurationId: string;
      accountId: string;
      name: string;
      message: string;
      keyFields: Array<string>;
      excludedFields: Array<string>;
      pipeline: any;
      notificationConfig: any;
      createdAt: string;
    }>;
    models: Array<{
      __typename?: 'Model';
      modelId: string;
      name: string;
      description?: string | null;
      primaryKey: Array<string>;
      labels: any;
      semantics?: any | null;
      properties: Array<{
        __typename?: 'ModelProperty';
        name: string;
        type: string;
        key: string;
        format?: string | null;
        precision?: string | null;
        description?: string | null;
      }>;
      relations: Array<{
        __typename?: 'ModelRelation';
        key: string;
        modelId: string;
        type: string;
        name: string;
        description?: string | null;
        joinStrategy: {
          __typename?: 'ModelRelationJoinStrategy';
          joinKeyOnBase?: string | null;
          joinKeyOnRelated?: string | null;
          sql?: string | null;
          through?: {
            __typename?: 'ModelRelationJoinStrategyThrough';
            modelId: string;
            joinKeyToBase?: string | null;
            joinKeyToRelated?: string | null;
          } | null;
          steps?: Array<{
            __typename?: 'ModelRelationJoinStrategySteps';
            relationKey: string;
          }> | null;
        };
      }>;
    }>;
    metrics: Array<{
      __typename?: 'Metric';
      metricId: string;
      name: string;
      description?: string | null;
      definition: any;
    }>;
    navigation: Array<{
      __typename?: 'ExplorationNavigationItem';
      kind: string;
      label: string;
      explorationId: string;
    }>;
    explorations: Array<{ __typename?: 'Exploration'; explorationId: string; name: string }>;
    userGroups: Array<{
      __typename?: 'UserGroup';
      userGroupId: string;
      name: string;
      parameters?: any | null;
      permissions: Array<UserRolePermission>;
      createdAt: string;
      updatedAt: string;
      members: Array<{ __typename?: 'AccountUser'; userId: string; email: string }>;
    }>;
    aiSystemInstructions: Array<{
      __typename?: 'AiSystemInstruction';
      aiSystemInstructionId: string;
      source: string;
      instructions: string;
      connectionId?: string | null;
      integrationId?: string | null;
    }>;
  } | null;
  permissions: Array<{ __typename?: 'Permission'; permissionId: UserRolePermission; name: string }>;
};

export type RevokeAuthorizedClientMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  grantId: Scalars['ID']['input'];
}>;

export type RevokeAuthorizedClientMutation = {
  __typename?: 'Mutation';
  revokeAuthorizedClient:
    | { __typename?: 'NotAllowedError'; message: string }
    | { __typename?: 'RevokeAuthorizedClientError'; error: string }
    | { __typename?: 'RevokeAuthorizedClientSuccess'; result: boolean };
};

export type CreateConfluencePairingRequestMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;

export type CreateConfluencePairingRequestMutation = {
  __typename?: 'Mutation';
  createConfluencePairingRequest: {
    __typename?: 'ConfluencePairingRequest';
    code: string;
    expiresAt: string;
  };
};

export type ConfluencePairingStateQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;

export type ConfluencePairingStateQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    accountId: string;
    confluencePairingState: {
      __typename?: 'ConfluencePairingState';
      status: ConfluencePairingStatus;
      integrationId?: string | null;
    };
  } | null;
};

export type OauthGithubCallbackMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;

export type OauthGithubCallbackMutation = {
  __typename?: 'Mutation';
  oauthGithubCallback:
    | { __typename?: 'OauthGithubCallbackError'; error: string }
    | { __typename?: 'OauthGithubCallbackInstallRequired'; installRequired: boolean }
    | { __typename?: 'OauthGithubCallbackSuccess'; success: boolean };
};

export type CreateGoogleDriveIntegrationMutationVariables = Exact<{
  url: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
}>;

export type CreateGoogleDriveIntegrationMutation = {
  __typename?: 'Mutation';
  createGoogleDriveIntegration: { __typename?: 'CreateIntegrationResult'; success: boolean };
};

export type CreateMcpIntegrationMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  serverUrl: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateMcpIntegrationMutation = {
  __typename?: 'Mutation';
  createMcpIntegration:
    | { __typename: 'CreateMcpIntegrationError'; error: string }
    | {
        __typename: 'CreateMcpIntegrationSuccess';
        integration: {
          __typename?: 'Integration';
          integrationId: string;
          service: IntegrationService;
          name?: string | null;
          createdAt: string;
          oauthClientId?: string | null;
        };
      };
};

export type StartOauthMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  oauthClientId: Scalars['ID']['input'];
}>;

export type StartOauthMutation = {
  __typename?: 'Mutation';
  startOauth:
    | { __typename: 'StartOauthError'; error: string }
    | { __typename: 'StartOauthSuccess'; authorizeUrl: string };
};

export type OauthCallbackMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  oauthClientId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
}>;

export type OauthCallbackMutation = {
  __typename?: 'Mutation';
  oauthCallback:
    | { __typename: 'OauthCallbackError'; error: string }
    | { __typename: 'OauthCallbackSuccess'; success: boolean };
};

export type DisconnectMcpIntegrationMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  integrationId: Scalars['ID']['input'];
}>;

export type DisconnectMcpIntegrationMutation = {
  __typename?: 'Mutation';
  disconnectMcpIntegration: boolean;
};

export type CreateNotionIntegrationMutationVariables = Exact<{
  apiKey: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
}>;

export type CreateNotionIntegrationMutation = {
  __typename?: 'Mutation';
  createNotionIntegration: { __typename?: 'CreateIntegrationResult'; success: boolean };
};

export type OauthSlackCallbackMutationVariables = Exact<{
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
}>;

export type OauthSlackCallbackMutation = {
  __typename?: 'Mutation';
  oauthSlackCallback:
    | { __typename?: 'OauthSlackCallbackError'; error: string }
    | { __typename?: 'OauthSlackCallbackSuccess'; success: boolean };
};

export type UpdateNavigationMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
}>;

export type UpdateNavigationMutation = { __typename?: 'Mutation'; updateNavigation: boolean };

export type CreateServiceUserAccessTokenMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
}>;

export type CreateServiceUserAccessTokenMutation = {
  __typename?: 'Mutation';
  createServiceUserAccessToken:
    | {
        __typename?: 'AccessTokenPreview';
        token: string;
        accessToken: {
          __typename?: 'AccessToken';
          accessTokenId: string;
          name: string;
          preview?: string | null;
          expiresAt?: string | null;
          lastUsedAt?: string | null;
          createdAt: string;
        };
      }
    | { __typename?: 'CreateAccessTokenError'; error: string }
    | { __typename?: 'NotAllowedError'; message: string };
};

export type CreateServiceUserMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  role: UserRole;
}>;

export type CreateServiceUserMutation = {
  __typename?: 'Mutation';
  createServiceUser:
    | { __typename?: 'CreateServiceUserError'; error: string }
    | { __typename?: 'NotAllowedError'; message: string }
    | {
        __typename?: 'ServiceUser';
        userId: string;
        name: string;
        email: string;
        role: UserRole;
        createdAt: string;
        accessTokens: Array<{
          __typename?: 'AccessToken';
          accessTokenId: string;
          name: string;
          preview?: string | null;
          expiresAt?: string | null;
          lastUsedAt?: string | null;
          createdAt: string;
        }>;
      };
};

export type DeleteServiceUserAccessTokenMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  accessTokenId: Scalars['ID']['input'];
}>;

export type DeleteServiceUserAccessTokenMutation = {
  __typename?: 'Mutation';
  deleteServiceUserAccessToken:
    | { __typename?: 'DeleteAccessTokenError'; error: string }
    | { __typename?: 'DeleteAccessTokenSuccess'; result: boolean }
    | { __typename?: 'NotAllowedError'; message: string };
};

export type DeleteServiceUserMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type DeleteServiceUserMutation = {
  __typename?: 'Mutation';
  deleteServiceUser:
    | { __typename?: 'DeleteServiceUserError'; error: string }
    | { __typename?: 'DeleteServiceUserSuccess'; result: boolean }
    | { __typename?: 'NotAllowedError'; message: string };
};

export type AddUserToGroupMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type AddUserToGroupMutation = {
  __typename?: 'Mutation';
  addUserToGroup: {
    __typename?: 'UserGroup';
    userGroupId: string;
    name: string;
    parameters?: any | null;
    permissions: Array<UserRolePermission>;
    createdAt: string;
    updatedAt: string;
    members: Array<{ __typename?: 'AccountUser'; userId: string; email: string }>;
  };
};

export type DeleteUserGroupMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
}>;

export type DeleteUserGroupMutation = {
  __typename?: 'Mutation';
  deleteUserGroup: { __typename?: 'UserGroup'; userGroupId: string; name: string };
};

export type RemoveUserFromGroupMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type RemoveUserFromGroupMutation = {
  __typename?: 'Mutation';
  removeUserFromGroup: {
    __typename?: 'UserGroup';
    userGroupId: string;
    name: string;
    parameters?: any | null;
    permissions: Array<UserRolePermission>;
    createdAt: string;
    updatedAt: string;
    members: Array<{ __typename?: 'AccountUser'; userId: string; email: string }>;
  };
};

export type UpsertUserGroupMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  permissions?: InputMaybe<Array<UserRolePermission> | UserRolePermission>;
}>;

export type UpsertUserGroupMutation = {
  __typename?: 'Mutation';
  upsertUserGroup: {
    __typename?: 'UserGroup';
    userGroupId: string;
    name: string;
    parameters?: any | null;
    permissions: Array<UserRolePermission>;
    createdAt: string;
    updatedAt: string;
    members: Array<{ __typename?: 'AccountUser'; userId: string; email: string }>;
  };
};

export type AddUserToAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  role: UserRole;
}>;

export type AddUserToAccountMutation = {
  __typename?: 'Mutation';
  addUserToAccount: {
    __typename?: 'AccountUserChangeResponse';
    accountUser: {
      __typename?: 'AccountUser';
      userId: string;
      email: string;
      role: { __typename?: 'Role'; roleId: UserRole };
    };
  };
};

export type DeleteUserFromAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type DeleteUserFromAccountMutation = {
  __typename?: 'Mutation';
  deleteUserFromAccount: {
    __typename?: 'AccountUserDeleteResponse';
    success: boolean;
    account: {
      __typename?: 'Account';
      accountId: string;
      users: Array<{
        __typename?: 'AccountUser';
        userId: string;
        email: string;
        addedAt: string;
        role: { __typename?: 'Role'; roleId: UserRole };
      }>;
    };
    accountUser: { __typename?: 'AccountUser'; userId: string; email: string };
  };
};

export type UpdateUserInAccountMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  role: UserRole;
}>;

export type UpdateUserInAccountMutation = {
  __typename?: 'Mutation';
  updateUserInAccount: {
    __typename?: 'AccountUserChangeResponse';
    accountUser: { __typename?: 'AccountUser'; userId: string; email: string };
  };
};

export type WorkspaceQueryVariables = Exact<{ [key: string]: never }>;

export type WorkspaceQuery = {
  __typename?: 'Query';
  me?: { __typename?: 'User'; userId: string; email: string } | null;
  accounts: Array<{
    __typename?: 'Account';
    accountId: string;
    slug: string;
    name: string;
    timezone?: string | null;
    isOnboarded: boolean;
    features?: any | null;
    pinnedExplorationIds: Array<string>;
    integrations: Array<{
      __typename?: 'Integration';
      integrationId: string;
      service: IntegrationService;
      name?: string | null;
      description?: string | null;
      createdAt: string;
      oauthClientId?: string | null;
      authStatus?: IntegrationAuthStatus | null;
    }>;
    connections: Array<{
      __typename?: 'Connection';
      connectionId: string;
      type: string;
      name: string;
    }>;
    me: {
      __typename?: 'AccountUser';
      pinnedExplorationIds: Array<string>;
      permissions: Array<{ __typename?: 'Permission'; permissionId: UserRolePermission }>;
    };
  }>;
};

export const ExplorationDataFragmentFragmentDoc = gql`
  fragment ExplorationDataFragment on ExplorationData {
    schemaVersion
    explorationId
    name
    description
    labels
    parameters {
      key
      modelId
    }
    view {
      canvas
      tabs
      cells {
        ... on RecordsViewCell {
          id
          kind
          title
          excludeProperties
          pipeline {
            baseModelId
            operations {
              operation
              parameters
              disabled
            }
            pipelineId
            parentId
          }
          sort {
            key
            direction
          }
          visualisations {
            aggregationType
            aggregationTarget
            groupByField
            timeGranularity
            viewOptions
            aggregations
            groups
            aggregation
            valueKeys
            mainAxisKey
            sort {
              key
              direction
            }
            type
            message
            visualisation
          }
          viewOptions
        }
        ... on FunnelViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            pipelineId
            operations {
              operation
              parameters
            }
          }
          viewOptions
        }
        ... on CohortViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
            parentId
          }
          viewOptions
        }
        ... on VariableViewCell {
          id
          kind
          definition
          viewOptions
        }
        ... on SqlViewCell {
          id
          kind
          title
          excludeProperties
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
          }
          visualisations {
            aggregationType
            aggregationTarget
            groupByField
            timeGranularity
            viewOptions
            aggregations
            groups
            aggregation
            valueKeys
            mainAxisKey
            sort {
              key
              direction
            }
            type
            message
            visualisation
          }
          viewOptions
        }
        ... on PythonViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
          }
          viewOptions
        }
        ... on MetricViewCell {
          id
          kind
          metricId
          viewOptions
        }
        ... on TextViewCell {
          id
          kind
          title
          content
          viewOptions
        }
        ... on ChatViewCell {
          id
          kind
          messages {
            id
            role
            type
            message
          }
          viewOptions
        }
        ... on ConversationViewCell {
          id
          kind
          conversationId
        }
        ... on InvalidViewCell {
          id
          kind
          title
          message
          viewOptions
          cell
        }
      }
      options
    }
  }
`;
export const ConversationFragmentFragmentDoc = gql`
  fragment ConversationFragment on Conversation {
    conversationId
    messages {
      ... on ConversationTextMessage {
        id
        role
        type
        enabledSources
        research
        message
        jobId
      }
      ... on ConversationExplorationMessage {
        id
        role
        type
        jobId
        exploration {
          ...ExplorationDataFragment
        }
      }
    }
    jobs {
      jobId
      parentJobId
      channel
      createdAt
      progress {
        jobProgressId
        jobId
        status
        statusMessage
        createdAt
      }
    }
  }
  ${ExplorationDataFragmentFragmentDoc}
`;
export const ExplorationFragmentFragmentDoc = gql`
  fragment ExplorationFragment on Exploration {
    schemaVersion
    explorationId
    name
    description
    labels
    createdAt
    createdBy {
      email
    }
    updatedAt
    updatedBy {
      email
    }
    parameters {
      key
      modelId
    }
    view {
      canvas
      tabs
      cells {
        ... on RecordsViewCell {
          id
          kind
          title
          excludeProperties
          pipeline {
            baseModelId
            operations {
              operation
              parameters
              disabled
            }
            pipelineId
            parentId
          }
          sort {
            key
            direction
          }
          visualisations {
            aggregationType
            aggregationTarget
            groupByField
            timeGranularity
            viewOptions
            aggregations
            groups
            aggregation
            valueKeys
            mainAxisKey
            sort {
              key
              direction
            }
            type
            message
            visualisation
          }
          viewOptions
        }
        ... on FunnelViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            pipelineId
            operations {
              operation
              parameters
            }
          }
          viewOptions
        }
        ... on CohortViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
            parentId
          }
          viewOptions
        }
        ... on VariableViewCell {
          id
          kind
          definition
          viewOptions
        }
        ... on SqlViewCell {
          id
          kind
          title
          excludeProperties
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
          }
          visualisations {
            aggregationType
            aggregationTarget
            groupByField
            timeGranularity
            viewOptions
            aggregations
            groups
            aggregation
            valueKeys
            mainAxisKey
            sort {
              key
              direction
            }
            type
            message
            visualisation
          }
          viewOptions
        }
        ... on PythonViewCell {
          id
          kind
          title
          pipeline {
            baseModelId
            operations {
              operation
              parameters
            }
            pipelineId
          }
          viewOptions
        }
        ... on MetricViewCell {
          id
          kind
          metricId
          viewOptions
        }
        ... on TextViewCell {
          id
          kind
          title
          content
          viewOptions
        }
        ... on ChatViewCell {
          id
          kind
          messages {
            id
            role
            type
            message
          }
          viewOptions
        }
        ... on ConversationViewCell {
          id
          kind
          conversationId
        }
        ... on InvalidViewCell {
          id
          kind
          title
          message
          viewOptions
          cell
        }
      }
      options
    }
  }
`;
export const MetricFragmentFragmentDoc = gql`
  fragment MetricFragment on Metric {
    metricId
    name
    description
    definition
  }
`;
export const ModelFragmentFragmentDoc = gql`
  fragment ModelFragment on Model {
    modelId
    name
    description
    primaryKey
    labels
    semantics
    properties {
      name
      type
      key
      format
      precision
      description
    }
    relations {
      key
      modelId
      type
      name
      description
      joinStrategy {
        joinKeyOnBase
        joinKeyOnRelated
        sql
        through {
          modelId
          joinKeyToBase
          joinKeyToRelated
        }
        steps {
          relationKey
        }
      }
    }
  }
`;
export const RecordTypeFragmentFragmentDoc = gql`
  fragment RecordTypeFragment on QueryResponseRecordType {
    key
    type
    name
    pk
    precision
    model {
      modelId
      name
      propertyKey
    }
    relation {
      modelId
      key
      name
    }
  }
`;
export const ExplorationMetadataFragmentFragmentDoc = gql`
  fragment ExplorationMetadataFragment on ExplorationMetadata {
    schemaVersion
    explorationId
    name
    description
    labels
    stats {
      cellKind {
        kind
        count
      }
    }
    createdAt
    createdBy {
      email
    }
    updatedAt
    updatedBy {
      email
    }
    parameters {
      key
      modelId
    }
  }
`;
export const AnswerGuidanceFieldsFragmentDoc = gql`
  fragment AnswerGuidanceFields on AnswerGuidance {
    id
    question
    sourceScope {
      type
      id
    }
    guidance
    exploration
    createdAt
    updatedAt
  }
`;
export const AiQueryHistoryDocument = gql`
  query AiQueryHistory($accountId: ID!) {
    account(accountId: $accountId) {
      accountId
      aiQueryHistory {
        threadId
        queries {
          correlationId
          message
          resultUrl
          sources
          createdAt
        }
      }
    }
  }
`;

/**
 * __useAiQueryHistoryQuery__
 *
 * To run a query within a React component, call `useAiQueryHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiQueryHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiQueryHistoryQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAiQueryHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<AiQueryHistoryQuery, AiQueryHistoryQueryVariables> &
    ({ variables: AiQueryHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiQueryHistoryQuery, AiQueryHistoryQueryVariables>(
    AiQueryHistoryDocument,
    options,
  );
}
export function useAiQueryHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AiQueryHistoryQuery, AiQueryHistoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiQueryHistoryQuery, AiQueryHistoryQueryVariables>(
    AiQueryHistoryDocument,
    options,
  );
}
export function useAiQueryHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AiQueryHistoryQuery, AiQueryHistoryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AiQueryHistoryQuery, AiQueryHistoryQueryVariables>(
    AiQueryHistoryDocument,
    options,
  );
}
export type AiQueryHistoryQueryHookResult = ReturnType<typeof useAiQueryHistoryQuery>;
export type AiQueryHistoryLazyQueryHookResult = ReturnType<typeof useAiQueryHistoryLazyQuery>;
export type AiQueryHistorySuspenseQueryHookResult = ReturnType<
  typeof useAiQueryHistorySuspenseQuery
>;
export type AiQueryHistoryQueryResult = Apollo.QueryResult<
  AiQueryHistoryQuery,
  AiQueryHistoryQueryVariables
>;
export const ExplorationHistoryDocument = gql`
  query ExplorationHistory($accountId: ID!, $days: Int, $timeZone: String) {
    account(accountId: $accountId) {
      accountId
      explorationHistory(days: $days, timeZone: $timeZone) {
        entryId
        startedAt
        endedAt
        stateCount
        sittingCount
        name
        headStateId
        continuedFromDate
        startedFromModelId
      }
    }
  }
`;

/**
 * __useExplorationHistoryQuery__
 *
 * To run a query within a React component, call `useExplorationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplorationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplorationHistoryQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      days: // value for 'days'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useExplorationHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<ExplorationHistoryQuery, ExplorationHistoryQueryVariables> &
    ({ variables: ExplorationHistoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExplorationHistoryQuery, ExplorationHistoryQueryVariables>(
    ExplorationHistoryDocument,
    options,
  );
}
export function useExplorationHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExplorationHistoryQuery,
    ExplorationHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExplorationHistoryQuery, ExplorationHistoryQueryVariables>(
    ExplorationHistoryDocument,
    options,
  );
}
export function useExplorationHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExplorationHistoryQuery, ExplorationHistoryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExplorationHistoryQuery, ExplorationHistoryQueryVariables>(
    ExplorationHistoryDocument,
    options,
  );
}
export type ExplorationHistoryQueryHookResult = ReturnType<typeof useExplorationHistoryQuery>;
export type ExplorationHistoryLazyQueryHookResult = ReturnType<
  typeof useExplorationHistoryLazyQuery
>;
export type ExplorationHistorySuspenseQueryHookResult = ReturnType<
  typeof useExplorationHistorySuspenseQuery
>;
export type ExplorationHistoryQueryResult = Apollo.QueryResult<
  ExplorationHistoryQuery,
  ExplorationHistoryQueryVariables
>;
export const ExplorationHistoryEntrySummaryDocument = gql`
  query ExplorationHistoryEntrySummary(
    $accountId: ID!
    $entryId: ID!
    $days: Int
    $timeZone: String
  ) {
    account(accountId: $accountId) {
      accountId
      explorationHistoryEntry(entryId: $entryId, days: $days, timeZone: $timeZone) {
        entryId
        summary
      }
    }
  }
`;

/**
 * __useExplorationHistoryEntrySummaryQuery__
 *
 * To run a query within a React component, call `useExplorationHistoryEntrySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplorationHistoryEntrySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplorationHistoryEntrySummaryQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      entryId: // value for 'entryId'
 *      days: // value for 'days'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useExplorationHistoryEntrySummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExplorationHistoryEntrySummaryQuery,
    ExplorationHistoryEntrySummaryQueryVariables
  > &
    (
      | { variables: ExplorationHistoryEntrySummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExplorationHistoryEntrySummaryQuery,
    ExplorationHistoryEntrySummaryQueryVariables
  >(ExplorationHistoryEntrySummaryDocument, options);
}
export function useExplorationHistoryEntrySummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExplorationHistoryEntrySummaryQuery,
    ExplorationHistoryEntrySummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExplorationHistoryEntrySummaryQuery,
    ExplorationHistoryEntrySummaryQueryVariables
  >(ExplorationHistoryEntrySummaryDocument, options);
}
export function useExplorationHistoryEntrySummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExplorationHistoryEntrySummaryQuery,
        ExplorationHistoryEntrySummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExplorationHistoryEntrySummaryQuery,
    ExplorationHistoryEntrySummaryQueryVariables
  >(ExplorationHistoryEntrySummaryDocument, options);
}
export type ExplorationHistoryEntrySummaryQueryHookResult = ReturnType<
  typeof useExplorationHistoryEntrySummaryQuery
>;
export type ExplorationHistoryEntrySummaryLazyQueryHookResult = ReturnType<
  typeof useExplorationHistoryEntrySummaryLazyQuery
>;
export type ExplorationHistoryEntrySummarySuspenseQueryHookResult = ReturnType<
  typeof useExplorationHistoryEntrySummarySuspenseQuery
>;
export type ExplorationHistoryEntrySummaryQueryResult = Apollo.QueryResult<
  ExplorationHistoryEntrySummaryQuery,
  ExplorationHistoryEntrySummaryQueryVariables
>;
export const ExplorationHistoryEntryStepsDocument = gql`
  query ExplorationHistoryEntrySteps(
    $accountId: ID!
    $entryId: ID!
    $days: Int
    $timeZone: String
  ) {
    account(accountId: $accountId) {
      accountId
      explorationHistoryEntry(entryId: $entryId, days: $days, timeZone: $timeZone) {
        entryId
        steps {
          stateId
          createdAt
          changeLabel
          changeKind
        }
      }
    }
  }
`;

/**
 * __useExplorationHistoryEntryStepsQuery__
 *
 * To run a query within a React component, call `useExplorationHistoryEntryStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplorationHistoryEntryStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplorationHistoryEntryStepsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      entryId: // value for 'entryId'
 *      days: // value for 'days'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useExplorationHistoryEntryStepsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExplorationHistoryEntryStepsQuery,
    ExplorationHistoryEntryStepsQueryVariables
  > &
    ({ variables: ExplorationHistoryEntryStepsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExplorationHistoryEntryStepsQuery,
    ExplorationHistoryEntryStepsQueryVariables
  >(ExplorationHistoryEntryStepsDocument, options);
}
export function useExplorationHistoryEntryStepsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExplorationHistoryEntryStepsQuery,
    ExplorationHistoryEntryStepsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExplorationHistoryEntryStepsQuery,
    ExplorationHistoryEntryStepsQueryVariables
  >(ExplorationHistoryEntryStepsDocument, options);
}
export function useExplorationHistoryEntryStepsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExplorationHistoryEntryStepsQuery,
        ExplorationHistoryEntryStepsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExplorationHistoryEntryStepsQuery,
    ExplorationHistoryEntryStepsQueryVariables
  >(ExplorationHistoryEntryStepsDocument, options);
}
export type ExplorationHistoryEntryStepsQueryHookResult = ReturnType<
  typeof useExplorationHistoryEntryStepsQuery
>;
export type ExplorationHistoryEntryStepsLazyQueryHookResult = ReturnType<
  typeof useExplorationHistoryEntryStepsLazyQuery
>;
export type ExplorationHistoryEntryStepsSuspenseQueryHookResult = ReturnType<
  typeof useExplorationHistoryEntryStepsSuspenseQuery
>;
export type ExplorationHistoryEntryStepsQueryResult = Apollo.QueryResult<
  ExplorationHistoryEntryStepsQuery,
  ExplorationHistoryEntryStepsQueryVariables
>;
export const AlertConfigurationDocument = gql`
  query AlertConfiguration($accountId: ID!, $alertConfigurationId: ID!) {
    account(accountId: $accountId) {
      alertConfiguration(alertConfigurationId: $alertConfigurationId) {
        alertConfigurationId
        accountId
        name
        message
        pipeline
        keyFields
        excludedFields
        notificationConfig
        createdAt
      }
      models {
        modelId
        name
      }
    }
  }
`;

/**
 * __useAlertConfigurationQuery__
 *
 * To run a query within a React component, call `useAlertConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertConfigurationQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      alertConfigurationId: // value for 'alertConfigurationId'
 *   },
 * });
 */
export function useAlertConfigurationQuery(
  baseOptions: Apollo.QueryHookOptions<AlertConfigurationQuery, AlertConfigurationQueryVariables> &
    ({ variables: AlertConfigurationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AlertConfigurationQuery, AlertConfigurationQueryVariables>(
    AlertConfigurationDocument,
    options,
  );
}
export function useAlertConfigurationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AlertConfigurationQuery,
    AlertConfigurationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AlertConfigurationQuery, AlertConfigurationQueryVariables>(
    AlertConfigurationDocument,
    options,
  );
}
export function useAlertConfigurationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AlertConfigurationQuery, AlertConfigurationQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AlertConfigurationQuery, AlertConfigurationQueryVariables>(
    AlertConfigurationDocument,
    options,
  );
}
export type AlertConfigurationQueryHookResult = ReturnType<typeof useAlertConfigurationQuery>;
export type AlertConfigurationLazyQueryHookResult = ReturnType<
  typeof useAlertConfigurationLazyQuery
>;
export type AlertConfigurationSuspenseQueryHookResult = ReturnType<
  typeof useAlertConfigurationSuspenseQuery
>;
export type AlertConfigurationQueryResult = Apollo.QueryResult<
  AlertConfigurationQuery,
  AlertConfigurationQueryVariables
>;
export const ExplorationRecordTypeDocument = gql`
  query ExplorationRecordType(
    $accountId: ID!
    $baseModelId: ID!
    $pipeline: [OperationInput!]!
    $variables: JSON
  ) {
    account(accountId: $accountId) {
      accountId
      query(baseModelId: $baseModelId, pipeline: $pipeline, first: 1, variables: $variables) {
        recordType {
          key
          type
          name
          relation {
            modelId
            key
            name
          }
        }
        grouping {
          key
        }
      }
    }
  }
`;

/**
 * __useExplorationRecordTypeQuery__
 *
 * To run a query within a React component, call `useExplorationRecordTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplorationRecordTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplorationRecordTypeQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      baseModelId: // value for 'baseModelId'
 *      pipeline: // value for 'pipeline'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useExplorationRecordTypeQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExplorationRecordTypeQuery,
    ExplorationRecordTypeQueryVariables
  > &
    ({ variables: ExplorationRecordTypeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExplorationRecordTypeQuery, ExplorationRecordTypeQueryVariables>(
    ExplorationRecordTypeDocument,
    options,
  );
}
export function useExplorationRecordTypeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExplorationRecordTypeQuery,
    ExplorationRecordTypeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExplorationRecordTypeQuery, ExplorationRecordTypeQueryVariables>(
    ExplorationRecordTypeDocument,
    options,
  );
}
export function useExplorationRecordTypeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExplorationRecordTypeQuery,
        ExplorationRecordTypeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExplorationRecordTypeQuery, ExplorationRecordTypeQueryVariables>(
    ExplorationRecordTypeDocument,
    options,
  );
}
export type ExplorationRecordTypeQueryHookResult = ReturnType<typeof useExplorationRecordTypeQuery>;
export type ExplorationRecordTypeLazyQueryHookResult = ReturnType<
  typeof useExplorationRecordTypeLazyQuery
>;
export type ExplorationRecordTypeSuspenseQueryHookResult = ReturnType<
  typeof useExplorationRecordTypeSuspenseQuery
>;
export type ExplorationRecordTypeQueryResult = Apollo.QueryResult<
  ExplorationRecordTypeQuery,
  ExplorationRecordTypeQueryVariables
>;
export const ConversationDocument = gql`
  query Conversation($accountId: ID!, $conversationId: ID!) {
    account(accountId: $accountId) {
      accountId
      conversation(conversationId: $conversationId) {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragmentFragmentDoc}
`;

/**
 * __useConversationQuery__
 *
 * To run a query within a React component, call `useConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationQuery(
  baseOptions: Apollo.QueryHookOptions<ConversationQuery, ConversationQueryVariables> &
    ({ variables: ConversationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConversationQuery, ConversationQueryVariables>(
    ConversationDocument,
    options,
  );
}
export function useConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ConversationQuery, ConversationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConversationQuery, ConversationQueryVariables>(
    ConversationDocument,
    options,
  );
}
export function useConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConversationQuery, ConversationQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ConversationQuery, ConversationQueryVariables>(
    ConversationDocument,
    options,
  );
}
export type ConversationQueryHookResult = ReturnType<typeof useConversationQuery>;
export type ConversationLazyQueryHookResult = ReturnType<typeof useConversationLazyQuery>;
export type ConversationSuspenseQueryHookResult = ReturnType<typeof useConversationSuspenseQuery>;
export type ConversationQueryResult = Apollo.QueryResult<
  ConversationQuery,
  ConversationQueryVariables
>;
export const StartConversationDocument = gql`
  mutation StartConversation(
    $accountId: ID!
    $conversationId: ID!
    $message: ConversationMessageInput!
    $exploration: ExplorationInput
    $variables: JSON
    $correlationId: String
    $selectors: [String]
  ) {
    startConversation(
      accountId: $accountId
      conversationId: $conversationId
      message: $message
      exploration: $exploration
      variables: $variables
      correlationId: $correlationId
      selectors: $selectors
    ) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragmentFragmentDoc}
`;
export type StartConversationMutationFn = Apollo.MutationFunction<
  StartConversationMutation,
  StartConversationMutationVariables
>;

/**
 * __useStartConversationMutation__
 *
 * To run a mutation, you first call `useStartConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startConversationMutation, { data, loading, error }] = useStartConversationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      conversationId: // value for 'conversationId'
 *      message: // value for 'message'
 *      exploration: // value for 'exploration'
 *      variables: // value for 'variables'
 *      correlationId: // value for 'correlationId'
 *      selectors: // value for 'selectors'
 *   },
 * });
 */
export function useStartConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartConversationMutation,
    StartConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartConversationMutation, StartConversationMutationVariables>(
    StartConversationDocument,
    options,
  );
}
export type StartConversationMutationHookResult = ReturnType<typeof useStartConversationMutation>;
export type StartConversationMutationResult = Apollo.MutationResult<StartConversationMutation>;
export type StartConversationMutationOptions = Apollo.BaseMutationOptions<
  StartConversationMutation,
  StartConversationMutationVariables
>;
export const AddMessageDocument = gql`
  mutation AddMessage(
    $accountId: ID!
    $conversationId: ID!
    $message: ConversationMessageInput!
    $exploration: ExplorationInput
    $variables: JSON
    $correlationId: String
    $selectors: [String]
  ) {
    addMessage(
      accountId: $accountId
      conversationId: $conversationId
      message: $message
      exploration: $exploration
      variables: $variables
      correlationId: $correlationId
      selectors: $selectors
    ) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragmentFragmentDoc}
`;
export type AddMessageMutationFn = Apollo.MutationFunction<
  AddMessageMutation,
  AddMessageMutationVariables
>;

/**
 * __useAddMessageMutation__
 *
 * To run a mutation, you first call `useAddMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMessageMutation, { data, loading, error }] = useAddMessageMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      conversationId: // value for 'conversationId'
 *      message: // value for 'message'
 *      exploration: // value for 'exploration'
 *      variables: // value for 'variables'
 *      correlationId: // value for 'correlationId'
 *      selectors: // value for 'selectors'
 *   },
 * });
 */
export function useAddMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<AddMessageMutation, AddMessageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddMessageMutation, AddMessageMutationVariables>(
    AddMessageDocument,
    options,
  );
}
export type AddMessageMutationHookResult = ReturnType<typeof useAddMessageMutation>;
export type AddMessageMutationResult = Apollo.MutationResult<AddMessageMutation>;
export type AddMessageMutationOptions = Apollo.BaseMutationOptions<
  AddMessageMutation,
  AddMessageMutationVariables
>;
export const UpdateMessageDocument = gql`
  mutation UpdateMessage(
    $accountId: ID!
    $conversationId: ID!
    $message: ConversationMessageInput!
    $exploration: ExplorationInput
    $variables: JSON
    $correlationId: String
    $selectors: [String]
  ) {
    updateMessage(
      accountId: $accountId
      conversationId: $conversationId
      message: $message
      exploration: $exploration
      variables: $variables
      correlationId: $correlationId
      selectors: $selectors
    ) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragmentFragmentDoc}
`;
export type UpdateMessageMutationFn = Apollo.MutationFunction<
  UpdateMessageMutation,
  UpdateMessageMutationVariables
>;

/**
 * __useUpdateMessageMutation__
 *
 * To run a mutation, you first call `useUpdateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageMutation, { data, loading, error }] = useUpdateMessageMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      conversationId: // value for 'conversationId'
 *      message: // value for 'message'
 *      exploration: // value for 'exploration'
 *      variables: // value for 'variables'
 *      correlationId: // value for 'correlationId'
 *      selectors: // value for 'selectors'
 *   },
 * });
 */
export function useUpdateMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateMessageMutation, UpdateMessageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateMessageMutation, UpdateMessageMutationVariables>(
    UpdateMessageDocument,
    options,
  );
}
export type UpdateMessageMutationHookResult = ReturnType<typeof useUpdateMessageMutation>;
export type UpdateMessageMutationResult = Apollo.MutationResult<UpdateMessageMutation>;
export type UpdateMessageMutationOptions = Apollo.BaseMutationOptions<
  UpdateMessageMutation,
  UpdateMessageMutationVariables
>;
export const DiscardMessageDocument = gql`
  mutation DiscardMessage($accountId: ID!, $conversationId: ID!, $messageId: ID!) {
    discardMessage(accountId: $accountId, conversationId: $conversationId, messageId: $messageId) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragmentFragmentDoc}
`;
export type DiscardMessageMutationFn = Apollo.MutationFunction<
  DiscardMessageMutation,
  DiscardMessageMutationVariables
>;

/**
 * __useDiscardMessageMutation__
 *
 * To run a mutation, you first call `useDiscardMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardMessageMutation, { data, loading, error }] = useDiscardMessageMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      conversationId: // value for 'conversationId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDiscardMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<DiscardMessageMutation, DiscardMessageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DiscardMessageMutation, DiscardMessageMutationVariables>(
    DiscardMessageDocument,
    options,
  );
}
export type DiscardMessageMutationHookResult = ReturnType<typeof useDiscardMessageMutation>;
export type DiscardMessageMutationResult = Apollo.MutationResult<DiscardMessageMutation>;
export type DiscardMessageMutationOptions = Apollo.BaseMutationOptions<
  DiscardMessageMutation,
  DiscardMessageMutationVariables
>;
export const DeleteMessageDocument = gql`
  mutation DeleteMessage($accountId: ID!, $conversationId: ID!, $messageId: ID!) {
    deleteMessage(accountId: $accountId, conversationId: $conversationId, messageId: $messageId) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragmentFragmentDoc}
`;
export type DeleteMessageMutationFn = Apollo.MutationFunction<
  DeleteMessageMutation,
  DeleteMessageMutationVariables
>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      conversationId: // value for 'conversationId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDeleteMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(
    DeleteMessageDocument,
    options,
  );
}
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<
  DeleteMessageMutation,
  DeleteMessageMutationVariables
>;
export const CancelConversationJobDocument = gql`
  mutation CancelConversationJob($accountId: ID!, $conversationId: ID!, $jobId: ID!) {
    cancelConversationJob(accountId: $accountId, conversationId: $conversationId, jobId: $jobId) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragmentFragmentDoc}
`;
export type CancelConversationJobMutationFn = Apollo.MutationFunction<
  CancelConversationJobMutation,
  CancelConversationJobMutationVariables
>;

/**
 * __useCancelConversationJobMutation__
 *
 * To run a mutation, you first call `useCancelConversationJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelConversationJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelConversationJobMutation, { data, loading, error }] = useCancelConversationJobMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      conversationId: // value for 'conversationId'
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelConversationJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelConversationJobMutation,
    CancelConversationJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelConversationJobMutation, CancelConversationJobMutationVariables>(
    CancelConversationJobDocument,
    options,
  );
}
export type CancelConversationJobMutationHookResult = ReturnType<
  typeof useCancelConversationJobMutation
>;
export type CancelConversationJobMutationResult =
  Apollo.MutationResult<CancelConversationJobMutation>;
export type CancelConversationJobMutationOptions = Apollo.BaseMutationOptions<
  CancelConversationJobMutation,
  CancelConversationJobMutationVariables
>;
export const RerunConversationJobDocument = gql`
  mutation RerunConversationJob(
    $accountId: ID!
    $conversationId: ID!
    $jobId: ID!
    $exploration: ExplorationInput
    $variables: JSON
    $correlationId: String
    $selectors: [String]
  ) {
    rerunConversationJob(
      accountId: $accountId
      conversationId: $conversationId
      jobId: $jobId
      exploration: $exploration
      variables: $variables
      correlationId: $correlationId
      selectors: $selectors
    ) {
      conversation {
        ...ConversationFragment
      }
    }
  }
  ${ConversationFragmentFragmentDoc}
`;
export type RerunConversationJobMutationFn = Apollo.MutationFunction<
  RerunConversationJobMutation,
  RerunConversationJobMutationVariables
>;

/**
 * __useRerunConversationJobMutation__
 *
 * To run a mutation, you first call `useRerunConversationJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunConversationJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunConversationJobMutation, { data, loading, error }] = useRerunConversationJobMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      conversationId: // value for 'conversationId'
 *      jobId: // value for 'jobId'
 *      exploration: // value for 'exploration'
 *      variables: // value for 'variables'
 *      correlationId: // value for 'correlationId'
 *      selectors: // value for 'selectors'
 *   },
 * });
 */
export function useRerunConversationJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RerunConversationJobMutation,
    RerunConversationJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RerunConversationJobMutation, RerunConversationJobMutationVariables>(
    RerunConversationJobDocument,
    options,
  );
}
export type RerunConversationJobMutationHookResult = ReturnType<
  typeof useRerunConversationJobMutation
>;
export type RerunConversationJobMutationResult =
  Apollo.MutationResult<RerunConversationJobMutation>;
export type RerunConversationJobMutationOptions = Apollo.BaseMutationOptions<
  RerunConversationJobMutation,
  RerunConversationJobMutationVariables
>;
export const ExecutePythonCellDocument = gql`
  mutation ExecutePythonCell($accountId: ID!, $code: String!, $dataContext: JSON!) {
    executePythonCell(accountId: $accountId, code: $code, dataContext: $dataContext) {
      result
      logs
    }
  }
`;
export type ExecutePythonCellMutationFn = Apollo.MutationFunction<
  ExecutePythonCellMutation,
  ExecutePythonCellMutationVariables
>;

/**
 * __useExecutePythonCellMutation__
 *
 * To run a mutation, you first call `useExecutePythonCellMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecutePythonCellMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executePythonCellMutation, { data, loading, error }] = useExecutePythonCellMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      code: // value for 'code'
 *      dataContext: // value for 'dataContext'
 *   },
 * });
 */
export function useExecutePythonCellMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecutePythonCellMutation,
    ExecutePythonCellMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExecutePythonCellMutation, ExecutePythonCellMutationVariables>(
    ExecutePythonCellDocument,
    options,
  );
}
export type ExecutePythonCellMutationHookResult = ReturnType<typeof useExecutePythonCellMutation>;
export type ExecutePythonCellMutationResult = Apollo.MutationResult<ExecutePythonCellMutation>;
export type ExecutePythonCellMutationOptions = Apollo.BaseMutationOptions<
  ExecutePythonCellMutation,
  ExecutePythonCellMutationVariables
>;
export const ExplorationsSearchDocument = gql`
  query ExplorationsSearch($accountId: ID!, $search: String!) {
    account(accountId: $accountId) {
      explorationSearch(search: $search) {
        ...ExplorationDataFragment
      }
    }
  }
  ${ExplorationDataFragmentFragmentDoc}
`;

/**
 * __useExplorationsSearchQuery__
 *
 * To run a query within a React component, call `useExplorationsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplorationsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplorationsSearchQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useExplorationsSearchQuery(
  baseOptions: Apollo.QueryHookOptions<ExplorationsSearchQuery, ExplorationsSearchQueryVariables> &
    ({ variables: ExplorationsSearchQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExplorationsSearchQuery, ExplorationsSearchQueryVariables>(
    ExplorationsSearchDocument,
    options,
  );
}
export function useExplorationsSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExplorationsSearchQuery,
    ExplorationsSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExplorationsSearchQuery, ExplorationsSearchQueryVariables>(
    ExplorationsSearchDocument,
    options,
  );
}
export function useExplorationsSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExplorationsSearchQuery, ExplorationsSearchQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExplorationsSearchQuery, ExplorationsSearchQueryVariables>(
    ExplorationsSearchDocument,
    options,
  );
}
export type ExplorationsSearchQueryHookResult = ReturnType<typeof useExplorationsSearchQuery>;
export type ExplorationsSearchLazyQueryHookResult = ReturnType<
  typeof useExplorationsSearchLazyQuery
>;
export type ExplorationsSearchSuspenseQueryHookResult = ReturnType<
  typeof useExplorationsSearchSuspenseQuery
>;
export type ExplorationsSearchQueryResult = Apollo.QueryResult<
  ExplorationsSearchQuery,
  ExplorationsSearchQueryVariables
>;
export const ExplorationDocument = gql`
  query Exploration($accountId: ID!, $explorationId: ID!) {
    account(accountId: $accountId) {
      exploration(explorationId: $explorationId) {
        ...ExplorationFragment
      }
    }
  }
  ${ExplorationFragmentFragmentDoc}
`;

/**
 * __useExplorationQuery__
 *
 * To run a query within a React component, call `useExplorationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplorationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplorationQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      explorationId: // value for 'explorationId'
 *   },
 * });
 */
export function useExplorationQuery(
  baseOptions: Apollo.QueryHookOptions<ExplorationQuery, ExplorationQueryVariables> &
    ({ variables: ExplorationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExplorationQuery, ExplorationQueryVariables>(ExplorationDocument, options);
}
export function useExplorationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ExplorationQuery, ExplorationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExplorationQuery, ExplorationQueryVariables>(
    ExplorationDocument,
    options,
  );
}
export function useExplorationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExplorationQuery, ExplorationQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExplorationQuery, ExplorationQueryVariables>(
    ExplorationDocument,
    options,
  );
}
export type ExplorationQueryHookResult = ReturnType<typeof useExplorationQuery>;
export type ExplorationLazyQueryHookResult = ReturnType<typeof useExplorationLazyQuery>;
export type ExplorationSuspenseQueryHookResult = ReturnType<typeof useExplorationSuspenseQuery>;
export type ExplorationQueryResult = Apollo.QueryResult<
  ExplorationQuery,
  ExplorationQueryVariables
>;
export const StreamPipelineDocument = gql`
  subscription StreamPipeline($input: StreamPipelineInput!) {
    streamPipeline(input: $input) {
      rows
      rowCount
      totalRows
      recordType {
        ...RecordTypeFragment
      }
      grouping {
        key
      }
    }
  }
  ${RecordTypeFragmentFragmentDoc}
`;

/**
 * __useStreamPipelineSubscription__
 *
 * To run a query within a React component, call `useStreamPipelineSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStreamPipelineSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreamPipelineSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStreamPipelineSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    StreamPipelineSubscription,
    StreamPipelineSubscriptionVariables
  > &
    ({ variables: StreamPipelineSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<StreamPipelineSubscription, StreamPipelineSubscriptionVariables>(
    StreamPipelineDocument,
    options,
  );
}
export type StreamPipelineSubscriptionHookResult = ReturnType<typeof useStreamPipelineSubscription>;
export type StreamPipelineSubscriptionResult =
  Apollo.SubscriptionResult<StreamPipelineSubscription>;
export const DeleteExplorationDocument = gql`
  mutation DeleteExploration($accountId: ID!, $explorationId: ID!) {
    deleteExploration(accountId: $accountId, explorationId: $explorationId) {
      ... on DeleteExplorationSuccess {
        result
      }
      ... on NotAllowedError {
        message
      }
    }
  }
`;
export type DeleteExplorationMutationFn = Apollo.MutationFunction<
  DeleteExplorationMutation,
  DeleteExplorationMutationVariables
>;

/**
 * __useDeleteExplorationMutation__
 *
 * To run a mutation, you first call `useDeleteExplorationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExplorationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExplorationMutation, { data, loading, error }] = useDeleteExplorationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      explorationId: // value for 'explorationId'
 *   },
 * });
 */
export function useDeleteExplorationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteExplorationMutation,
    DeleteExplorationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteExplorationMutation, DeleteExplorationMutationVariables>(
    DeleteExplorationDocument,
    options,
  );
}
export type DeleteExplorationMutationHookResult = ReturnType<typeof useDeleteExplorationMutation>;
export type DeleteExplorationMutationResult = Apollo.MutationResult<DeleteExplorationMutation>;
export type DeleteExplorationMutationOptions = Apollo.BaseMutationOptions<
  DeleteExplorationMutation,
  DeleteExplorationMutationVariables
>;
export const EnumOptionsDocument = gql`
  query EnumOptions($accountId: ID!, $modelId: ID!, $propertyKey: String!) {
    account(accountId: $accountId) {
      accountId
      model(modelId: $modelId) {
        modelId
        property(key: $propertyKey) {
          key
          enumOptions {
            label
            value
          }
        }
      }
    }
  }
`;

/**
 * __useEnumOptionsQuery__
 *
 * To run a query within a React component, call `useEnumOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnumOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnumOptionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      modelId: // value for 'modelId'
 *      propertyKey: // value for 'propertyKey'
 *   },
 * });
 */
export function useEnumOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<EnumOptionsQuery, EnumOptionsQueryVariables> &
    ({ variables: EnumOptionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EnumOptionsQuery, EnumOptionsQueryVariables>(EnumOptionsDocument, options);
}
export function useEnumOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EnumOptionsQuery, EnumOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EnumOptionsQuery, EnumOptionsQueryVariables>(
    EnumOptionsDocument,
    options,
  );
}
export function useEnumOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EnumOptionsQuery, EnumOptionsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EnumOptionsQuery, EnumOptionsQueryVariables>(
    EnumOptionsDocument,
    options,
  );
}
export type EnumOptionsQueryHookResult = ReturnType<typeof useEnumOptionsQuery>;
export type EnumOptionsLazyQueryHookResult = ReturnType<typeof useEnumOptionsLazyQuery>;
export type EnumOptionsSuspenseQueryHookResult = ReturnType<typeof useEnumOptionsSuspenseQuery>;
export type EnumOptionsQueryResult = Apollo.QueryResult<
  EnumOptionsQuery,
  EnumOptionsQueryVariables
>;
export const ExplorationChatDocument = gql`
  subscription ExplorationChat(
    $accountId: ID!
    $conversation: ConversationInput!
    $exploration: ExplorationInput
    $variables: JSON
    $correlationId: String
    $selectors: [String]
  ) {
    ask(
      accountId: $accountId
      conversation: $conversation
      exploration: $exploration
      variables: $variables
      correlationId: $correlationId
      selectors: $selectors
    ) {
      lastMessage {
        ... on ConversationTextMessage {
          id
          role
          type
          message
        }
        ... on ConversationExplorationMessage {
          id
          role
          type
          exploration {
            ...ExplorationDataFragment
          }
        }
      }
    }
  }
  ${ExplorationDataFragmentFragmentDoc}
`;

/**
 * __useExplorationChatSubscription__
 *
 * To run a query within a React component, call `useExplorationChatSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExplorationChatSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplorationChatSubscription({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      conversation: // value for 'conversation'
 *      exploration: // value for 'exploration'
 *      variables: // value for 'variables'
 *      correlationId: // value for 'correlationId'
 *      selectors: // value for 'selectors'
 *   },
 * });
 */
export function useExplorationChatSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ExplorationChatSubscription,
    ExplorationChatSubscriptionVariables
  > &
    ({ variables: ExplorationChatSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<ExplorationChatSubscription, ExplorationChatSubscriptionVariables>(
    ExplorationChatDocument,
    options,
  );
}
export type ExplorationChatSubscriptionHookResult = ReturnType<
  typeof useExplorationChatSubscription
>;
export type ExplorationChatSubscriptionResult =
  Apollo.SubscriptionResult<ExplorationChatSubscription>;
export const ExplorationDataDocument = gql`
  query ExplorationData(
    $accountId: ID!
    $baseModelId: ID!
    $pipeline: [OperationInput!]!
    $first: Int
    $after: String
    $sort: [QuerySortBy!]
    $variables: JSON
    $options: QueryOptionsInput
  ) {
    account(accountId: $accountId) {
      accountId
      name
      query(
        baseModelId: $baseModelId
        pipeline: $pipeline
        first: $first
        after: $after
        sort: $sort
        variables: $variables
        options: $options
      ) {
        edges {
          node
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        recordType {
          ...RecordTypeFragment
        }
        grouping {
          key
        }
      }
    }
  }
  ${RecordTypeFragmentFragmentDoc}
`;

/**
 * __useExplorationDataQuery__
 *
 * To run a query within a React component, call `useExplorationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplorationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplorationDataQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      baseModelId: // value for 'baseModelId'
 *      pipeline: // value for 'pipeline'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      variables: // value for 'variables'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useExplorationDataQuery(
  baseOptions: Apollo.QueryHookOptions<ExplorationDataQuery, ExplorationDataQueryVariables> &
    ({ variables: ExplorationDataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExplorationDataQuery, ExplorationDataQueryVariables>(
    ExplorationDataDocument,
    options,
  );
}
export function useExplorationDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ExplorationDataQuery, ExplorationDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExplorationDataQuery, ExplorationDataQueryVariables>(
    ExplorationDataDocument,
    options,
  );
}
export function useExplorationDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExplorationDataQuery, ExplorationDataQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExplorationDataQuery, ExplorationDataQueryVariables>(
    ExplorationDataDocument,
    options,
  );
}
export type ExplorationDataQueryHookResult = ReturnType<typeof useExplorationDataQuery>;
export type ExplorationDataLazyQueryHookResult = ReturnType<typeof useExplorationDataLazyQuery>;
export type ExplorationDataSuspenseQueryHookResult = ReturnType<
  typeof useExplorationDataSuspenseQuery
>;
export type ExplorationDataQueryResult = Apollo.QueryResult<
  ExplorationDataQuery,
  ExplorationDataQueryVariables
>;
export const ExplorationDescribeQueryDocument = gql`
  query ExplorationDescribeQuery(
    $accountId: ID!
    $baseModelId: ID!
    $pipeline: [OperationInput!]!
    $first: Int
    $after: String
    $sort: [QuerySortBy!]
    $variables: JSON
    $options: QueryOptionsInput
  ) {
    account(accountId: $accountId) {
      accountId
      name
      describeQuery(
        baseModelId: $baseModelId
        pipeline: $pipeline
        first: $first
        after: $after
        sort: $sort
        variables: $variables
        options: $options
      ) {
        sql
      }
    }
  }
`;

/**
 * __useExplorationDescribeQueryQuery__
 *
 * To run a query within a React component, call `useExplorationDescribeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExplorationDescribeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExplorationDescribeQueryQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      baseModelId: // value for 'baseModelId'
 *      pipeline: // value for 'pipeline'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      variables: // value for 'variables'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useExplorationDescribeQueryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExplorationDescribeQueryQuery,
    ExplorationDescribeQueryQueryVariables
  > &
    ({ variables: ExplorationDescribeQueryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExplorationDescribeQueryQuery, ExplorationDescribeQueryQueryVariables>(
    ExplorationDescribeQueryDocument,
    options,
  );
}
export function useExplorationDescribeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExplorationDescribeQueryQuery,
    ExplorationDescribeQueryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExplorationDescribeQueryQuery, ExplorationDescribeQueryQueryVariables>(
    ExplorationDescribeQueryDocument,
    options,
  );
}
export function useExplorationDescribeQuerySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExplorationDescribeQueryQuery,
        ExplorationDescribeQueryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExplorationDescribeQueryQuery,
    ExplorationDescribeQueryQueryVariables
  >(ExplorationDescribeQueryDocument, options);
}
export type ExplorationDescribeQueryQueryHookResult = ReturnType<
  typeof useExplorationDescribeQueryQuery
>;
export type ExplorationDescribeQueryLazyQueryHookResult = ReturnType<
  typeof useExplorationDescribeQueryLazyQuery
>;
export type ExplorationDescribeQuerySuspenseQueryHookResult = ReturnType<
  typeof useExplorationDescribeQuerySuspenseQuery
>;
export type ExplorationDescribeQueryQueryResult = Apollo.QueryResult<
  ExplorationDescribeQueryQuery,
  ExplorationDescribeQueryQueryVariables
>;
export const ToggleUserPinnedExplorationDocument = gql`
  mutation ToggleUserPinnedExploration($accountId: ID!, $explorationId: ID!) {
    toggleUserPinnedExploration(accountId: $accountId, explorationId: $explorationId) {
      userId
      pinnedExplorationIds
    }
  }
`;
export type ToggleUserPinnedExplorationMutationFn = Apollo.MutationFunction<
  ToggleUserPinnedExplorationMutation,
  ToggleUserPinnedExplorationMutationVariables
>;

/**
 * __useToggleUserPinnedExplorationMutation__
 *
 * To run a mutation, you first call `useToggleUserPinnedExplorationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserPinnedExplorationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserPinnedExplorationMutation, { data, loading, error }] = useToggleUserPinnedExplorationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      explorationId: // value for 'explorationId'
 *   },
 * });
 */
export function useToggleUserPinnedExplorationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleUserPinnedExplorationMutation,
    ToggleUserPinnedExplorationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleUserPinnedExplorationMutation,
    ToggleUserPinnedExplorationMutationVariables
  >(ToggleUserPinnedExplorationDocument, options);
}
export type ToggleUserPinnedExplorationMutationHookResult = ReturnType<
  typeof useToggleUserPinnedExplorationMutation
>;
export type ToggleUserPinnedExplorationMutationResult =
  Apollo.MutationResult<ToggleUserPinnedExplorationMutation>;
export type ToggleUserPinnedExplorationMutationOptions = Apollo.BaseMutationOptions<
  ToggleUserPinnedExplorationMutation,
  ToggleUserPinnedExplorationMutationVariables
>;
export const UpsertExplorationDocument = gql`
  mutation UpsertExploration($accountId: ID!, $input: ExplorationInput!) {
    upsertExploration(accountId: $accountId, input: $input) {
      ...ExplorationFragment
    }
  }
  ${ExplorationFragmentFragmentDoc}
`;
export type UpsertExplorationMutationFn = Apollo.MutationFunction<
  UpsertExplorationMutation,
  UpsertExplorationMutationVariables
>;

/**
 * __useUpsertExplorationMutation__
 *
 * To run a mutation, you first call `useUpsertExplorationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertExplorationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertExplorationMutation, { data, loading, error }] = useUpsertExplorationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertExplorationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertExplorationMutation,
    UpsertExplorationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertExplorationMutation, UpsertExplorationMutationVariables>(
    UpsertExplorationDocument,
    options,
  );
}
export type UpsertExplorationMutationHookResult = ReturnType<typeof useUpsertExplorationMutation>;
export type UpsertExplorationMutationResult = Apollo.MutationResult<UpsertExplorationMutation>;
export type UpsertExplorationMutationOptions = Apollo.BaseMutationOptions<
  UpsertExplorationMutation,
  UpsertExplorationMutationVariables
>;
export const GetExplorationStateDocument = gql`
  query GetExplorationState($accountId: ID!, $explorationId: ID!) {
    account(accountId: $accountId) {
      explorationState(explorationId: $explorationId) {
        explorationId
        previousStateId
        explorationSourceId
        state
      }
    }
  }
`;

/**
 * __useGetExplorationStateQuery__
 *
 * To run a query within a React component, call `useGetExplorationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExplorationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExplorationStateQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      explorationId: // value for 'explorationId'
 *   },
 * });
 */
export function useGetExplorationStateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetExplorationStateQuery,
    GetExplorationStateQueryVariables
  > &
    ({ variables: GetExplorationStateQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetExplorationStateQuery, GetExplorationStateQueryVariables>(
    GetExplorationStateDocument,
    options,
  );
}
export function useGetExplorationStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExplorationStateQuery,
    GetExplorationStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetExplorationStateQuery, GetExplorationStateQueryVariables>(
    GetExplorationStateDocument,
    options,
  );
}
export function useGetExplorationStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetExplorationStateQuery, GetExplorationStateQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetExplorationStateQuery, GetExplorationStateQueryVariables>(
    GetExplorationStateDocument,
    options,
  );
}
export type GetExplorationStateQueryHookResult = ReturnType<typeof useGetExplorationStateQuery>;
export type GetExplorationStateLazyQueryHookResult = ReturnType<
  typeof useGetExplorationStateLazyQuery
>;
export type GetExplorationStateSuspenseQueryHookResult = ReturnType<
  typeof useGetExplorationStateSuspenseQuery
>;
export type GetExplorationStateQueryResult = Apollo.QueryResult<
  GetExplorationStateQuery,
  GetExplorationStateQueryVariables
>;
export const SetExplorationStateDocument = gql`
  mutation SetExplorationState($accountId: ID!, $input: ExplorationStateInput!) {
    upsertExplorationState(accountId: $accountId, input: $input) {
      explorationId
      previousStateId
      explorationSourceId
      state
    }
  }
`;
export type SetExplorationStateMutationFn = Apollo.MutationFunction<
  SetExplorationStateMutation,
  SetExplorationStateMutationVariables
>;

/**
 * __useSetExplorationStateMutation__
 *
 * To run a mutation, you first call `useSetExplorationStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExplorationStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExplorationStateMutation, { data, loading, error }] = useSetExplorationStateMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetExplorationStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetExplorationStateMutation,
    SetExplorationStateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetExplorationStateMutation, SetExplorationStateMutationVariables>(
    SetExplorationStateDocument,
    options,
  );
}
export type SetExplorationStateMutationHookResult = ReturnType<
  typeof useSetExplorationStateMutation
>;
export type SetExplorationStateMutationResult = Apollo.MutationResult<SetExplorationStateMutation>;
export type SetExplorationStateMutationOptions = Apollo.BaseMutationOptions<
  SetExplorationStateMutation,
  SetExplorationStateMutationVariables
>;
export const InboxItemsDocument = gql`
  query InboxItems($accountId: ID!) {
    account(accountId: $accountId) {
      accountId
      inboxItems {
        inboxItemId
        source
        status
        title
        details
        dismissalReason
        statusChangedAt
        statusChangedBy {
          userId
          email
        }
        createdAt
        users {
          userId
          email
        }
        conversations {
          conversationId
          explorationStateId
          createdAt
          messageId
          question
          user {
            userId
            email
          }
        }
      }
    }
  }
`;

/**
 * __useInboxItemsQuery__
 *
 * To run a query within a React component, call `useInboxItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxItemsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useInboxItemsQuery(
  baseOptions: Apollo.QueryHookOptions<InboxItemsQuery, InboxItemsQueryVariables> &
    ({ variables: InboxItemsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InboxItemsQuery, InboxItemsQueryVariables>(InboxItemsDocument, options);
}
export function useInboxItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InboxItemsQuery, InboxItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InboxItemsQuery, InboxItemsQueryVariables>(
    InboxItemsDocument,
    options,
  );
}
export function useInboxItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InboxItemsQuery, InboxItemsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InboxItemsQuery, InboxItemsQueryVariables>(
    InboxItemsDocument,
    options,
  );
}
export type InboxItemsQueryHookResult = ReturnType<typeof useInboxItemsQuery>;
export type InboxItemsLazyQueryHookResult = ReturnType<typeof useInboxItemsLazyQuery>;
export type InboxItemsSuspenseQueryHookResult = ReturnType<typeof useInboxItemsSuspenseQuery>;
export type InboxItemsQueryResult = Apollo.QueryResult<InboxItemsQuery, InboxItemsQueryVariables>;
export const InboxItemCountDocument = gql`
  query InboxItemCount($accountId: ID!) {
    account(accountId: $accountId) {
      accountId
      inboxItemCount
    }
  }
`;

/**
 * __useInboxItemCountQuery__
 *
 * To run a query within a React component, call `useInboxItemCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxItemCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxItemCountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useInboxItemCountQuery(
  baseOptions: Apollo.QueryHookOptions<InboxItemCountQuery, InboxItemCountQueryVariables> &
    ({ variables: InboxItemCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InboxItemCountQuery, InboxItemCountQueryVariables>(
    InboxItemCountDocument,
    options,
  );
}
export function useInboxItemCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InboxItemCountQuery, InboxItemCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InboxItemCountQuery, InboxItemCountQueryVariables>(
    InboxItemCountDocument,
    options,
  );
}
export function useInboxItemCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<InboxItemCountQuery, InboxItemCountQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InboxItemCountQuery, InboxItemCountQueryVariables>(
    InboxItemCountDocument,
    options,
  );
}
export type InboxItemCountQueryHookResult = ReturnType<typeof useInboxItemCountQuery>;
export type InboxItemCountLazyQueryHookResult = ReturnType<typeof useInboxItemCountLazyQuery>;
export type InboxItemCountSuspenseQueryHookResult = ReturnType<
  typeof useInboxItemCountSuspenseQuery
>;
export type InboxItemCountQueryResult = Apollo.QueryResult<
  InboxItemCountQuery,
  InboxItemCountQueryVariables
>;
export const ResolveInboxItemDocument = gql`
  mutation ResolveInboxItem($accountId: ID!, $inboxItemId: ID!) {
    resolveInboxItem(accountId: $accountId, inboxItemId: $inboxItemId)
  }
`;
export type ResolveInboxItemMutationFn = Apollo.MutationFunction<
  ResolveInboxItemMutation,
  ResolveInboxItemMutationVariables
>;

/**
 * __useResolveInboxItemMutation__
 *
 * To run a mutation, you first call `useResolveInboxItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveInboxItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveInboxItemMutation, { data, loading, error }] = useResolveInboxItemMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      inboxItemId: // value for 'inboxItemId'
 *   },
 * });
 */
export function useResolveInboxItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResolveInboxItemMutation,
    ResolveInboxItemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResolveInboxItemMutation, ResolveInboxItemMutationVariables>(
    ResolveInboxItemDocument,
    options,
  );
}
export type ResolveInboxItemMutationHookResult = ReturnType<typeof useResolveInboxItemMutation>;
export type ResolveInboxItemMutationResult = Apollo.MutationResult<ResolveInboxItemMutation>;
export type ResolveInboxItemMutationOptions = Apollo.BaseMutationOptions<
  ResolveInboxItemMutation,
  ResolveInboxItemMutationVariables
>;
export const UpdateInboxItemStatusDocument = gql`
  mutation UpdateInboxItemStatus(
    $accountId: ID!
    $inboxItemId: ID!
    $status: InboxItemReviewStatus!
    $dismissalReason: String
  ) {
    updateInboxItemStatus(
      accountId: $accountId
      inboxItemId: $inboxItemId
      status: $status
      dismissalReason: $dismissalReason
    )
  }
`;
export type UpdateInboxItemStatusMutationFn = Apollo.MutationFunction<
  UpdateInboxItemStatusMutation,
  UpdateInboxItemStatusMutationVariables
>;

/**
 * __useUpdateInboxItemStatusMutation__
 *
 * To run a mutation, you first call `useUpdateInboxItemStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInboxItemStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInboxItemStatusMutation, { data, loading, error }] = useUpdateInboxItemStatusMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      inboxItemId: // value for 'inboxItemId'
 *      status: // value for 'status'
 *      dismissalReason: // value for 'dismissalReason'
 *   },
 * });
 */
export function useUpdateInboxItemStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateInboxItemStatusMutation,
    UpdateInboxItemStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateInboxItemStatusMutation, UpdateInboxItemStatusMutationVariables>(
    UpdateInboxItemStatusDocument,
    options,
  );
}
export type UpdateInboxItemStatusMutationHookResult = ReturnType<
  typeof useUpdateInboxItemStatusMutation
>;
export type UpdateInboxItemStatusMutationResult =
  Apollo.MutationResult<UpdateInboxItemStatusMutation>;
export type UpdateInboxItemStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateInboxItemStatusMutation,
  UpdateInboxItemStatusMutationVariables
>;
export const CreateAnalyticsEventDocument = gql`
  mutation CreateAnalyticsEvent($input: CreateAnalyticsEventInput!, $accountId: ID!) {
    createAnalyticsEvent(input: $input, accountId: $accountId) {
      ... on AnalyticsEvent {
        analyticsEventId
      }
      ... on NotAllowedError {
        message
      }
      ... on CreateAnalyticsEventError {
        error
      }
    }
  }
`;
export type CreateAnalyticsEventMutationFn = Apollo.MutationFunction<
  CreateAnalyticsEventMutation,
  CreateAnalyticsEventMutationVariables
>;

/**
 * __useCreateAnalyticsEventMutation__
 *
 * To run a mutation, you first call `useCreateAnalyticsEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnalyticsEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnalyticsEventMutation, { data, loading, error }] = useCreateAnalyticsEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCreateAnalyticsEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAnalyticsEventMutation,
    CreateAnalyticsEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAnalyticsEventMutation, CreateAnalyticsEventMutationVariables>(
    CreateAnalyticsEventDocument,
    options,
  );
}
export type CreateAnalyticsEventMutationHookResult = ReturnType<
  typeof useCreateAnalyticsEventMutation
>;
export type CreateAnalyticsEventMutationResult =
  Apollo.MutationResult<CreateAnalyticsEventMutation>;
export type CreateAnalyticsEventMutationOptions = Apollo.BaseMutationOptions<
  CreateAnalyticsEventMutation,
  CreateAnalyticsEventMutationVariables
>;
export const MetadataDocument = gql`
  query Metadata($accountId: ID!) {
    account(accountId: $accountId) {
      accountId
      explorationMetadata {
        ...ExplorationMetadataFragment
      }
      models {
        ...ModelFragment
      }
      metrics {
        ...MetricFragment
      }
    }
  }
  ${ExplorationMetadataFragmentFragmentDoc}
  ${ModelFragmentFragmentDoc}
  ${MetricFragmentFragmentDoc}
`;

/**
 * __useMetadataQuery__
 *
 * To run a query within a React component, call `useMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetadataQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useMetadataQuery(
  baseOptions: Apollo.QueryHookOptions<MetadataQuery, MetadataQueryVariables> &
    ({ variables: MetadataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MetadataQuery, MetadataQueryVariables>(MetadataDocument, options);
}
export function useMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MetadataQuery, MetadataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MetadataQuery, MetadataQueryVariables>(MetadataDocument, options);
}
export function useMetadataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MetadataQuery, MetadataQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MetadataQuery, MetadataQueryVariables>(MetadataDocument, options);
}
export type MetadataQueryHookResult = ReturnType<typeof useMetadataQuery>;
export type MetadataLazyQueryHookResult = ReturnType<typeof useMetadataLazyQuery>;
export type MetadataSuspenseQueryHookResult = ReturnType<typeof useMetadataSuspenseQuery>;
export type MetadataQueryResult = Apollo.QueryResult<MetadataQuery, MetadataQueryVariables>;
export const OnboardingStateDocument = gql`
  query OnboardingState($accountId: ID!) {
    account(accountId: $accountId) {
      onboardingState {
        hasConnection
        hasConsented
        hasOnboarded
        hasPassedSetupCallStep
        hasBookedSetupCall
        welcomeSurvey
      }
    }
  }
`;

/**
 * __useOnboardingStateQuery__
 *
 * To run a query within a React component, call `useOnboardingStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingStateQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useOnboardingStateQuery(
  baseOptions: Apollo.QueryHookOptions<OnboardingStateQuery, OnboardingStateQueryVariables> &
    ({ variables: OnboardingStateQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OnboardingStateQuery, OnboardingStateQueryVariables>(
    OnboardingStateDocument,
    options,
  );
}
export function useOnboardingStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OnboardingStateQuery, OnboardingStateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OnboardingStateQuery, OnboardingStateQueryVariables>(
    OnboardingStateDocument,
    options,
  );
}
export function useOnboardingStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<OnboardingStateQuery, OnboardingStateQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OnboardingStateQuery, OnboardingStateQueryVariables>(
    OnboardingStateDocument,
    options,
  );
}
export type OnboardingStateQueryHookResult = ReturnType<typeof useOnboardingStateQuery>;
export type OnboardingStateLazyQueryHookResult = ReturnType<typeof useOnboardingStateLazyQuery>;
export type OnboardingStateSuspenseQueryHookResult = ReturnType<
  typeof useOnboardingStateSuspenseQuery
>;
export type OnboardingStateQueryResult = Apollo.QueryResult<
  OnboardingStateQuery,
  OnboardingStateQueryVariables
>;
export const CreateConnectionDocument = gql`
  mutation CreateConnection($accountId: ID!, $type: String!, $name: String!, $properties: JSON!) {
    createConnection(accountId: $accountId, type: $type, name: $name, properties: $properties) {
      connectionId
    }
  }
`;
export type CreateConnectionMutationFn = Apollo.MutationFunction<
  CreateConnectionMutation,
  CreateConnectionMutationVariables
>;

/**
 * __useCreateConnectionMutation__
 *
 * To run a mutation, you first call `useCreateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectionMutation, { data, loading, error }] = useCreateConnectionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      properties: // value for 'properties'
 *   },
 * });
 */
export function useCreateConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConnectionMutation,
    CreateConnectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateConnectionMutation, CreateConnectionMutationVariables>(
    CreateConnectionDocument,
    options,
  );
}
export type CreateConnectionMutationHookResult = ReturnType<typeof useCreateConnectionMutation>;
export type CreateConnectionMutationResult = Apollo.MutationResult<CreateConnectionMutation>;
export type CreateConnectionMutationOptions = Apollo.BaseMutationOptions<
  CreateConnectionMutation,
  CreateConnectionMutationVariables
>;
export const DiscoverModelsDocument = gql`
  query DiscoverModels($accountId: ID!, $input: DiscoverModelsInput) {
    account(accountId: $accountId) {
      discoverModels(input: $input) {
        ... on DiscoverModelsSuccess {
          configurationFile
        }
        ... on DiscoverModelsError {
          error
        }
      }
    }
  }
`;

/**
 * __useDiscoverModelsQuery__
 *
 * To run a query within a React component, call `useDiscoverModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverModelsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscoverModelsQuery(
  baseOptions: Apollo.QueryHookOptions<DiscoverModelsQuery, DiscoverModelsQueryVariables> &
    ({ variables: DiscoverModelsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DiscoverModelsQuery, DiscoverModelsQueryVariables>(
    DiscoverModelsDocument,
    options,
  );
}
export function useDiscoverModelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DiscoverModelsQuery, DiscoverModelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DiscoverModelsQuery, DiscoverModelsQueryVariables>(
    DiscoverModelsDocument,
    options,
  );
}
export function useDiscoverModelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DiscoverModelsQuery, DiscoverModelsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DiscoverModelsQuery, DiscoverModelsQueryVariables>(
    DiscoverModelsDocument,
    options,
  );
}
export type DiscoverModelsQueryHookResult = ReturnType<typeof useDiscoverModelsQuery>;
export type DiscoverModelsLazyQueryHookResult = ReturnType<typeof useDiscoverModelsLazyQuery>;
export type DiscoverModelsSuspenseQueryHookResult = ReturnType<
  typeof useDiscoverModelsSuspenseQuery
>;
export type DiscoverModelsQueryResult = Apollo.QueryResult<
  DiscoverModelsQuery,
  DiscoverModelsQueryVariables
>;
export const DiscoverSchemasDocument = gql`
  query DiscoverSchemas($accountId: ID!, $connectionId: ID) {
    account(accountId: $accountId) {
      discoverSchemas(input: { connectionId: $connectionId }) {
        ... on DiscoverSchemasSuccess {
          schemas {
            name
          }
        }
        ... on DiscoverSchemasError {
          error
        }
      }
    }
  }
`;

/**
 * __useDiscoverSchemasQuery__
 *
 * To run a query within a React component, call `useDiscoverSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverSchemasQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useDiscoverSchemasQuery(
  baseOptions: Apollo.QueryHookOptions<DiscoverSchemasQuery, DiscoverSchemasQueryVariables> &
    ({ variables: DiscoverSchemasQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DiscoverSchemasQuery, DiscoverSchemasQueryVariables>(
    DiscoverSchemasDocument,
    options,
  );
}
export function useDiscoverSchemasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DiscoverSchemasQuery, DiscoverSchemasQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DiscoverSchemasQuery, DiscoverSchemasQueryVariables>(
    DiscoverSchemasDocument,
    options,
  );
}
export function useDiscoverSchemasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DiscoverSchemasQuery, DiscoverSchemasQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DiscoverSchemasQuery, DiscoverSchemasQueryVariables>(
    DiscoverSchemasDocument,
    options,
  );
}
export type DiscoverSchemasQueryHookResult = ReturnType<typeof useDiscoverSchemasQuery>;
export type DiscoverSchemasLazyQueryHookResult = ReturnType<typeof useDiscoverSchemasLazyQuery>;
export type DiscoverSchemasSuspenseQueryHookResult = ReturnType<
  typeof useDiscoverSchemasSuspenseQuery
>;
export type DiscoverSchemasQueryResult = Apollo.QueryResult<
  DiscoverSchemasQuery,
  DiscoverSchemasQueryVariables
>;
export const ImportConfigurationDocument = gql`
  mutation ImportConfiguration($accountId: ID!, $input: String!) {
    importConfiguration(accountId: $accountId, input: $input) {
      success
      errors
      warnings
    }
  }
`;
export type ImportConfigurationMutationFn = Apollo.MutationFunction<
  ImportConfigurationMutation,
  ImportConfigurationMutationVariables
>;

/**
 * __useImportConfigurationMutation__
 *
 * To run a mutation, you first call `useImportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importConfigurationMutation, { data, loading, error }] = useImportConfigurationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportConfigurationMutation,
    ImportConfigurationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ImportConfigurationMutation, ImportConfigurationMutationVariables>(
    ImportConfigurationDocument,
    options,
  );
}
export type ImportConfigurationMutationHookResult = ReturnType<
  typeof useImportConfigurationMutation
>;
export type ImportConfigurationMutationResult = Apollo.MutationResult<ImportConfigurationMutation>;
export type ImportConfigurationMutationOptions = Apollo.BaseMutationOptions<
  ImportConfigurationMutation,
  ImportConfigurationMutationVariables
>;
export const TestConnectionDocument = gql`
  query TestConnection($accountId: ID!, $type: String!, $properties: JSON!) {
    account(accountId: $accountId) {
      testConnection(type: $type, properties: $properties) {
        ... on TestConnectionSuccess {
          success
        }
        ... on TestConnectionFailed {
          error
        }
      }
    }
  }
`;

/**
 * __useTestConnectionQuery__
 *
 * To run a query within a React component, call `useTestConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestConnectionQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      type: // value for 'type'
 *      properties: // value for 'properties'
 *   },
 * });
 */
export function useTestConnectionQuery(
  baseOptions: Apollo.QueryHookOptions<TestConnectionQuery, TestConnectionQueryVariables> &
    ({ variables: TestConnectionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TestConnectionQuery, TestConnectionQueryVariables>(
    TestConnectionDocument,
    options,
  );
}
export function useTestConnectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TestConnectionQuery, TestConnectionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TestConnectionQuery, TestConnectionQueryVariables>(
    TestConnectionDocument,
    options,
  );
}
export function useTestConnectionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TestConnectionQuery, TestConnectionQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TestConnectionQuery, TestConnectionQueryVariables>(
    TestConnectionDocument,
    options,
  );
}
export type TestConnectionQueryHookResult = ReturnType<typeof useTestConnectionQuery>;
export type TestConnectionLazyQueryHookResult = ReturnType<typeof useTestConnectionLazyQuery>;
export type TestConnectionSuspenseQueryHookResult = ReturnType<
  typeof useTestConnectionSuspenseQuery
>;
export type TestConnectionQueryResult = Apollo.QueryResult<
  TestConnectionQuery,
  TestConnectionQueryVariables
>;
export const GiveConsentDocument = gql`
  mutation GiveConsent($accountId: ID!, $input: ConsentInput!) {
    giveConsent(accountId: $accountId, input: $input)
  }
`;
export type GiveConsentMutationFn = Apollo.MutationFunction<
  GiveConsentMutation,
  GiveConsentMutationVariables
>;

/**
 * __useGiveConsentMutation__
 *
 * To run a mutation, you first call `useGiveConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiveConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giveConsentMutation, { data, loading, error }] = useGiveConsentMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGiveConsentMutation(
  baseOptions?: Apollo.MutationHookOptions<GiveConsentMutation, GiveConsentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GiveConsentMutation, GiveConsentMutationVariables>(
    GiveConsentDocument,
    options,
  );
}
export type GiveConsentMutationHookResult = ReturnType<typeof useGiveConsentMutation>;
export type GiveConsentMutationResult = Apollo.MutationResult<GiveConsentMutation>;
export type GiveConsentMutationOptions = Apollo.BaseMutationOptions<
  GiveConsentMutation,
  GiveConsentMutationVariables
>;
export const UpdateOnboardingStateDocument = gql`
  mutation UpdateOnboardingState($accountId: ID!, $key: OnboardingStateKey!, $value: JSON!) {
    updateOnboardingState(accountId: $accountId, key: $key, value: $value)
  }
`;
export type UpdateOnboardingStateMutationFn = Apollo.MutationFunction<
  UpdateOnboardingStateMutation,
  UpdateOnboardingStateMutationVariables
>;

/**
 * __useUpdateOnboardingStateMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingStateMutation, { data, loading, error }] = useUpdateOnboardingStateMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateOnboardingStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOnboardingStateMutation,
    UpdateOnboardingStateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateOnboardingStateMutation, UpdateOnboardingStateMutationVariables>(
    UpdateOnboardingStateDocument,
    options,
  );
}
export type UpdateOnboardingStateMutationHookResult = ReturnType<
  typeof useUpdateOnboardingStateMutation
>;
export type UpdateOnboardingStateMutationResult =
  Apollo.MutationResult<UpdateOnboardingStateMutation>;
export type UpdateOnboardingStateMutationOptions = Apollo.BaseMutationOptions<
  UpdateOnboardingStateMutation,
  UpdateOnboardingStateMutationVariables
>;
export const SsoProviderIdForEmailDocument = gql`
  query SsoProviderIdForEmail($email: String!) {
    ssoProviderIdForEmail(email: $email)
  }
`;

/**
 * __useSsoProviderIdForEmailQuery__
 *
 * To run a query within a React component, call `useSsoProviderIdForEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoProviderIdForEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoProviderIdForEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSsoProviderIdForEmailQuery(
  baseOptions: Apollo.QueryHookOptions<
    SsoProviderIdForEmailQuery,
    SsoProviderIdForEmailQueryVariables
  > &
    ({ variables: SsoProviderIdForEmailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SsoProviderIdForEmailQuery, SsoProviderIdForEmailQueryVariables>(
    SsoProviderIdForEmailDocument,
    options,
  );
}
export function useSsoProviderIdForEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SsoProviderIdForEmailQuery,
    SsoProviderIdForEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SsoProviderIdForEmailQuery, SsoProviderIdForEmailQueryVariables>(
    SsoProviderIdForEmailDocument,
    options,
  );
}
export function useSsoProviderIdForEmailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SsoProviderIdForEmailQuery,
        SsoProviderIdForEmailQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SsoProviderIdForEmailQuery, SsoProviderIdForEmailQueryVariables>(
    SsoProviderIdForEmailDocument,
    options,
  );
}
export type SsoProviderIdForEmailQueryHookResult = ReturnType<typeof useSsoProviderIdForEmailQuery>;
export type SsoProviderIdForEmailLazyQueryHookResult = ReturnType<
  typeof useSsoProviderIdForEmailLazyQuery
>;
export type SsoProviderIdForEmailSuspenseQueryHookResult = ReturnType<
  typeof useSsoProviderIdForEmailSuspenseQuery
>;
export type SsoProviderIdForEmailQueryResult = Apollo.QueryResult<
  SsoProviderIdForEmailQuery,
  SsoProviderIdForEmailQueryVariables
>;
export const SignUpDocument = gql`
  mutation SignUp($email: String!, $consent: ConsentInput!) {
    signUp(email: $email, consent: $consent) {
      userId
    }
  }
`;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useSignUpMutation(
  baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
}
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<
  SignUpMutation,
  SignUpMutationVariables
>;
export const CreateAccessTokenDocument = gql`
  mutation CreateAccessToken($input: CreateAccessTokenInput!) {
    createAccessToken(input: $input) {
      ... on AccessTokenPreview {
        accessToken {
          name
          preview
          lastUsedAt
          expiresAt
          createdAt
          accessTokenId
        }
        token
      }
      ... on NotAllowedError {
        message
      }
      ... on CreateAccessTokenError {
        error
      }
    }
  }
`;
export type CreateAccessTokenMutationFn = Apollo.MutationFunction<
  CreateAccessTokenMutation,
  CreateAccessTokenMutationVariables
>;

/**
 * __useCreateAccessTokenMutation__
 *
 * To run a mutation, you first call `useCreateAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessTokenMutation, { data, loading, error }] = useCreateAccessTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccessTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAccessTokenMutation,
    CreateAccessTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>(
    CreateAccessTokenDocument,
    options,
  );
}
export type CreateAccessTokenMutationHookResult = ReturnType<typeof useCreateAccessTokenMutation>;
export type CreateAccessTokenMutationResult = Apollo.MutationResult<CreateAccessTokenMutation>;
export type CreateAccessTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateAccessTokenMutation,
  CreateAccessTokenMutationVariables
>;
export const DeleteAccessTokenDocument = gql`
  mutation DeleteAccessToken($accessTokenId: ID!) {
    deleteAccessToken(accessTokenId: $accessTokenId) {
      ... on DeleteAccessTokenSuccess {
        result
      }
      ... on NotAllowedError {
        message
      }
      ... on DeleteAccessTokenError {
        error
      }
    }
  }
`;
export type DeleteAccessTokenMutationFn = Apollo.MutationFunction<
  DeleteAccessTokenMutation,
  DeleteAccessTokenMutationVariables
>;

/**
 * __useDeleteAccessTokenMutation__
 *
 * To run a mutation, you first call `useDeleteAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccessTokenMutation, { data, loading, error }] = useDeleteAccessTokenMutation({
 *   variables: {
 *      accessTokenId: // value for 'accessTokenId'
 *   },
 * });
 */
export function useDeleteAccessTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAccessTokenMutation,
    DeleteAccessTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAccessTokenMutation, DeleteAccessTokenMutationVariables>(
    DeleteAccessTokenDocument,
    options,
  );
}
export type DeleteAccessTokenMutationHookResult = ReturnType<typeof useDeleteAccessTokenMutation>;
export type DeleteAccessTokenMutationResult = Apollo.MutationResult<DeleteAccessTokenMutation>;
export type DeleteAccessTokenMutationOptions = Apollo.BaseMutationOptions<
  DeleteAccessTokenMutation,
  DeleteAccessTokenMutationVariables
>;
export const AgentSkillsSettingsDocument = gql`
  query AgentSkillsSettings($accountId: ID!) {
    account(accountId: $accountId) {
      agentSkills(includeAll: true) {
        agentSkillId
        name
        description
        instructions
        access
        enabled
        position
      }
    }
  }
`;

/**
 * __useAgentSkillsSettingsQuery__
 *
 * To run a query within a React component, call `useAgentSkillsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentSkillsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentSkillsSettingsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAgentSkillsSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AgentSkillsSettingsQuery,
    AgentSkillsSettingsQueryVariables
  > &
    ({ variables: AgentSkillsSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AgentSkillsSettingsQuery, AgentSkillsSettingsQueryVariables>(
    AgentSkillsSettingsDocument,
    options,
  );
}
export function useAgentSkillsSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AgentSkillsSettingsQuery,
    AgentSkillsSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AgentSkillsSettingsQuery, AgentSkillsSettingsQueryVariables>(
    AgentSkillsSettingsDocument,
    options,
  );
}
export function useAgentSkillsSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AgentSkillsSettingsQuery, AgentSkillsSettingsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AgentSkillsSettingsQuery, AgentSkillsSettingsQueryVariables>(
    AgentSkillsSettingsDocument,
    options,
  );
}
export type AgentSkillsSettingsQueryHookResult = ReturnType<typeof useAgentSkillsSettingsQuery>;
export type AgentSkillsSettingsLazyQueryHookResult = ReturnType<
  typeof useAgentSkillsSettingsLazyQuery
>;
export type AgentSkillsSettingsSuspenseQueryHookResult = ReturnType<
  typeof useAgentSkillsSettingsSuspenseQuery
>;
export type AgentSkillsSettingsQueryResult = Apollo.QueryResult<
  AgentSkillsSettingsQuery,
  AgentSkillsSettingsQueryVariables
>;
export const UpsertAgentSkillDocument = gql`
  mutation UpsertAgentSkill($accountId: ID!, $input: AgentSkillInput!) {
    upsertAgentSkill(accountId: $accountId, input: $input) {
      agentSkillId
      name
      description
      instructions
      access
      enabled
      position
    }
  }
`;
export type UpsertAgentSkillMutationFn = Apollo.MutationFunction<
  UpsertAgentSkillMutation,
  UpsertAgentSkillMutationVariables
>;

/**
 * __useUpsertAgentSkillMutation__
 *
 * To run a mutation, you first call `useUpsertAgentSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAgentSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAgentSkillMutation, { data, loading, error }] = useUpsertAgentSkillMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAgentSkillMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertAgentSkillMutation,
    UpsertAgentSkillMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertAgentSkillMutation, UpsertAgentSkillMutationVariables>(
    UpsertAgentSkillDocument,
    options,
  );
}
export type UpsertAgentSkillMutationHookResult = ReturnType<typeof useUpsertAgentSkillMutation>;
export type UpsertAgentSkillMutationResult = Apollo.MutationResult<UpsertAgentSkillMutation>;
export type UpsertAgentSkillMutationOptions = Apollo.BaseMutationOptions<
  UpsertAgentSkillMutation,
  UpsertAgentSkillMutationVariables
>;
export const DeleteAgentSkillDocument = gql`
  mutation DeleteAgentSkill($accountId: ID!, $agentSkillId: ID!) {
    deleteAgentSkill(accountId: $accountId, agentSkillId: $agentSkillId)
  }
`;
export type DeleteAgentSkillMutationFn = Apollo.MutationFunction<
  DeleteAgentSkillMutation,
  DeleteAgentSkillMutationVariables
>;

/**
 * __useDeleteAgentSkillMutation__
 *
 * To run a mutation, you first call `useDeleteAgentSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentSkillMutation, { data, loading, error }] = useDeleteAgentSkillMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      agentSkillId: // value for 'agentSkillId'
 *   },
 * });
 */
export function useDeleteAgentSkillMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAgentSkillMutation,
    DeleteAgentSkillMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAgentSkillMutation, DeleteAgentSkillMutationVariables>(
    DeleteAgentSkillDocument,
    options,
  );
}
export type DeleteAgentSkillMutationHookResult = ReturnType<typeof useDeleteAgentSkillMutation>;
export type DeleteAgentSkillMutationResult = Apollo.MutationResult<DeleteAgentSkillMutation>;
export type DeleteAgentSkillMutationOptions = Apollo.BaseMutationOptions<
  DeleteAgentSkillMutation,
  DeleteAgentSkillMutationVariables
>;
export const AnswerGuidanceSettingsDocument = gql`
  query AnswerGuidanceSettings($accountId: ID!) {
    account(accountId: $accountId) {
      answerGuidance {
        ...AnswerGuidanceFields
      }
    }
  }
  ${AnswerGuidanceFieldsFragmentDoc}
`;

/**
 * __useAnswerGuidanceSettingsQuery__
 *
 * To run a query within a React component, call `useAnswerGuidanceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnswerGuidanceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnswerGuidanceSettingsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAnswerGuidanceSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AnswerGuidanceSettingsQuery,
    AnswerGuidanceSettingsQueryVariables
  > &
    ({ variables: AnswerGuidanceSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AnswerGuidanceSettingsQuery, AnswerGuidanceSettingsQueryVariables>(
    AnswerGuidanceSettingsDocument,
    options,
  );
}
export function useAnswerGuidanceSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AnswerGuidanceSettingsQuery,
    AnswerGuidanceSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AnswerGuidanceSettingsQuery, AnswerGuidanceSettingsQueryVariables>(
    AnswerGuidanceSettingsDocument,
    options,
  );
}
export function useAnswerGuidanceSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AnswerGuidanceSettingsQuery,
        AnswerGuidanceSettingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AnswerGuidanceSettingsQuery, AnswerGuidanceSettingsQueryVariables>(
    AnswerGuidanceSettingsDocument,
    options,
  );
}
export type AnswerGuidanceSettingsQueryHookResult = ReturnType<
  typeof useAnswerGuidanceSettingsQuery
>;
export type AnswerGuidanceSettingsLazyQueryHookResult = ReturnType<
  typeof useAnswerGuidanceSettingsLazyQuery
>;
export type AnswerGuidanceSettingsSuspenseQueryHookResult = ReturnType<
  typeof useAnswerGuidanceSettingsSuspenseQuery
>;
export type AnswerGuidanceSettingsQueryResult = Apollo.QueryResult<
  AnswerGuidanceSettingsQuery,
  AnswerGuidanceSettingsQueryVariables
>;
export const UpsertAnswerGuidanceDocument = gql`
  mutation UpsertAnswerGuidance($accountId: ID!, $input: AnswerGuidanceInput!) {
    upsertAnswerGuidance(accountId: $accountId, input: $input) {
      ...AnswerGuidanceFields
    }
  }
  ${AnswerGuidanceFieldsFragmentDoc}
`;
export type UpsertAnswerGuidanceMutationFn = Apollo.MutationFunction<
  UpsertAnswerGuidanceMutation,
  UpsertAnswerGuidanceMutationVariables
>;

/**
 * __useUpsertAnswerGuidanceMutation__
 *
 * To run a mutation, you first call `useUpsertAnswerGuidanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAnswerGuidanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAnswerGuidanceMutation, { data, loading, error }] = useUpsertAnswerGuidanceMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAnswerGuidanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertAnswerGuidanceMutation,
    UpsertAnswerGuidanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertAnswerGuidanceMutation, UpsertAnswerGuidanceMutationVariables>(
    UpsertAnswerGuidanceDocument,
    options,
  );
}
export type UpsertAnswerGuidanceMutationHookResult = ReturnType<
  typeof useUpsertAnswerGuidanceMutation
>;
export type UpsertAnswerGuidanceMutationResult =
  Apollo.MutationResult<UpsertAnswerGuidanceMutation>;
export type UpsertAnswerGuidanceMutationOptions = Apollo.BaseMutationOptions<
  UpsertAnswerGuidanceMutation,
  UpsertAnswerGuidanceMutationVariables
>;
export const DeleteAnswerGuidanceDocument = gql`
  mutation DeleteAnswerGuidance($accountId: ID!, $answerGuidanceId: ID!) {
    deleteAnswerGuidance(accountId: $accountId, answerGuidanceId: $answerGuidanceId)
  }
`;
export type DeleteAnswerGuidanceMutationFn = Apollo.MutationFunction<
  DeleteAnswerGuidanceMutation,
  DeleteAnswerGuidanceMutationVariables
>;

/**
 * __useDeleteAnswerGuidanceMutation__
 *
 * To run a mutation, you first call `useDeleteAnswerGuidanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnswerGuidanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnswerGuidanceMutation, { data, loading, error }] = useDeleteAnswerGuidanceMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      answerGuidanceId: // value for 'answerGuidanceId'
 *   },
 * });
 */
export function useDeleteAnswerGuidanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAnswerGuidanceMutation,
    DeleteAnswerGuidanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAnswerGuidanceMutation, DeleteAnswerGuidanceMutationVariables>(
    DeleteAnswerGuidanceDocument,
    options,
  );
}
export type DeleteAnswerGuidanceMutationHookResult = ReturnType<
  typeof useDeleteAnswerGuidanceMutation
>;
export type DeleteAnswerGuidanceMutationResult =
  Apollo.MutationResult<DeleteAnswerGuidanceMutation>;
export type DeleteAnswerGuidanceMutationOptions = Apollo.BaseMutationOptions<
  DeleteAnswerGuidanceMutation,
  DeleteAnswerGuidanceMutationVariables
>;
export const UpdateAiBusinessConceptsDocument = gql`
  mutation UpdateAiBusinessConcepts($accountId: ID!, $aiBusinessConcepts: String!) {
    updateAiBusinessConcepts(accountId: $accountId, aiBusinessConcepts: $aiBusinessConcepts) {
      accountId
      aiBusinessConcepts
    }
  }
`;
export type UpdateAiBusinessConceptsMutationFn = Apollo.MutationFunction<
  UpdateAiBusinessConceptsMutation,
  UpdateAiBusinessConceptsMutationVariables
>;

/**
 * __useUpdateAiBusinessConceptsMutation__
 *
 * To run a mutation, you first call `useUpdateAiBusinessConceptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiBusinessConceptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiBusinessConceptsMutation, { data, loading, error }] = useUpdateAiBusinessConceptsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      aiBusinessConcepts: // value for 'aiBusinessConcepts'
 *   },
 * });
 */
export function useUpdateAiBusinessConceptsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAiBusinessConceptsMutation,
    UpdateAiBusinessConceptsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAiBusinessConceptsMutation,
    UpdateAiBusinessConceptsMutationVariables
  >(UpdateAiBusinessConceptsDocument, options);
}
export type UpdateAiBusinessConceptsMutationHookResult = ReturnType<
  typeof useUpdateAiBusinessConceptsMutation
>;
export type UpdateAiBusinessConceptsMutationResult =
  Apollo.MutationResult<UpdateAiBusinessConceptsMutation>;
export type UpdateAiBusinessConceptsMutationOptions = Apollo.BaseMutationOptions<
  UpdateAiBusinessConceptsMutation,
  UpdateAiBusinessConceptsMutationVariables
>;
export const UpsertAiSystemInstructionDocument = gql`
  mutation UpsertAiSystemInstruction(
    $accountId: ID!
    $connectionId: ID
    $integrationId: ID
    $instructions: String
  ) {
    upsertAiSystemInstruction(
      accountId: $accountId
      connectionId: $connectionId
      integrationId: $integrationId
      instructions: $instructions
    ) {
      aiSystemInstructionId
      source
      instructions
      connectionId
      integrationId
    }
  }
`;
export type UpsertAiSystemInstructionMutationFn = Apollo.MutationFunction<
  UpsertAiSystemInstructionMutation,
  UpsertAiSystemInstructionMutationVariables
>;

/**
 * __useUpsertAiSystemInstructionMutation__
 *
 * To run a mutation, you first call `useUpsertAiSystemInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAiSystemInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAiSystemInstructionMutation, { data, loading, error }] = useUpsertAiSystemInstructionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      connectionId: // value for 'connectionId'
 *      integrationId: // value for 'integrationId'
 *      instructions: // value for 'instructions'
 *   },
 * });
 */
export function useUpsertAiSystemInstructionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertAiSystemInstructionMutation,
    UpsertAiSystemInstructionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertAiSystemInstructionMutation,
    UpsertAiSystemInstructionMutationVariables
  >(UpsertAiSystemInstructionDocument, options);
}
export type UpsertAiSystemInstructionMutationHookResult = ReturnType<
  typeof useUpsertAiSystemInstructionMutation
>;
export type UpsertAiSystemInstructionMutationResult =
  Apollo.MutationResult<UpsertAiSystemInstructionMutation>;
export type UpsertAiSystemInstructionMutationOptions = Apollo.BaseMutationOptions<
  UpsertAiSystemInstructionMutation,
  UpsertAiSystemInstructionMutationVariables
>;
export const UpdateFeaturesDocument = gql`
  mutation UpdateFeatures($accountId: ID!, $input: UpdateFeaturesInput!) {
    updateFeatures(accountId: $accountId, input: $input) {
      accountId
      features
    }
  }
`;
export type UpdateFeaturesMutationFn = Apollo.MutationFunction<
  UpdateFeaturesMutation,
  UpdateFeaturesMutationVariables
>;

/**
 * __useUpdateFeaturesMutation__
 *
 * To run a mutation, you first call `useUpdateFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeaturesMutation, { data, loading, error }] = useUpdateFeaturesMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeaturesMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateFeaturesMutation, UpdateFeaturesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateFeaturesMutation, UpdateFeaturesMutationVariables>(
    UpdateFeaturesDocument,
    options,
  );
}
export type UpdateFeaturesMutationHookResult = ReturnType<typeof useUpdateFeaturesMutation>;
export type UpdateFeaturesMutationResult = Apollo.MutationResult<UpdateFeaturesMutation>;
export type UpdateFeaturesMutationOptions = Apollo.BaseMutationOptions<
  UpdateFeaturesMutation,
  UpdateFeaturesMutationVariables
>;
export const AiUsageLimitsSettingsDocument = gql`
  query AiUsageLimitsSettings($accountId: ID!) {
    account(accountId: $accountId) {
      aiUsageLimits {
        account {
          costUsdPerDay
          costUsdPerMonth
          questionsPerDay
          questionsPerMonth
          costUsdPerQuestion
          costUsdPerQuestionResearch
        }
        user {
          costUsdPerDay
          costUsdPerMonth
          questionsPerDay
          questionsPerMonth
          costUsdPerQuestion
          costUsdPerQuestionResearch
        }
        defaults {
          costUsdPerDay
          costUsdPerMonth
          questionsPerDay
          questionsPerMonth
          costUsdPerQuestion
          costUsdPerQuestionResearch
        }
      }
    }
  }
`;

/**
 * __useAiUsageLimitsSettingsQuery__
 *
 * To run a query within a React component, call `useAiUsageLimitsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiUsageLimitsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiUsageLimitsSettingsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAiUsageLimitsSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AiUsageLimitsSettingsQuery,
    AiUsageLimitsSettingsQueryVariables
  > &
    ({ variables: AiUsageLimitsSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiUsageLimitsSettingsQuery, AiUsageLimitsSettingsQueryVariables>(
    AiUsageLimitsSettingsDocument,
    options,
  );
}
export function useAiUsageLimitsSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiUsageLimitsSettingsQuery,
    AiUsageLimitsSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiUsageLimitsSettingsQuery, AiUsageLimitsSettingsQueryVariables>(
    AiUsageLimitsSettingsDocument,
    options,
  );
}
export function useAiUsageLimitsSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AiUsageLimitsSettingsQuery,
        AiUsageLimitsSettingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AiUsageLimitsSettingsQuery, AiUsageLimitsSettingsQueryVariables>(
    AiUsageLimitsSettingsDocument,
    options,
  );
}
export type AiUsageLimitsSettingsQueryHookResult = ReturnType<typeof useAiUsageLimitsSettingsQuery>;
export type AiUsageLimitsSettingsLazyQueryHookResult = ReturnType<
  typeof useAiUsageLimitsSettingsLazyQuery
>;
export type AiUsageLimitsSettingsSuspenseQueryHookResult = ReturnType<
  typeof useAiUsageLimitsSettingsSuspenseQuery
>;
export type AiUsageLimitsSettingsQueryResult = Apollo.QueryResult<
  AiUsageLimitsSettingsQuery,
  AiUsageLimitsSettingsQueryVariables
>;
export const UpdateAiUsageLimitsConfigDocument = gql`
  mutation UpdateAiUsageLimitsConfig(
    $accountId: ID!
    $account: AiUsageLimitsConfigInput!
    $user: AiUsageLimitsConfigInput!
  ) {
    updateAiUsageLimitsConfig(accountId: $accountId, account: $account, user: $user) {
      account {
        costUsdPerDay
        costUsdPerMonth
        questionsPerDay
        questionsPerMonth
        costUsdPerQuestion
        costUsdPerQuestionResearch
      }
      user {
        costUsdPerDay
        costUsdPerMonth
        questionsPerDay
        questionsPerMonth
        costUsdPerQuestion
        costUsdPerQuestionResearch
      }
    }
  }
`;
export type UpdateAiUsageLimitsConfigMutationFn = Apollo.MutationFunction<
  UpdateAiUsageLimitsConfigMutation,
  UpdateAiUsageLimitsConfigMutationVariables
>;

/**
 * __useUpdateAiUsageLimitsConfigMutation__
 *
 * To run a mutation, you first call `useUpdateAiUsageLimitsConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiUsageLimitsConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiUsageLimitsConfigMutation, { data, loading, error }] = useUpdateAiUsageLimitsConfigMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      account: // value for 'account'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateAiUsageLimitsConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAiUsageLimitsConfigMutation,
    UpdateAiUsageLimitsConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAiUsageLimitsConfigMutation,
    UpdateAiUsageLimitsConfigMutationVariables
  >(UpdateAiUsageLimitsConfigDocument, options);
}
export type UpdateAiUsageLimitsConfigMutationHookResult = ReturnType<
  typeof useUpdateAiUsageLimitsConfigMutation
>;
export type UpdateAiUsageLimitsConfigMutationResult =
  Apollo.MutationResult<UpdateAiUsageLimitsConfigMutation>;
export type UpdateAiUsageLimitsConfigMutationOptions = Apollo.BaseMutationOptions<
  UpdateAiUsageLimitsConfigMutation,
  UpdateAiUsageLimitsConfigMutationVariables
>;
export const DeleteAlertConfigurationDocument = gql`
  mutation DeleteAlertConfiguration($accountId: ID!, $alertConfigurationId: ID!) {
    deleteAlertConfiguration(accountId: $accountId, alertConfigurationId: $alertConfigurationId) {
      ... on DeleteAlertConfigurationSuccess {
        result
      }
    }
  }
`;
export type DeleteAlertConfigurationMutationFn = Apollo.MutationFunction<
  DeleteAlertConfigurationMutation,
  DeleteAlertConfigurationMutationVariables
>;

/**
 * __useDeleteAlertConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteAlertConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertConfigurationMutation, { data, loading, error }] = useDeleteAlertConfigurationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      alertConfigurationId: // value for 'alertConfigurationId'
 *   },
 * });
 */
export function useDeleteAlertConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAlertConfigurationMutation,
    DeleteAlertConfigurationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAlertConfigurationMutation,
    DeleteAlertConfigurationMutationVariables
  >(DeleteAlertConfigurationDocument, options);
}
export type DeleteAlertConfigurationMutationHookResult = ReturnType<
  typeof useDeleteAlertConfigurationMutation
>;
export type DeleteAlertConfigurationMutationResult =
  Apollo.MutationResult<DeleteAlertConfigurationMutation>;
export type DeleteAlertConfigurationMutationOptions = Apollo.BaseMutationOptions<
  DeleteAlertConfigurationMutation,
  DeleteAlertConfigurationMutationVariables
>;
export const SlackChannelsDocument = gql`
  query SlackChannels($accountId: ID!, $integrationId: ID!) {
    account(accountId: $accountId) {
      slackChannels(integrationId: $integrationId) {
        id
        name
        isPrivate
        isBotInChannel
      }
    }
  }
`;

/**
 * __useSlackChannelsQuery__
 *
 * To run a query within a React component, call `useSlackChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlackChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlackChannelsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useSlackChannelsQuery(
  baseOptions: Apollo.QueryHookOptions<SlackChannelsQuery, SlackChannelsQueryVariables> &
    ({ variables: SlackChannelsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SlackChannelsQuery, SlackChannelsQueryVariables>(
    SlackChannelsDocument,
    options,
  );
}
export function useSlackChannelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SlackChannelsQuery, SlackChannelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SlackChannelsQuery, SlackChannelsQueryVariables>(
    SlackChannelsDocument,
    options,
  );
}
export function useSlackChannelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SlackChannelsQuery, SlackChannelsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SlackChannelsQuery, SlackChannelsQueryVariables>(
    SlackChannelsDocument,
    options,
  );
}
export type SlackChannelsQueryHookResult = ReturnType<typeof useSlackChannelsQuery>;
export type SlackChannelsLazyQueryHookResult = ReturnType<typeof useSlackChannelsLazyQuery>;
export type SlackChannelsSuspenseQueryHookResult = ReturnType<typeof useSlackChannelsSuspenseQuery>;
export type SlackChannelsQueryResult = Apollo.QueryResult<
  SlackChannelsQuery,
  SlackChannelsQueryVariables
>;
export const UpsertAlertConfigurationDocument = gql`
  mutation UpsertAlertConfiguration($accountId: ID!, $input: AlertConfigurationInput!) {
    upsertAlertConfiguration(accountId: $accountId, input: $input) {
      alertConfigurationId
      name
      message
      keyFields
      pipeline
      notificationConfig
      createdAt
    }
  }
`;
export type UpsertAlertConfigurationMutationFn = Apollo.MutationFunction<
  UpsertAlertConfigurationMutation,
  UpsertAlertConfigurationMutationVariables
>;

/**
 * __useUpsertAlertConfigurationMutation__
 *
 * To run a mutation, you first call `useUpsertAlertConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAlertConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAlertConfigurationMutation, { data, loading, error }] = useUpsertAlertConfigurationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAlertConfigurationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertAlertConfigurationMutation,
    UpsertAlertConfigurationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertAlertConfigurationMutation,
    UpsertAlertConfigurationMutationVariables
  >(UpsertAlertConfigurationDocument, options);
}
export type UpsertAlertConfigurationMutationHookResult = ReturnType<
  typeof useUpsertAlertConfigurationMutation
>;
export type UpsertAlertConfigurationMutationResult =
  Apollo.MutationResult<UpsertAlertConfigurationMutation>;
export type UpsertAlertConfigurationMutationOptions = Apollo.BaseMutationOptions<
  UpsertAlertConfigurationMutation,
  UpsertAlertConfigurationMutationVariables
>;
export const ConnectionPropertiesDocument = gql`
  query ConnectionProperties($accountId: ID!) {
    account(accountId: $accountId) {
      accountId
      connections {
        connectionId
        properties {
          connectionTimeout
          maximumDataProcessedBytes
        }
      }
    }
  }
`;

/**
 * __useConnectionPropertiesQuery__
 *
 * To run a query within a React component, call `useConnectionPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectionPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectionPropertiesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useConnectionPropertiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConnectionPropertiesQuery,
    ConnectionPropertiesQueryVariables
  > &
    ({ variables: ConnectionPropertiesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConnectionPropertiesQuery, ConnectionPropertiesQueryVariables>(
    ConnectionPropertiesDocument,
    options,
  );
}
export function useConnectionPropertiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConnectionPropertiesQuery,
    ConnectionPropertiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConnectionPropertiesQuery, ConnectionPropertiesQueryVariables>(
    ConnectionPropertiesDocument,
    options,
  );
}
export function useConnectionPropertiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConnectionPropertiesQuery,
        ConnectionPropertiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ConnectionPropertiesQuery, ConnectionPropertiesQueryVariables>(
    ConnectionPropertiesDocument,
    options,
  );
}
export type ConnectionPropertiesQueryHookResult = ReturnType<typeof useConnectionPropertiesQuery>;
export type ConnectionPropertiesLazyQueryHookResult = ReturnType<
  typeof useConnectionPropertiesLazyQuery
>;
export type ConnectionPropertiesSuspenseQueryHookResult = ReturnType<
  typeof useConnectionPropertiesSuspenseQuery
>;
export type ConnectionPropertiesQueryResult = Apollo.QueryResult<
  ConnectionPropertiesQuery,
  ConnectionPropertiesQueryVariables
>;
export const UpdateConnectionDocument = gql`
  mutation UpdateConnection($accountId: ID!, $connectionId: ID!, $input: UpdateConnectionInput!) {
    updateConnection(accountId: $accountId, connectionId: $connectionId, input: $input) {
      connectionId
      name
      properties {
        connectionTimeout
        maximumDataProcessedBytes
      }
    }
  }
`;
export type UpdateConnectionMutationFn = Apollo.MutationFunction<
  UpdateConnectionMutation,
  UpdateConnectionMutationVariables
>;

/**
 * __useUpdateConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectionMutation, { data, loading, error }] = useUpdateConnectionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      connectionId: // value for 'connectionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConnectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConnectionMutation,
    UpdateConnectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateConnectionMutation, UpdateConnectionMutationVariables>(
    UpdateConnectionDocument,
    options,
  );
}
export type UpdateConnectionMutationHookResult = ReturnType<typeof useUpdateConnectionMutation>;
export type UpdateConnectionMutationResult = Apollo.MutationResult<UpdateConnectionMutation>;
export type UpdateConnectionMutationOptions = Apollo.BaseMutationOptions<
  UpdateConnectionMutation,
  UpdateConnectionMutationVariables
>;
export const AccountSettingsDocument = gql`
  query AccountSettings($accountId: ID!) {
    account(accountId: $accountId) {
      accountId
      name
      me {
        userId
        authorizedClients {
          grantId
          verified
          clientName
          logoUri
          redirectHost
          scopes
          authorizedAt
          lastUsedAt
        }
      }
      users {
        userId
        email
        role {
          roleId
          name
        }
        addedAt
      }
      accessTokens {
        name
        preview
        expiresAt
        lastUsedAt
        createdAt
        accessTokenId
      }
      serviceUsers {
        userId
        name
        email
        role
        createdAt
        accessTokens {
          accessTokenId
          name
          preview
          expiresAt
          lastUsedAt
          createdAt
        }
      }
      connections {
        connectionId
        name
        type
        createdAt
      }
      integrations {
        integrationId
        service
        name
        workspaceId
        url
        description
        createdAt
        oauthClientId
        authStatus
      }
      alertConfigurations {
        alertConfigurationId
        accountId
        name
        message
        keyFields
        excludedFields
        pipeline
        notificationConfig
        createdAt
      }
      models {
        ...ModelFragment
      }
      metrics {
        ...MetricFragment
      }
      navigation {
        ... on ExplorationNavigationItem {
          kind
          label
          explorationId
        }
      }
      explorations {
        explorationId
        name
      }
      userGroups {
        userGroupId
        name
        parameters
        permissions
        members {
          userId
          email
        }
        createdAt
        updatedAt
      }
      aiBusinessConcepts
      aiSystemInstructions {
        aiSystemInstructionId
        source
        instructions
        connectionId
        integrationId
      }
    }
    permissions {
      permissionId
      name
    }
  }
  ${ModelFragmentFragmentDoc}
  ${MetricFragmentFragmentDoc}
`;

/**
 * __useAccountSettingsQuery__
 *
 * To run a query within a React component, call `useAccountSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSettingsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables> &
    ({ variables: AccountSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(
    AccountSettingsDocument,
    options,
  );
}
export function useAccountSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(
    AccountSettingsDocument,
    options,
  );
}
export function useAccountSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AccountSettingsQuery, AccountSettingsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AccountSettingsQuery, AccountSettingsQueryVariables>(
    AccountSettingsDocument,
    options,
  );
}
export type AccountSettingsQueryHookResult = ReturnType<typeof useAccountSettingsQuery>;
export type AccountSettingsLazyQueryHookResult = ReturnType<typeof useAccountSettingsLazyQuery>;
export type AccountSettingsSuspenseQueryHookResult = ReturnType<
  typeof useAccountSettingsSuspenseQuery
>;
export type AccountSettingsQueryResult = Apollo.QueryResult<
  AccountSettingsQuery,
  AccountSettingsQueryVariables
>;
export const RevokeAuthorizedClientDocument = gql`
  mutation RevokeAuthorizedClient($accountId: ID!, $grantId: ID!) {
    revokeAuthorizedClient(accountId: $accountId, grantId: $grantId) {
      ... on RevokeAuthorizedClientSuccess {
        result
      }
      ... on NotAllowedError {
        message
      }
      ... on RevokeAuthorizedClientError {
        error
      }
    }
  }
`;
export type RevokeAuthorizedClientMutationFn = Apollo.MutationFunction<
  RevokeAuthorizedClientMutation,
  RevokeAuthorizedClientMutationVariables
>;

/**
 * __useRevokeAuthorizedClientMutation__
 *
 * To run a mutation, you first call `useRevokeAuthorizedClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAuthorizedClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAuthorizedClientMutation, { data, loading, error }] = useRevokeAuthorizedClientMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      grantId: // value for 'grantId'
 *   },
 * });
 */
export function useRevokeAuthorizedClientMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeAuthorizedClientMutation,
    RevokeAuthorizedClientMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeAuthorizedClientMutation,
    RevokeAuthorizedClientMutationVariables
  >(RevokeAuthorizedClientDocument, options);
}
export type RevokeAuthorizedClientMutationHookResult = ReturnType<
  typeof useRevokeAuthorizedClientMutation
>;
export type RevokeAuthorizedClientMutationResult =
  Apollo.MutationResult<RevokeAuthorizedClientMutation>;
export type RevokeAuthorizedClientMutationOptions = Apollo.BaseMutationOptions<
  RevokeAuthorizedClientMutation,
  RevokeAuthorizedClientMutationVariables
>;
export const CreateConfluencePairingRequestDocument = gql`
  mutation CreateConfluencePairingRequest($accountId: String!) {
    createConfluencePairingRequest(accountId: $accountId) {
      code
      expiresAt
    }
  }
`;
export type CreateConfluencePairingRequestMutationFn = Apollo.MutationFunction<
  CreateConfluencePairingRequestMutation,
  CreateConfluencePairingRequestMutationVariables
>;

/**
 * __useCreateConfluencePairingRequestMutation__
 *
 * To run a mutation, you first call `useCreateConfluencePairingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConfluencePairingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConfluencePairingRequestMutation, { data, loading, error }] = useCreateConfluencePairingRequestMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCreateConfluencePairingRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateConfluencePairingRequestMutation,
    CreateConfluencePairingRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateConfluencePairingRequestMutation,
    CreateConfluencePairingRequestMutationVariables
  >(CreateConfluencePairingRequestDocument, options);
}
export type CreateConfluencePairingRequestMutationHookResult = ReturnType<
  typeof useCreateConfluencePairingRequestMutation
>;
export type CreateConfluencePairingRequestMutationResult =
  Apollo.MutationResult<CreateConfluencePairingRequestMutation>;
export type CreateConfluencePairingRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateConfluencePairingRequestMutation,
  CreateConfluencePairingRequestMutationVariables
>;
export const ConfluencePairingStateDocument = gql`
  query ConfluencePairingState($accountId: ID!, $code: String!) {
    account(accountId: $accountId) {
      accountId
      confluencePairingState(code: $code) {
        status
        integrationId
      }
    }
  }
`;

/**
 * __useConfluencePairingStateQuery__
 *
 * To run a query within a React component, call `useConfluencePairingStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfluencePairingStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfluencePairingStateQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConfluencePairingStateQuery(
  baseOptions: Apollo.QueryHookOptions<
    ConfluencePairingStateQuery,
    ConfluencePairingStateQueryVariables
  > &
    ({ variables: ConfluencePairingStateQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConfluencePairingStateQuery, ConfluencePairingStateQueryVariables>(
    ConfluencePairingStateDocument,
    options,
  );
}
export function useConfluencePairingStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ConfluencePairingStateQuery,
    ConfluencePairingStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConfluencePairingStateQuery, ConfluencePairingStateQueryVariables>(
    ConfluencePairingStateDocument,
    options,
  );
}
export function useConfluencePairingStateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ConfluencePairingStateQuery,
        ConfluencePairingStateQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ConfluencePairingStateQuery, ConfluencePairingStateQueryVariables>(
    ConfluencePairingStateDocument,
    options,
  );
}
export type ConfluencePairingStateQueryHookResult = ReturnType<
  typeof useConfluencePairingStateQuery
>;
export type ConfluencePairingStateLazyQueryHookResult = ReturnType<
  typeof useConfluencePairingStateLazyQuery
>;
export type ConfluencePairingStateSuspenseQueryHookResult = ReturnType<
  typeof useConfluencePairingStateSuspenseQuery
>;
export type ConfluencePairingStateQueryResult = Apollo.QueryResult<
  ConfluencePairingStateQuery,
  ConfluencePairingStateQueryVariables
>;
export const OauthGithubCallbackDocument = gql`
  mutation OauthGithubCallback($accountId: String!, $code: String!) {
    oauthGithubCallback(accountId: $accountId, code: $code) {
      ... on OauthGithubCallbackSuccess {
        success
      }
      ... on OauthGithubCallbackError {
        error
      }
      ... on OauthGithubCallbackInstallRequired {
        installRequired
      }
    }
  }
`;
export type OauthGithubCallbackMutationFn = Apollo.MutationFunction<
  OauthGithubCallbackMutation,
  OauthGithubCallbackMutationVariables
>;

/**
 * __useOauthGithubCallbackMutation__
 *
 * To run a mutation, you first call `useOauthGithubCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOauthGithubCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oauthGithubCallbackMutation, { data, loading, error }] = useOauthGithubCallbackMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useOauthGithubCallbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OauthGithubCallbackMutation,
    OauthGithubCallbackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<OauthGithubCallbackMutation, OauthGithubCallbackMutationVariables>(
    OauthGithubCallbackDocument,
    options,
  );
}
export type OauthGithubCallbackMutationHookResult = ReturnType<
  typeof useOauthGithubCallbackMutation
>;
export type OauthGithubCallbackMutationResult = Apollo.MutationResult<OauthGithubCallbackMutation>;
export type OauthGithubCallbackMutationOptions = Apollo.BaseMutationOptions<
  OauthGithubCallbackMutation,
  OauthGithubCallbackMutationVariables
>;
export const CreateGoogleDriveIntegrationDocument = gql`
  mutation CreateGoogleDriveIntegration($url: String!, $accountId: String!) {
    createGoogleDriveIntegration(folderUrl: $url, accountId: $accountId) {
      success
    }
  }
`;
export type CreateGoogleDriveIntegrationMutationFn = Apollo.MutationFunction<
  CreateGoogleDriveIntegrationMutation,
  CreateGoogleDriveIntegrationMutationVariables
>;

/**
 * __useCreateGoogleDriveIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateGoogleDriveIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoogleDriveIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoogleDriveIntegrationMutation, { data, loading, error }] = useCreateGoogleDriveIntegrationMutation({
 *   variables: {
 *      url: // value for 'url'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCreateGoogleDriveIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGoogleDriveIntegrationMutation,
    CreateGoogleDriveIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateGoogleDriveIntegrationMutation,
    CreateGoogleDriveIntegrationMutationVariables
  >(CreateGoogleDriveIntegrationDocument, options);
}
export type CreateGoogleDriveIntegrationMutationHookResult = ReturnType<
  typeof useCreateGoogleDriveIntegrationMutation
>;
export type CreateGoogleDriveIntegrationMutationResult =
  Apollo.MutationResult<CreateGoogleDriveIntegrationMutation>;
export type CreateGoogleDriveIntegrationMutationOptions = Apollo.BaseMutationOptions<
  CreateGoogleDriveIntegrationMutation,
  CreateGoogleDriveIntegrationMutationVariables
>;
export const CreateMcpIntegrationDocument = gql`
  mutation CreateMcpIntegration(
    $accountId: String!
    $displayName: String!
    $serverUrl: String!
    $clientId: String
    $clientSecret: String
  ) {
    createMcpIntegration(
      accountId: $accountId
      displayName: $displayName
      serverUrl: $serverUrl
      clientId: $clientId
      clientSecret: $clientSecret
    ) {
      __typename
      ... on CreateMcpIntegrationSuccess {
        integration {
          integrationId
          service
          name
          createdAt
          oauthClientId
        }
      }
      ... on CreateMcpIntegrationError {
        error
      }
    }
  }
`;
export type CreateMcpIntegrationMutationFn = Apollo.MutationFunction<
  CreateMcpIntegrationMutation,
  CreateMcpIntegrationMutationVariables
>;

/**
 * __useCreateMcpIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateMcpIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMcpIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMcpIntegrationMutation, { data, loading, error }] = useCreateMcpIntegrationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      displayName: // value for 'displayName'
 *      serverUrl: // value for 'serverUrl'
 *      clientId: // value for 'clientId'
 *      clientSecret: // value for 'clientSecret'
 *   },
 * });
 */
export function useCreateMcpIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMcpIntegrationMutation,
    CreateMcpIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateMcpIntegrationMutation, CreateMcpIntegrationMutationVariables>(
    CreateMcpIntegrationDocument,
    options,
  );
}
export type CreateMcpIntegrationMutationHookResult = ReturnType<
  typeof useCreateMcpIntegrationMutation
>;
export type CreateMcpIntegrationMutationResult =
  Apollo.MutationResult<CreateMcpIntegrationMutation>;
export type CreateMcpIntegrationMutationOptions = Apollo.BaseMutationOptions<
  CreateMcpIntegrationMutation,
  CreateMcpIntegrationMutationVariables
>;
export const StartOauthDocument = gql`
  mutation StartOauth($accountId: String!, $oauthClientId: ID!) {
    startOauth(accountId: $accountId, oauthClientId: $oauthClientId) {
      __typename
      ... on StartOauthSuccess {
        authorizeUrl
      }
      ... on StartOauthError {
        error
      }
    }
  }
`;
export type StartOauthMutationFn = Apollo.MutationFunction<
  StartOauthMutation,
  StartOauthMutationVariables
>;

/**
 * __useStartOauthMutation__
 *
 * To run a mutation, you first call `useStartOauthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOauthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOauthMutation, { data, loading, error }] = useStartOauthMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      oauthClientId: // value for 'oauthClientId'
 *   },
 * });
 */
export function useStartOauthMutation(
  baseOptions?: Apollo.MutationHookOptions<StartOauthMutation, StartOauthMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartOauthMutation, StartOauthMutationVariables>(
    StartOauthDocument,
    options,
  );
}
export type StartOauthMutationHookResult = ReturnType<typeof useStartOauthMutation>;
export type StartOauthMutationResult = Apollo.MutationResult<StartOauthMutation>;
export type StartOauthMutationOptions = Apollo.BaseMutationOptions<
  StartOauthMutation,
  StartOauthMutationVariables
>;
export const OauthCallbackDocument = gql`
  mutation OauthCallback(
    $accountId: String!
    $oauthClientId: ID!
    $code: String!
    $state: String!
  ) {
    oauthCallback(
      accountId: $accountId
      oauthClientId: $oauthClientId
      code: $code
      state: $state
    ) {
      __typename
      ... on OauthCallbackSuccess {
        success
      }
      ... on OauthCallbackError {
        error
      }
    }
  }
`;
export type OauthCallbackMutationFn = Apollo.MutationFunction<
  OauthCallbackMutation,
  OauthCallbackMutationVariables
>;

/**
 * __useOauthCallbackMutation__
 *
 * To run a mutation, you first call `useOauthCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOauthCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oauthCallbackMutation, { data, loading, error }] = useOauthCallbackMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      oauthClientId: // value for 'oauthClientId'
 *      code: // value for 'code'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useOauthCallbackMutation(
  baseOptions?: Apollo.MutationHookOptions<OauthCallbackMutation, OauthCallbackMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<OauthCallbackMutation, OauthCallbackMutationVariables>(
    OauthCallbackDocument,
    options,
  );
}
export type OauthCallbackMutationHookResult = ReturnType<typeof useOauthCallbackMutation>;
export type OauthCallbackMutationResult = Apollo.MutationResult<OauthCallbackMutation>;
export type OauthCallbackMutationOptions = Apollo.BaseMutationOptions<
  OauthCallbackMutation,
  OauthCallbackMutationVariables
>;
export const DisconnectMcpIntegrationDocument = gql`
  mutation DisconnectMcpIntegration($accountId: String!, $integrationId: ID!) {
    disconnectMcpIntegration(accountId: $accountId, integrationId: $integrationId)
  }
`;
export type DisconnectMcpIntegrationMutationFn = Apollo.MutationFunction<
  DisconnectMcpIntegrationMutation,
  DisconnectMcpIntegrationMutationVariables
>;

/**
 * __useDisconnectMcpIntegrationMutation__
 *
 * To run a mutation, you first call `useDisconnectMcpIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectMcpIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectMcpIntegrationMutation, { data, loading, error }] = useDisconnectMcpIntegrationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useDisconnectMcpIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisconnectMcpIntegrationMutation,
    DisconnectMcpIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisconnectMcpIntegrationMutation,
    DisconnectMcpIntegrationMutationVariables
  >(DisconnectMcpIntegrationDocument, options);
}
export type DisconnectMcpIntegrationMutationHookResult = ReturnType<
  typeof useDisconnectMcpIntegrationMutation
>;
export type DisconnectMcpIntegrationMutationResult =
  Apollo.MutationResult<DisconnectMcpIntegrationMutation>;
export type DisconnectMcpIntegrationMutationOptions = Apollo.BaseMutationOptions<
  DisconnectMcpIntegrationMutation,
  DisconnectMcpIntegrationMutationVariables
>;
export const CreateNotionIntegrationDocument = gql`
  mutation CreateNotionIntegration($apiKey: String!, $accountId: String!) {
    createNotionIntegration(apiKey: $apiKey, accountId: $accountId) {
      success
    }
  }
`;
export type CreateNotionIntegrationMutationFn = Apollo.MutationFunction<
  CreateNotionIntegrationMutation,
  CreateNotionIntegrationMutationVariables
>;

/**
 * __useCreateNotionIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateNotionIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotionIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotionIntegrationMutation, { data, loading, error }] = useCreateNotionIntegrationMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCreateNotionIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNotionIntegrationMutation,
    CreateNotionIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateNotionIntegrationMutation,
    CreateNotionIntegrationMutationVariables
  >(CreateNotionIntegrationDocument, options);
}
export type CreateNotionIntegrationMutationHookResult = ReturnType<
  typeof useCreateNotionIntegrationMutation
>;
export type CreateNotionIntegrationMutationResult =
  Apollo.MutationResult<CreateNotionIntegrationMutation>;
export type CreateNotionIntegrationMutationOptions = Apollo.BaseMutationOptions<
  CreateNotionIntegrationMutation,
  CreateNotionIntegrationMutationVariables
>;
export const OauthSlackCallbackDocument = gql`
  mutation OauthSlackCallback($code: String!, $redirectUri: String!, $accountId: String!) {
    oauthSlackCallback(code: $code, redirectUri: $redirectUri, accountId: $accountId) {
      ... on OauthSlackCallbackSuccess {
        success
      }
      ... on OauthSlackCallbackError {
        error
      }
    }
  }
`;
export type OauthSlackCallbackMutationFn = Apollo.MutationFunction<
  OauthSlackCallbackMutation,
  OauthSlackCallbackMutationVariables
>;

/**
 * __useOauthSlackCallbackMutation__
 *
 * To run a mutation, you first call `useOauthSlackCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOauthSlackCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oauthSlackCallbackMutation, { data, loading, error }] = useOauthSlackCallbackMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useOauthSlackCallbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OauthSlackCallbackMutation,
    OauthSlackCallbackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<OauthSlackCallbackMutation, OauthSlackCallbackMutationVariables>(
    OauthSlackCallbackDocument,
    options,
  );
}
export type OauthSlackCallbackMutationHookResult = ReturnType<typeof useOauthSlackCallbackMutation>;
export type OauthSlackCallbackMutationResult = Apollo.MutationResult<OauthSlackCallbackMutation>;
export type OauthSlackCallbackMutationOptions = Apollo.BaseMutationOptions<
  OauthSlackCallbackMutation,
  OauthSlackCallbackMutationVariables
>;
export const UpdateNavigationDocument = gql`
  mutation UpdateNavigation($accountId: ID!, $input: JSON!) {
    updateNavigation(accountId: $accountId, input: $input)
  }
`;
export type UpdateNavigationMutationFn = Apollo.MutationFunction<
  UpdateNavigationMutation,
  UpdateNavigationMutationVariables
>;

/**
 * __useUpdateNavigationMutation__
 *
 * To run a mutation, you first call `useUpdateNavigationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNavigationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNavigationMutation, { data, loading, error }] = useUpdateNavigationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNavigationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNavigationMutation,
    UpdateNavigationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateNavigationMutation, UpdateNavigationMutationVariables>(
    UpdateNavigationDocument,
    options,
  );
}
export type UpdateNavigationMutationHookResult = ReturnType<typeof useUpdateNavigationMutation>;
export type UpdateNavigationMutationResult = Apollo.MutationResult<UpdateNavigationMutation>;
export type UpdateNavigationMutationOptions = Apollo.BaseMutationOptions<
  UpdateNavigationMutation,
  UpdateNavigationMutationVariables
>;
export const CreateServiceUserAccessTokenDocument = gql`
  mutation CreateServiceUserAccessToken(
    $accountId: ID!
    $userId: ID!
    $name: String!
    $expiresAt: Date
  ) {
    createServiceUserAccessToken(
      accountId: $accountId
      userId: $userId
      name: $name
      expiresAt: $expiresAt
    ) {
      ... on AccessTokenPreview {
        accessToken {
          accessTokenId
          name
          preview
          expiresAt
          lastUsedAt
          createdAt
        }
        token
      }
      ... on NotAllowedError {
        message
      }
      ... on CreateAccessTokenError {
        error
      }
    }
  }
`;
export type CreateServiceUserAccessTokenMutationFn = Apollo.MutationFunction<
  CreateServiceUserAccessTokenMutation,
  CreateServiceUserAccessTokenMutationVariables
>;

/**
 * __useCreateServiceUserAccessTokenMutation__
 *
 * To run a mutation, you first call `useCreateServiceUserAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceUserAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceUserAccessTokenMutation, { data, loading, error }] = useCreateServiceUserAccessTokenMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useCreateServiceUserAccessTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateServiceUserAccessTokenMutation,
    CreateServiceUserAccessTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateServiceUserAccessTokenMutation,
    CreateServiceUserAccessTokenMutationVariables
  >(CreateServiceUserAccessTokenDocument, options);
}
export type CreateServiceUserAccessTokenMutationHookResult = ReturnType<
  typeof useCreateServiceUserAccessTokenMutation
>;
export type CreateServiceUserAccessTokenMutationResult =
  Apollo.MutationResult<CreateServiceUserAccessTokenMutation>;
export type CreateServiceUserAccessTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateServiceUserAccessTokenMutation,
  CreateServiceUserAccessTokenMutationVariables
>;
export const CreateServiceUserDocument = gql`
  mutation CreateServiceUser($accountId: ID!, $name: String!, $role: UserRole!) {
    createServiceUser(accountId: $accountId, name: $name, role: $role) {
      ... on ServiceUser {
        userId
        name
        email
        role
        createdAt
        accessTokens {
          accessTokenId
          name
          preview
          expiresAt
          lastUsedAt
          createdAt
        }
      }
      ... on NotAllowedError {
        message
      }
      ... on CreateServiceUserError {
        error
      }
    }
  }
`;
export type CreateServiceUserMutationFn = Apollo.MutationFunction<
  CreateServiceUserMutation,
  CreateServiceUserMutationVariables
>;

/**
 * __useCreateServiceUserMutation__
 *
 * To run a mutation, you first call `useCreateServiceUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceUserMutation, { data, loading, error }] = useCreateServiceUserMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      name: // value for 'name'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreateServiceUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateServiceUserMutation,
    CreateServiceUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateServiceUserMutation, CreateServiceUserMutationVariables>(
    CreateServiceUserDocument,
    options,
  );
}
export type CreateServiceUserMutationHookResult = ReturnType<typeof useCreateServiceUserMutation>;
export type CreateServiceUserMutationResult = Apollo.MutationResult<CreateServiceUserMutation>;
export type CreateServiceUserMutationOptions = Apollo.BaseMutationOptions<
  CreateServiceUserMutation,
  CreateServiceUserMutationVariables
>;
export const DeleteServiceUserAccessTokenDocument = gql`
  mutation DeleteServiceUserAccessToken($accountId: ID!, $accessTokenId: ID!) {
    deleteServiceUserAccessToken(accountId: $accountId, accessTokenId: $accessTokenId) {
      ... on DeleteAccessTokenSuccess {
        result
      }
      ... on NotAllowedError {
        message
      }
      ... on DeleteAccessTokenError {
        error
      }
    }
  }
`;
export type DeleteServiceUserAccessTokenMutationFn = Apollo.MutationFunction<
  DeleteServiceUserAccessTokenMutation,
  DeleteServiceUserAccessTokenMutationVariables
>;

/**
 * __useDeleteServiceUserAccessTokenMutation__
 *
 * To run a mutation, you first call `useDeleteServiceUserAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceUserAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceUserAccessTokenMutation, { data, loading, error }] = useDeleteServiceUserAccessTokenMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      accessTokenId: // value for 'accessTokenId'
 *   },
 * });
 */
export function useDeleteServiceUserAccessTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteServiceUserAccessTokenMutation,
    DeleteServiceUserAccessTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteServiceUserAccessTokenMutation,
    DeleteServiceUserAccessTokenMutationVariables
  >(DeleteServiceUserAccessTokenDocument, options);
}
export type DeleteServiceUserAccessTokenMutationHookResult = ReturnType<
  typeof useDeleteServiceUserAccessTokenMutation
>;
export type DeleteServiceUserAccessTokenMutationResult =
  Apollo.MutationResult<DeleteServiceUserAccessTokenMutation>;
export type DeleteServiceUserAccessTokenMutationOptions = Apollo.BaseMutationOptions<
  DeleteServiceUserAccessTokenMutation,
  DeleteServiceUserAccessTokenMutationVariables
>;
export const DeleteServiceUserDocument = gql`
  mutation DeleteServiceUser($accountId: ID!, $userId: ID!) {
    deleteServiceUser(accountId: $accountId, userId: $userId) {
      ... on DeleteServiceUserSuccess {
        result
      }
      ... on NotAllowedError {
        message
      }
      ... on DeleteServiceUserError {
        error
      }
    }
  }
`;
export type DeleteServiceUserMutationFn = Apollo.MutationFunction<
  DeleteServiceUserMutation,
  DeleteServiceUserMutationVariables
>;

/**
 * __useDeleteServiceUserMutation__
 *
 * To run a mutation, you first call `useDeleteServiceUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceUserMutation, { data, loading, error }] = useDeleteServiceUserMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteServiceUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteServiceUserMutation,
    DeleteServiceUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteServiceUserMutation, DeleteServiceUserMutationVariables>(
    DeleteServiceUserDocument,
    options,
  );
}
export type DeleteServiceUserMutationHookResult = ReturnType<typeof useDeleteServiceUserMutation>;
export type DeleteServiceUserMutationResult = Apollo.MutationResult<DeleteServiceUserMutation>;
export type DeleteServiceUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteServiceUserMutation,
  DeleteServiceUserMutationVariables
>;
export const AddUserToGroupDocument = gql`
  mutation AddUserToGroup($accountId: ID!, $userGroupId: ID!, $userId: ID!) {
    addUserToGroup(accountId: $accountId, userGroupId: $userGroupId, userId: $userId) {
      userGroupId
      name
      parameters
      permissions
      members {
        userId
        email
      }
      createdAt
      updatedAt
    }
  }
`;
export type AddUserToGroupMutationFn = Apollo.MutationFunction<
  AddUserToGroupMutation,
  AddUserToGroupMutationVariables
>;

/**
 * __useAddUserToGroupMutation__
 *
 * To run a mutation, you first call `useAddUserToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToGroupMutation, { data, loading, error }] = useAddUserToGroupMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userGroupId: // value for 'userGroupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddUserToGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<AddUserToGroupMutation, AddUserToGroupMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddUserToGroupMutation, AddUserToGroupMutationVariables>(
    AddUserToGroupDocument,
    options,
  );
}
export type AddUserToGroupMutationHookResult = ReturnType<typeof useAddUserToGroupMutation>;
export type AddUserToGroupMutationResult = Apollo.MutationResult<AddUserToGroupMutation>;
export type AddUserToGroupMutationOptions = Apollo.BaseMutationOptions<
  AddUserToGroupMutation,
  AddUserToGroupMutationVariables
>;
export const DeleteUserGroupDocument = gql`
  mutation DeleteUserGroup($accountId: ID!, $userGroupId: ID!) {
    deleteUserGroup(accountId: $accountId, userGroupId: $userGroupId) {
      userGroupId
      name
    }
  }
`;
export type DeleteUserGroupMutationFn = Apollo.MutationFunction<
  DeleteUserGroupMutation,
  DeleteUserGroupMutationVariables
>;

/**
 * __useDeleteUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserGroupMutation, { data, loading, error }] = useDeleteUserGroupMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useDeleteUserGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserGroupMutation,
    DeleteUserGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(
    DeleteUserGroupDocument,
    options,
  );
}
export type DeleteUserGroupMutationHookResult = ReturnType<typeof useDeleteUserGroupMutation>;
export type DeleteUserGroupMutationResult = Apollo.MutationResult<DeleteUserGroupMutation>;
export type DeleteUserGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserGroupMutation,
  DeleteUserGroupMutationVariables
>;
export const RemoveUserFromGroupDocument = gql`
  mutation RemoveUserFromGroup($accountId: ID!, $userGroupId: ID!, $userId: ID!) {
    removeUserFromGroup(accountId: $accountId, userGroupId: $userGroupId, userId: $userId) {
      userGroupId
      name
      parameters
      permissions
      members {
        userId
        email
      }
      createdAt
      updatedAt
    }
  }
`;
export type RemoveUserFromGroupMutationFn = Apollo.MutationFunction<
  RemoveUserFromGroupMutation,
  RemoveUserFromGroupMutationVariables
>;

/**
 * __useRemoveUserFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromGroupMutation, { data, loading, error }] = useRemoveUserFromGroupMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userGroupId: // value for 'userGroupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveUserFromGroupMutation,
    RemoveUserFromGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>(
    RemoveUserFromGroupDocument,
    options,
  );
}
export type RemoveUserFromGroupMutationHookResult = ReturnType<
  typeof useRemoveUserFromGroupMutation
>;
export type RemoveUserFromGroupMutationResult = Apollo.MutationResult<RemoveUserFromGroupMutation>;
export type RemoveUserFromGroupMutationOptions = Apollo.BaseMutationOptions<
  RemoveUserFromGroupMutation,
  RemoveUserFromGroupMutationVariables
>;
export const UpsertUserGroupDocument = gql`
  mutation UpsertUserGroup(
    $accountId: ID!
    $userGroupId: ID!
    $name: String!
    $parameters: JSON
    $permissions: [UserRolePermission!]
  ) {
    upsertUserGroup(
      accountId: $accountId
      userGroupId: $userGroupId
      name: $name
      parameters: $parameters
      permissions: $permissions
    ) {
      userGroupId
      name
      parameters
      permissions
      members {
        userId
        email
      }
      createdAt
      updatedAt
    }
  }
`;
export type UpsertUserGroupMutationFn = Apollo.MutationFunction<
  UpsertUserGroupMutation,
  UpsertUserGroupMutationVariables
>;

/**
 * __useUpsertUserGroupMutation__
 *
 * To run a mutation, you first call `useUpsertUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserGroupMutation, { data, loading, error }] = useUpsertUserGroupMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userGroupId: // value for 'userGroupId'
 *      name: // value for 'name'
 *      parameters: // value for 'parameters'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useUpsertUserGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertUserGroupMutation,
    UpsertUserGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertUserGroupMutation, UpsertUserGroupMutationVariables>(
    UpsertUserGroupDocument,
    options,
  );
}
export type UpsertUserGroupMutationHookResult = ReturnType<typeof useUpsertUserGroupMutation>;
export type UpsertUserGroupMutationResult = Apollo.MutationResult<UpsertUserGroupMutation>;
export type UpsertUserGroupMutationOptions = Apollo.BaseMutationOptions<
  UpsertUserGroupMutation,
  UpsertUserGroupMutationVariables
>;
export const AddUserToAccountDocument = gql`
  mutation AddUserToAccount($accountId: ID!, $email: String!, $role: UserRole!) {
    addUserToAccount(accountId: $accountId, email: $email, role: $role) {
      accountUser {
        userId
        email
        role {
          roleId
        }
      }
    }
  }
`;
export type AddUserToAccountMutationFn = Apollo.MutationFunction<
  AddUserToAccountMutation,
  AddUserToAccountMutationVariables
>;

/**
 * __useAddUserToAccountMutation__
 *
 * To run a mutation, you first call `useAddUserToAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToAccountMutation, { data, loading, error }] = useAddUserToAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddUserToAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddUserToAccountMutation,
    AddUserToAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddUserToAccountMutation, AddUserToAccountMutationVariables>(
    AddUserToAccountDocument,
    options,
  );
}
export type AddUserToAccountMutationHookResult = ReturnType<typeof useAddUserToAccountMutation>;
export type AddUserToAccountMutationResult = Apollo.MutationResult<AddUserToAccountMutation>;
export type AddUserToAccountMutationOptions = Apollo.BaseMutationOptions<
  AddUserToAccountMutation,
  AddUserToAccountMutationVariables
>;
export const DeleteUserFromAccountDocument = gql`
  mutation DeleteUserFromAccount($accountId: ID!, $userId: ID!) {
    deleteUserFromAccount(accountId: $accountId, userId: $userId) {
      account {
        accountId
        users {
          userId
          email
          role {
            roleId
          }
          addedAt
        }
      }
      accountUser {
        userId
        email
      }
      success
    }
  }
`;
export type DeleteUserFromAccountMutationFn = Apollo.MutationFunction<
  DeleteUserFromAccountMutation,
  DeleteUserFromAccountMutationVariables
>;

/**
 * __useDeleteUserFromAccountMutation__
 *
 * To run a mutation, you first call `useDeleteUserFromAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserFromAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserFromAccountMutation, { data, loading, error }] = useDeleteUserFromAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserFromAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserFromAccountMutation,
    DeleteUserFromAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserFromAccountMutation, DeleteUserFromAccountMutationVariables>(
    DeleteUserFromAccountDocument,
    options,
  );
}
export type DeleteUserFromAccountMutationHookResult = ReturnType<
  typeof useDeleteUserFromAccountMutation
>;
export type DeleteUserFromAccountMutationResult =
  Apollo.MutationResult<DeleteUserFromAccountMutation>;
export type DeleteUserFromAccountMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserFromAccountMutation,
  DeleteUserFromAccountMutationVariables
>;
export const UpdateUserInAccountDocument = gql`
  mutation UpdateUserInAccount($accountId: ID!, $userId: ID!, $role: UserRole!) {
    updateUserInAccount(accountId: $accountId, userId: $userId, role: $role) {
      accountUser {
        userId
        email
      }
    }
  }
`;
export type UpdateUserInAccountMutationFn = Apollo.MutationFunction<
  UpdateUserInAccountMutation,
  UpdateUserInAccountMutationVariables
>;

/**
 * __useUpdateUserInAccountMutation__
 *
 * To run a mutation, you first call `useUpdateUserInAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInAccountMutation, { data, loading, error }] = useUpdateUserInAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserInAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserInAccountMutation,
    UpdateUserInAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserInAccountMutation, UpdateUserInAccountMutationVariables>(
    UpdateUserInAccountDocument,
    options,
  );
}
export type UpdateUserInAccountMutationHookResult = ReturnType<
  typeof useUpdateUserInAccountMutation
>;
export type UpdateUserInAccountMutationResult = Apollo.MutationResult<UpdateUserInAccountMutation>;
export type UpdateUserInAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserInAccountMutation,
  UpdateUserInAccountMutationVariables
>;
export const WorkspaceDocument = gql`
  query Workspace {
    me {
      userId
      email
    }
    accounts {
      accountId
      slug
      name
      timezone
      isOnboarded
      features
      pinnedExplorationIds
      integrations {
        integrationId
        service
        name
        description
        createdAt
        oauthClientId
        authStatus
      }
      connections {
        connectionId
        type
        name
      }
      me {
        pinnedExplorationIds
        permissions {
          permissionId
        }
      }
    }
  }
`;

/**
 * __useWorkspaceQuery__
 *
 * To run a query within a React component, call `useWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceQuery(
  baseOptions?: Apollo.QueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
}
export function useWorkspaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
}
export function useWorkspaceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<WorkspaceQuery, WorkspaceQueryVariables>(
    WorkspaceDocument,
    options,
  );
}
export type WorkspaceQueryHookResult = ReturnType<typeof useWorkspaceQuery>;
export type WorkspaceLazyQueryHookResult = ReturnType<typeof useWorkspaceLazyQuery>;
export type WorkspaceSuspenseQueryHookResult = ReturnType<typeof useWorkspaceSuspenseQuery>;
export type WorkspaceQueryResult = Apollo.QueryResult<WorkspaceQuery, WorkspaceQueryVariables>;
